import Vue from 'vue';
import { applyDomTranslation, initDomTranslator } from './domTranslator';

export const messages = {
  "en": {
    "nav": {
      "platformOverview": "Platform Overview",
      "tenantManagement": "Tenant Management",
      "billingAndFinance": "Billing & Subscriptions",
      "systemAndSecurity": "User Directory",
      "companyWorkspace": "Company Workspace",
      "dashboard": "Platform Dashboard",
      "clientCompanies": "Client Companies",
      "createCompany": "Onboard Company",
      "subscriptionPackages": "Subscription Plans",
      "billingApprovals": "Invoice Approvals",
      "playerQuota": "Seat Quota Allocation",
      "paymentChannels": "Payment Gateways",
      "discountVouchers": "Discount Vouchers",
      "globalUsers": "Platform Users",
      "systemAuditLogs": "System Audit Logs",
      "gameRealms": "Virtual Realms Market",
      "ownerAnalytics": "Executive Analytics",
      "makerStudio": "Maker Studio",
      "gameSettings": "Game Settings Hub",
      "squads": "Division & Squad",
      "rules": "Quests & KPI",
      "quests": "Quests & KPI",
      "consequences": "SOP Consequence",
      "compensations": "Recovery Task",
      "approvals": "Approvals Center",
      "questApprovals": "Quests & KPI Submissions",
      "consequenceApprovals": "SOP Consequence",
      "punishmentApprovals": "Penalty Report",
      "compensationApprovals": "Recovery Task",
      "rewardShop": "Reward Shop",
      "gamePlayer": "Company Players",
      "gameMaker": "Game Maker (Manager)",
      "inboundLeads": "Inbound Leads",
      "gameBenchmarks": "Game Benchmarks",
      "creatorEcosystem": "Creator Ecosystem",
      "superadminSection": "Platform Management",
      "ownerSection": "Enterprise Management",
      "makerSection": "Operational Studio",
      "companyPersonnel": "Company Personnel",
      "glossary": "Knowledge Hub & Glossary",
      "profileSettings": "Profile Settings",
      "companyBilling": "Company Billing",
      "logOut": "Log Out",
      "platformOperator": "Platform Operator",
      "enterpriseMember": "Enterprise Member",
      "defaultUserName": "Workspace User",
      "openMenu": "Open navigation menu",
      "realmGuildMaster": "Operations Studio",
      "realmRoyalCommand": "Executive Command",
      "realmSovereign": "Platform Administration",
      "roleMaker": "Game Maker",
      "roleOwner": "Workspace Owner",
      "toggleSidebar": "Toggle sidebar navigation"
    },
    "leads": {
      "title": "Inbound Leads & Client Registrations",
      "subtitle": "Review demo requests and trial applications from the public landing page, qualify leads, and convert them to live workspaces.",
      "totalInbound": "Total Inbound Leads",
      "fromPublicLanding": "Submitted via landing page forms",
      "newLeads": "New Uncontacted",
      "qualified": "Qualified Pipeline",
      "converted": "Converted Enterprises",
      "statusNew": "New Leads",
      "statusContacted": "Contacted",
      "statusQualified": "Qualified",
      "statusConverted": "Converted",
      "statusRejected": "Rejected",
      "searchPlaceholder": "Search company, name, email...",
      "company": "Client Company",
      "contactPerson": "Contact Person",
      "channels": "Direct Channels",
      "convertBtn": "Convert to Client",
      "deleteConfirm": "Are you sure you want to delete this lead?",
      "modalTitle": "Lead Details & Conversion",
      "notesPlaceholder": "Add internal sales or follow-up notes...",
      "emptyTitle": "No Inbound Leads Found",
      "emptyDesc": "New demo requests and trial applications from prospective clients will appear here.",
      "detailTitle": "Inbound Registration Detail",
      "workEmail": "Work Email",
      "whatsappPhone": "WhatsApp Phone",
      "teamSize": "Team Size",
      "inquiryMessage": "Inquiry Message & Goals",
      "noMessage": "No specific note submitted.",
      "openWhatsApp": "Open WhatsApp Consultation",
      "closeModal": "Close",
      "confirmConvertTitle": "Convert to Client Enterprise?",
      "confirmConvertText": "Are you sure you want to convert \"{company}\" into an official Client Enterprise on Gamiteam? This will provision a dedicated company workspace and owner account.",
      "convertSuccessTitle": "Lead Converted Successfully!",
      "convertSuccessText": "Company \"{company}\" has been created with Game Owner email: {email}.",
      "viewCompanyBtn": "View Company Details",
      "markNew": "Mark as New",
      "markContacted": "Mark as Contacted",
      "markQualified": "Mark as Qualified",
      "markRejected": "Mark as Rejected",
      "awaitingContact": "Awaiting Contact",
      "slaHours": "SLA < 24h",
      "readyConversion": "Ready for client conversion",
      "activeEnterprises": "Active Client Enterprises"
    },
    "benchmarks": {
      "title": "Game Setting Benchmarks & Telemetry",
      "subtitle": "Platform-wide telemetry comparing quest completion, SOP adherence, division heatmaps, and official master blueprints.",
      "createTemplateBtn": "+ Create Master Blueprint",
      "topFramework": "Top Framework",
      "topFrameworkSub": "engagement rate benchmark",
      "optimalCycle": "Optimal Quest Cycle",
      "optimalCycleSub": "Highest completion window across tenants",
      "avgCompletion": "Cross-Tenant Avg Completion",
      "aboveIndustryAverage": "Above industry average (87%)",
      "goldPool": "Circulating Platform Gold",
      "goldPoolSub": "Active in-game enterprise economy",
      "divisionTitle": "Division Effectiveness Comparison Heatmap",
      "divisionSubtitle": "Relative completion and discipline rates across functional enterprise departments.",
      "completionRate": "Quest Completion SLA",
      "sopAdherence": "SOP & Discipline Adherence",
      "topRulesTitle": "Top-Performing Rules Ranking",
      "topRulesSub": "Highest adoption and completion impact across client enterprises.",
      "ruleName": "Gamification Rule",
      "rewards": "XP & Gold Rewards",
      "impact": "Completion SLA",
      "blueprintsTitle": "Official Master Blueprint Library",
      "blueprintsSub": "Curated gamification templates that client companies can adopt with one click.",
      "previewJson": "Preview JSON",
      "noTemplatesFound": "No blueprint templates found for this industry filter.",
      "createTemplateModalTitle": "Create Official Master Blueprint",
      "editTemplateModalTitle": "Edit Master Blueprint",
      "templateTitle": "Blueprint Title",
      "industry": "Industry",
      "blueprintJson": "Blueprint Specification (JSON)",
      "activeQuestsLabel": "Active Quests",
      "adoptionsLabel": "Adoptions",
      "allIndustries": "All Industries",
      "approvedSubmissionsSub": "Approved quest submissions",
      "avgEngagementLabel": "Avg. Engagement Rate",
      "badgeFeatured": "Featured",
      "badgeOfficial": "Official",
      "benchmarkSlaLabel": "Target Benchmark",
      "crossTenantNormalized": "Normalized across active workspaces",
      "deleteBlueprintTitle": "Delete Blueprint",
      "deleteTemplateConfirmMsg": "This master blueprint will be permanently removed from the benchmark catalog.",
      "deleteTemplateErrorMsg": "Failed to delete blueprint template.",
      "deleteTemplateSuccessMsg": "Master blueprint deleted successfully.",
      "editBlueprintTitle": "Edit Master Blueprint",
      "engagementScoreLabel": "Engagement Rate",
      "featuredMarketplaceCheck": "Feature prominently in Marketplace Catalog",
      "indFintech": "Fintech & Banking",
      "indHealthcare": "Healthcare & Hospitality",
      "indOps": "Retail & Field Operations",
      "indSales": "B2B Sales & Revenue",
      "indTech": "Software Engineering & DevOps",
      "invalidJsonMsg": "Rules JSON configuration is invalid. Please provide a valid JSON array or object.",
      "masterBlueprintSpec": "Master Blueprint Specification",
      "noDataYet": "No Data Yet",
      "officialTemplateCheck": "Mark as Official Gamiteam Blueprint",
      "rulesCountLabel": "Configured Quests",
      "rulesCountSuffix": "quests",
      "saveTemplateErrorMsg": "Failed to save blueprint template.",
      "saveTemplateSuccessMsg": "Blueprint template saved successfully.",
      "searchBlueprint": "Search blueprint title, category, or industry...",
      "templateDescPlaceholder": "Describe KPI objectives, target teams, and operational cadence...",
      "templateTitlePlaceholder": "e.g. Enterprise B2B Revenue Acceleration"
    },
    "creators": {
      "title": "Creator Ecosystem & Revenue Share",
      "subtitle": "Manage community game designers, partner applications, platform revenue commission splits (70/30), and payout approvals.",
      "tabLeaderboard": "Creator Hall of Fame",
      "tabApplications": "Partner Applications",
      "tabRevenueShare": "Revenue Share Setup",
      "tabPayouts": "Payout Approvals Queue",
      "totalVerifiedCreators": "Verified Creators",
      "totalBlueprintsInstalled": "Blueprints Installed",
      "totalCreatorEarnings": "Creator Payouts Distributed",
      "platformCommissionCut": "Gamiteam HQ Margin",
      "hallOfFameTitle": "Top Creator Hall of Fame",
      "hallOfFameSub": "Ranked by client adoption volume, template ratings, and verified status.",
      "creatorName": "Creator Partner",
      "specialization": "Specialization",
      "rating": "Rating & Reviews",
      "adoptions": "Adoptions",
      "earnings": "Cumulative Earnings",
      "applicationsTitle": "Creator Partner Inbound Applications",
      "applicationsSub": "Game designers and HR consultants applying from public landing page.",
      "applicant": "Applicant",
      "portfolio": "Portfolio Link",
      "proposalConcept": "Gamification Concept",
      "noApplicationsFound": "No creator applications found.",
      "commissionSetupTitle": "Global Revenue Commission Configuration",
      "commissionSetupSub": "Define standard revenue sharing ratio between community creators and Gamiteam Platform HQ.",
      "creatorPercentLabel": "Creator Share (%)",
      "platformPercentLabel": "Gamiteam Platform HQ Share (%)",
      "minPayoutLabel": "Minimum Payout Threshold",
      "payoutScheduleLabel": "Payout Processing Schedule",
      "saveConfigBtn": "Save Revenue Configuration",
      "simCalculatorTitle": "Interactive Revenue Split Simulator",
      "simCalculatorSub": "Calculate revenue distribution between Creator and Gamiteam HQ in real-time.",
      "payoutQueueTitle": "Creator Payout Withdrawal Queue",
      "payoutQueueSub": "Approve and process withdrawal transfers to creator bank accounts.",
      "grossAmount": "Gross Amount",
      "netPayout": "Net Payout",
      "bankDetails": "Bank Account Details",
      "simPriceLabel": "Simulated Template Price",
      "simVolumeLabel": "Sales & Adoptions Volume",
      "simTotalRevenue": "Simulated Gross Volume",
      "simCreatorTakes": "Creator Earnings Cut",
      "simPlatformTakes": "Platform Net Margin",
      "approveApplication": "Approve Creator",
      "rejectApplication": "Reject Creator",
      "reviewNotes": "Reviewer Notes",
      "reviewModalTitle": "Review Creator Partner Application",
      "confirmApproveCreator": "Confirm verification and certify creator partner?",
      "adoptedByEnterprises": "Adopted across active workspaces",
      "approveAndPay": "Verify & Settle Payout",
      "approveSuccessMsg": "Creator application approved and certified.",
      "autoCalculatedHint": "Automatically balanced to 100% total share",
      "bankTransferRefLabel": "Bank Transfer Reference Number",
      "certifiedCreators": "Certified Creators",
      "commissionPaidLabel": "Total Creator Royalties Paid",
      "confirmPayoutText": "Confirm transfer of {amount} to {name} ({bank} - {account}).",
      "defaultApproveNotes": "Portfolio and KPI blueprint verified against platform quality standards.",
      "defaultRejectNotes": "Blueprint submission requires clearer measurable KPI verification criteria.",
      "distributedToPartners": "Settled creator royalty payouts",
      "hqMargin": "Platform Share",
      "minPayoutHint": "Minimum settlement threshold in Rupiah",
      "noNotes": "No reviewer notes recorded",
      "noPayoutsFound": "No payout requests match the current filter.",
      "payoutErrorMsg": "Failed to process royalty payout settlement.",
      "payoutFeeNotice": "Ensure bank transfer settlement is completed before recording reference.",
      "payoutSuccessMsg": "Royalty payout marked as settled and logged to audit trail.",
      "rank": "Rank",
      "refPrefix": "Ref:",
      "rejectSuccessMsg": "Creator application rejected with review feedback.",
      "revenueSaveErrorMsg": "Failed to save revenue split policy.",
      "revenueSaveSuccessMsg": "Revenue split policy updated across creator marketplace.",
      "reviewErrorMsg": "Failed to submit application review.",
      "reviewNotesPlaceholder": "Provide objective review notes for the applicant...",
      "reviewedPrefix": "Reviewed:",
      "reviewsLabel": "reviews",
      "scheduleBiweekly": "Bi-Weekly (1st & 15th)",
      "scheduleMonthly": "Monthly (25th Cutoff)",
      "scheduleWeekly": "Weekly (Every Friday)",
      "searchApplicant": "Search applicant name, email, or specialty...",
      "searchPayout": "Search creator name, bank, or reference...",
      "statusProcessed": "Settled",
      "tierCreator": "{tier} Creator",
      "transferNet": "Net Royalty",
      "unrated": "Unrated",
      "verifiedPartnerTitle": "Verified Blueprint Partner",
      "workspacesLabel": "workspaces"
    },
    "audit": {
      "title": "System & Security Audit Logs",
      "subtitle": "Immutable activity log of tenant onboarding, invoice approvals, seat quota adjustments, and platform admin events.",
      "exportCsv": "Export CSV",
      "totalEvents": "Total Events",
      "billingEvents": "Billing Events",
      "tenantEvents": "Tenant Events",
      "securityLogins": "Security Logins",
      "searchPlaceholder": "Search event, actor, tenant, IP...",
      "allCategories": "All Categories",
      "catTenant": "Tenant & Partner",
      "catBilling": "SaaS Billing",
      "catSecurity": "Access & Auth",
      "catSystem": "System Config",
      "allSeverities": "All Severities",
      "colTimestamp": "Timestamp",
      "colEvent": "Event & Activity",
      "colTarget": "Target Entity",
      "colActor": "Actor",
      "colIp": "IP Address",
      "colSeverity": "Severity",
      "emptyTitle": "No Audit Logs Found",
      "emptyDesc": "No platform activity records matching the specified criteria.",
      "sevDanger": "Critical",
      "sevInfo": "Info",
      "sevSuccess": "Verified",
      "sevWarning": "Warning"
    },
    "superadmin": {
      "title": "Gamiteam Platform Operations",
      "subtitle": "SaaS Master Control: Multi-tenant client companies, recurring revenue, subscriptions, and system telemetry.",
      "mrr": "Monthly Recurring Revenue (MRR)",
      "totalRevenue": "Total Platform Revenue",
      "activeTenants": "Active Enterprise Clients",
      "totalGlobalUsers": "Global Platform Users",
      "totalGlobalPlayers": "Active Employees (Players)",
      "totalGlobalMakers": "Team Managers (Makers)",
      "pendingInvoices": "Pending Payment Approvals",
      "platformHealth": "Platform Service Health",
      "allCompanies": "All Client Enterprises",
      "searchCompanies": "Search company name, owner, or email...",
      "companyName": "Client Company",
      "ownerContact": "Game Owner (Contact)",
      "currentPlan": "Active Plan",
      "playerQuota": "Player Quota",
      "subscriptionStatus": "Status",
      "healthStatus": "Health Status",
      "actions": "Actions",
      "pendingBillingTitle": "Manual Invoices Awaiting Verification",
      "pendingBillingDesc": "Client subscription payments submitted via bank transfer requiring manual confirmation.",
      "approvePayment": "Verify & Activate",
      "rejectPayment": "Reject Invoice",
      "invoiceNumber": "Invoice #",
      "package": "Package",
      "amount": "Amount",
      "date": "Date",
      "paymentMethod": "Payment Method",
      "noPendingInvoices": "No pending payments waiting for approval.",
      "revenueTrendTitle": "12-Month Revenue Performance",
      "quickStats": "Platform Key Performance Indicators",
      "globalCompletionRate": "Global Quest Completion Rate",
      "totalGoldInCirculation": "Total Gold Circulating",
      "onboardClientBtn": "+ Onboard Client Enterprise",
      "planStarter": "Starter",
      "planGrowth": "Growth",
      "planEnterprise": "Enterprise",
      "statusActive": "Active",
      "statusExpiring": "Expiring Soon",
      "statusExpired": "Expired",
      "statusTrial": "Free Trial",
      "companyDetails": "Client Enterprise Details",
      "companyTelemetry": "Enterprise Telemetry & Health",
      "companyInfo": "Company Profile",
      "joinDate": "Onboarding Date",
      "registeredEmail": "Enterprise Admin Email",
      "ownerName": "Owner Name",
      "phoneNumber": "Contact Phone",
      "playerQuotaUsage": "Player Quota Allocation",
      "activeUsers7d": "Active Users (Last 7 Days)",
      "activityRatio": "Engagement Rate",
      "totalRulesConfigured": "Gamification Rules Set",
      "questSubmissionsCount": "Total Quest Submissions",
      "completionSuccessRate": "Mission Completion Rate",
      "daysUntilExpiry": "Days Until Plan Expiry",
      "editCompany": "Edit Enterprise Info",
      "deleteCompany": "Offboard Client Enterprise",
      "confirmDeleteCompany": "Are you sure you want to offboard this client company? All associated workspace data will be archived.",
      "onboardNewCompany": "Onboard New Client Enterprise",
      "onboardSubtitle": "Register a new enterprise client, allocate initial player quotas, and provision their dedicated workspace.",
      "companyLogo": "Company Brand Logo",
      "selectSubscriptionPlan": "Select Subscription Plan",
      "initialPaymentStatus": "Initial Payment Status",
      "initialPaymentPaid": "Paid & Activated Immediately",
      "initialPaymentUnpaid": "Pending Payment (Manual Transfer)",
      "packagesTitle": "SaaS Subscription Plans",
      "packagesSubtitle": "Define tier quotas, per-seat pricing, and feature allowances for client companies.",
      "createPackage": "Create Subscription Plan",
      "editPackage": "Edit Subscription Plan",
      "packageName": "Plan Name",
      "pricePerSeatMonth": "Price per Seat per Month",
      "maxUserSeats": "Max User Seats (Quota)",
      "packageDescription": "Plan Description & Included Perks",
      "confirmDeletePackage": "Are you sure you want to delete this subscription plan?",
      "discountsTitle": "Discount & Promo Vouchers",
      "discountsSubtitle": "Manage marketing promotion codes, percentage discounts, and fixed credits for client billing.",
      "createDiscount": "Create Promo Code",
      "editDiscount": "Edit Promo Code",
      "discountCode": "Promo Code",
      "discountType": "Discount Type",
      "discountValue": "Discount Value",
      "percentage": "Percentage (%)",
      "flatAmount": "Fixed IDR (Rp)",
      "usageLimit": "Total Redemption Limit",
      "expiryDate": "Expiry Date",
      "confirmDeleteDiscount": "Are you sure you want to delete this discount voucher?",
      "platformPlayersTitle": "Platform Employee Directory (Players)",
      "platformPlayersSubtitle": "Unified global directory of all employees across client companies participating in gamified quests.",
      "platformMakersTitle": "Platform Manager Directory (Makers)",
      "platformMakersSubtitle": "Unified global directory of all supervisors and operational makers designing quests across client companies.",
      "assignedCompany": "Assigned Company (Tenant)",
      "squadDivision": "Division & Squad",
      "userLevel": "Level",
      "userXp": "XP Points",
      "goldBalance": "Gold Coins",
      "gamiteamHq": "GAMITEAM HQ • PLATFORM OPERATOR",
      "allSystemsNominal": "All Systems Nominal",
      "allTimeBillingVolume": "All-time platform billing volume",
      "viewAllEnterprises": "View all enterprises →",
      "tenants": "Tenants",
      "activeEconomy": "Active Economy",
      "acrossAllTenants": "Across All Tenants",
      "liveRules": "Live Rules",
      "platformRules": "Platform Gamification Rules",
      "monthlyBilledVolume": "Monthly billed subscription volume across all client organizations",
      "allTime": "Total",
      "viewAllInvoices": "View All Invoices & Billing →",
      "onlineGateway": "Online & Payment Gateway",
      "manualTransfer": "Bank Transfer (Manual)",
      "confirmActivationTitle": "Verify & Activate Subscription?",
      "confirmActivationText": "Are you sure you want to approve invoice #{invoice} for {company}? This will instantly activate the client subscription.",
      "confirmActivationBtn": "Yes, Verify & Activate!",
      "rejectionReasonLabel": "Reason for Rejection *",
      "rejectionReasonPlaceholder": "e.g. Payment proof is blurred, amount does not match, or transaction not found in bank statement.",
      "confirmRejection": "Confirm Rejection",
      "healthy": "Healthy",
      "roleScope": "Role Scope",
      "operationalMaker": "Operational Maker",
      "noPlayersFound": "No Platform Players Found",
      "noPlayersDesc": "No active employee player records matching the filter criteria.",
      "noMakersFound": "No Platform Managers Found",
      "noMakersDesc": "No operational game makers matching the filter criteria.",
      "noDiscountsFound": "No Promo Vouchers Found",
      "noDiscountsDesc": "No discount codes configured yet. Create a promo code for client billing.",
      "createPromoCode": "+ Create Promo Code",
      "paymentChannelsTitle": "Payment Methods & Gateways",
      "paymentChannelsSubtitle": "Configure payment gateway channels, bank transfers, e-wallets, and subscription accounts.",
      "createPaymentMethod": "Add Payment Method",
      "editPaymentMethod": "Edit Payment Method",
      "detailPaymentMethod": "Payment Method Details",
      "paymentMethodName": "Payment Method & Channel Name",
      "channelCode": "Channel Code",
      "baseFee": "Base Fee",
      "channelInfo": "Payment Channel Information",
      "noPaymentsFound": "No Payment Methods Configured",
      "noPaymentsDesc": "Add payment gateway configurations or bank transfer accounts for client billing.",
      "discountDetailTitle": "Promo Voucher Details",
      "discountDetailSubtitle": "Promo voucher specifications, redemption limits, and validity period.",
      "editDiscountBtn": "Edit Voucher",
      "deleteDiscountBtn": "Delete Voucher",
      "confirmDeleteDiscountTitle": "Delete Promo Voucher?",
      "confirmDeleteDiscountText": "Voucher \"{code}\" will be permanently removed.",
      "discountDeletedSuccess": "Promo voucher has been removed.",
      "invoiceVerificationDetail": "Invoice Verification Detail",
      "destinationBank": "Destination Bank",
      "baseAmount": "Base Amount",
      "discountVoucher": "Discount Voucher",
      "totalTransferAmount": "Total Transfer Amount",
      "paymentTransferSlip": "Payment Transfer Slip",
      "noProofUploaded": "No transfer proof uploaded yet",
      "billingPeriod": "Billing Period",
      "duration": "Duration",
      "confirmApproveInvoiceTitle": "Approve & Activate Subscription?",
      "confirmApproveInvoiceText": "Confirm verification for invoice #{invoice}? Subscription will be activated immediately.",
      "approveSuccessText": "Invoice #{invoice} has been approved and subscription activated.",
      "securityAndAllocation": "Security & Workspace Allocation",
      "initialPassword": "Initial Password",
      "subscriptionTerms": "Subscription & Billing Terms",
      "chooseLogoFile": "Choose brand logo file (PNG, JPG, SVG)...",
      "logoRecommendation": "Recommended: Transparent PNG or SVG, max 2MB.",
      "quickTopupSuccess": "Quota updated successfully!",
      "activeMrrLabel": "Active Monthly Recurring Revenue",
      "activeUntilPrefix": "Active until",
      "allCompaniesSub": "Registered client workspaces",
      "approveErrorMsg": "Failed to approve payment transaction.",
      "approveInvoiceError": "Failed to approve billing invoice.",
      "approveSuccessMsg": "Subscription activated for {company}.",
      "approvedLower": "settled",
      "chartRevenueAxis": "Revenue (IDR)",
      "chartRevenueSeries": "Settled SaaS Revenue",
      "clientFallback": "Enterprise Client",
      "createdPrefix": "Created",
      "defaultClientName": "Enterprise Client",
      "healthInactive": "Inactive",
      "healthWarningActivity": "Low Recent Activity",
      "healthWarningSub": "Subscription Expiring Soon",
      "invoiceRejectedMsg": "Invoice rejected and tenant notified.",
      "invoiceRejectedTitle": "Invoice Rejected",
      "invoicesCountLabel": "Invoices",
      "managersLabel": "Makers",
      "monthsLabel": "months",
      "noActivePlan": "No Active Plan",
      "noExpirySet": "No expiry date",
      "ownersLabel": "Owners",
      "playersLabel": "Players",
      "quotaPrefix": "Seat Quota:",
      "rejectErrorMsg": "Failed to reject invoice.",
      "rejectInvoiceError": "Failed to reject billing invoice.",
      "rejectSuccessText": "Billing transaction has been rejected and recorded.",
      "searchInvoicesPlaceholder": "Search invoice number, company, or plan...",
      "standardPlan": "Standard Plan",
      "trialPlan": "Trial Workspace",
      "usersLabel": "users"
    },
    "auth": {
      "loginTitle": "Sign In to Gamiteam",
      "loginSubtitle": "Enterprise Gamification & Employee Motivation Platform",
      "emailLabel": "Work Email Address",
      "emailPlaceholder": "name@company.com",
      "passwordLabel": "Password",
      "passwordPlaceholder": "Enter your password",
      "rememberMe": "Remember this session",
      "forgotPassword": "Forgot Password?",
      "signInBtn": "Sign In",
      "signingIn": "Authenticating...",
      "registerLink": "Don't have an enterprise account? Register here",
      "quickRoleSwitch": "Quick Demo Account Selector",
      "superadmin": "Superadmin (Platform Operator)",
      "gameOwner": "Game Owner (Client Enterprise)",
      "gameMaker": "Game Maker (Team Lead)",
      "gamePlayer": "Game Player (Employee)",
      "resetPasswordTitle": "Reset Your Password",
      "resetPasswordDesc": "Enter your registered email address to receive password reset instructions.",
      "resetPasswordModalTitle": "Reset Your Password",
      "resetPasswordModalDesc": "Enter your registered email address to receive password reset instructions.",
      "registeredEmail": "Registered Email Address",
      "sending": "Sending...",
      "sendResetLink": "Send Reset Link",
      "backToLogin": "Back to Login",
      "chooseCommandClass": "CHOOSE COMMAND CLASS",
      "demoAccess": "DEMO ACCESS",
      "sovereignRole": "Sovereign",
      "sovereignSub": "Superadmin HQ",
      "ownerRole": "Lord Owner",
      "ownerSub": "CEO & Analytics",
      "makerRole": "Guild Master",
      "makerSub": "Quest Studio",
      "playerLink": "Knight Player App",
      "citadelGuard": "KNIGHTHOOD SANCTUM GUARD • MULTI-TENANT CITADEL",
      "citadelEdition": "GAMITEAM • KNIGHTHOOD ROYAL CITADEL EDITION",
      "enterCitadel": "ENTER COMMAND CITADEL",
      "openingCitadelGates": "OPENING CITADEL GATES...",
      "signInFailed": "Sign In Failed",
      "checkInbox": "Check Your Inbox",
      "requestFailed": "Request Failed",
      "accessDenied": "Access Denied",
      "accessDeniedMsg": "You do not have permission to access the Admin Portal.",
      "playerBlockedMsg": "Players must use the Player App. Access to Admin Portal is restricted.",
      "loggedOut": "Logged Out",
      "loggedOutDesc": "You have been logged out successfully.",
      "copyright": "Copyright © 2026 Gamiteam. All rights reserved."
    },
    "workspace": {
      "title": "Enterprise Gamification Command Center",
      "subtitle": "Real-time team engagement, squad rankings, and performance reward economy.",
      "engagementIndex": "Team Engagement Score",
      "activeStreaks": "Active Streaks",
      "goldPool": "Circulating Gold Pool",
      "kudosSent": "Peer Recognitions Sent",
      "squadClash": "Squad & Division Leaderboard",
      "squadClashDesc": "Performance ranking by completed quests and gold points",
      "hallOfFame": "Top MVP Champions",
      "hallOfFameDesc": "Leading team players by level, consistency, and points",
      "liveActivity": "Live Activity & Recognition Stream",
      "recentQuests": "Recent Quest Completions",
      "recentKudos": "Peer Kudos & Recognition",
      "noRecentQuests": "No quest completions recorded today.",
      "noQuestActivity": "No quest completions recorded yet.",
      "noRecentKudos": "No peer kudos sent today.",
      "companyInvoices": "Company Subscription Invoices",
      "createQuestBtn": "+ Create Quest",
      "reviewSubmissionsBtn": "Review Submissions",
      "rewardShopBtn": "Reward Shop",
      "quotaUsed": "Seats Allocated",
      "companyActiveStatus": "Workspace Active",
      "quickOwnerAnalytics": "Owner Macro Analytics",
      "quickOwnerDesc": "ROI radar, gold liquidity, department heatmaps, and company boss raid.",
      "quickMakerStudio": "Maker Studio & Verification",
      "quickMakerDesc": "Quest submissions audit, fast quest builder, and team interventions.",
      "quickRealmsMarket": "Workspaces & SOP Templates",
      "quickRealmsDesc": "Interactive workplace simulations and team collaboration templates.",
      "openSuite": "Open Suite →",
      "openStudio": "Open Studio →",
      "openMarket": "Open Marketplace →",
      "monthlySubscriptionStatistic": "Monthly Subscription Statistic",
      "latest12Months": "Latest 12 Months",
      "payDate": "Payment Date",
      "billingPeriod": "Billing Period",
      "totalAmount": "Total Amount",
      "downloadInvoice": "Invoice PDF",
      "numberOfPlayers": "Number of Players",
      "newRegistration": "New Registration",
      "renewal": "Renewal",
      "viewAll": "View All",
      "members": "Members",
      "pts": "pts",
      "days": "Days",
      "seasonActive": "Season Active",
      "refreshData": "Refresh Telemetry",
      "filterThisMonth": "This Month",
      "filterAllTime": "All Time",
      "streakSubtext": "Consistent check-ins & completed tasks",
      "goldPoolSubtext": "Circulating in workspace this month",
      "kudosSubtext": "Peer recognition between colleagues",
      "level": "Level",
      "rank": "Rank",
      "squadDivision": "Division & Squad",
      "totalGoldPts": "Total Gold",
      "questProgress": "Quest Progress",
      "ratingVeryActive": "Highly Active",
      "ratingActive": "Active",
      "ratingGettingStarted": "Getting Started",
      "activeQuestsCardSub": "Published daily & sprint KPI missions",
      "activeQuestsCardTitle": "Active Workspace Quests",
      "approvedQuestsSeries": "Approved Quests",
      "badgeWorkspaces": "Enterprise Workspace Overview",
      "chartActivityAxis": "Completed Actions",
      "makersCardSub": "Team leads & quest reviewers",
      "monthlyActivityStatistic": "Monthly Operational Activity Trend",
      "newMembersSeries": "Onboarded Members",
      "playersCardSub": "Active participating employees",
      "staffSuffix": "members"
    },
    "quests": {
      "title": "Quests & KPI",
      "subtitle": "Define employee goals, work standards, and gamified performance rewards.",
      "createNewQuest": "+ Create New Quest",
      "searchPlaceholder": "Search quest name, target, or category...",
      "questName": "Quest Name",
      "reward": "Reward (Gold & Perks)",
      "description": "Target Objective",
      "frequency": "Cycle",
      "division": "Division & Squad",
      "actions": "Actions",
      "viewDetails": "View Details",
      "editQuest": "Edit Quest",
      "deleteQuest": "Delete Quest",
      "confirmDelete": "Are you sure you want to remove this quest rule?",
      "emptyTitle": "No Quest Rules Configured",
      "emptyDesc": "Create target missions and SOP objectives to motivate employees.",
      "consequencesTitle": "SOP Consequence",
      "consequencesSubtitle": "Transparent consequence points for missed deadlines or policy violations.",
      "createConsequence": "+ Create SOP Consequence",
      "compensationsTitle": "Recovery Task",
      "compensationsSubtitle": "Recovery tasks allowing employees to offset penalty points.",
      "createCompensation": "+ Create Recovery Task",
      "pointsDeduction": "Gold Deduction",
      "offsetAmount": "Offset Value",
      "violationRule": "SOP Consequence",
      "compensationTask": "Recovery Task",
      "emptyCompTitle": "No Recovery Tasks Configured",
      "emptyCompDesc": "No recovery tasks set for this workspace.",
      "emptyConsequenceTitle": "No SOP Consequences Configured",
      "emptyConsequenceDesc": "No SOP consequence rules defined yet.",
      "statusActive": "Active",
      "statusDraftPaused": "Draft or Paused",
      "cloneSuccess": "Quest Cloned Successfully!",
      "cloneSuccessDesc": "A copy of \"{name}\" has been created and is active.",
      "cloneFailed": "Failed to Clone Quest",
      "statusUpdated": "Status Updated",
      "statusUpdatedDesc": "Quest \"{name}\" is now {status}.",
      "statusUpdateFailed": "Failed to Update Status",
      "deleteConfirmText": "This quest will be permanently removed from the list.",
      "deleted": "Deleted",
      "deletedDesc": "Quest has been successfully deleted.",
      "deleteFailed": "Failed to delete quest",
      "deleteBtn": "Delete Quest",
      "weekDayRequired": "Please select a day for weekly repeat",
      "deleteQuestConfirmTitle": "Delete Quest?",
      "deleteQuestConfirmText": "Are you sure you want to delete this quest?"
    },
    "approvals": {
      "title": "Quests & KPI Submissions & Verification",
      "subtitle": "Audit proof of work, approve reward distribution, or reject invalid quest submissions.",
      "searchPlaceholder": "Search employee name or quest title...",
      "employee": "Employee",
      "questRule": "Quests & KPI",
      "submittedAt": "Submitted At",
      "verificationStatus": "Verification Status",
      "reviewSubmission": "Review Submission",
      "reviewRewardClaim": "Review Quests & KPI Submission",
      "backToReward": "Back to Quests & KPI Approvals",
      "emptyTitle": "No Submissions Awaiting Approval",
      "emptyDesc": "All player quest submissions have been processed or no pending submissions exist.",
      "filterStatus": "Filter by Status",
      "consequenceTitle": "SOP Consequence",
      "consequenceSubtitle": "Verify reported policy violations and audit penalty deductions.",
      "emptyConsequenceTitle": "No SOP Consequence Queue",
      "emptyConsequenceDesc": "All reported SOP violations have been processed or no new reports submitted.",
      "reviewConsequence": "Review Violation",
      "compensationTitle": "Recovery Task",
      "compensationSubtitle": "Review recovery task submissions to restore deducted player Gold.",
      "emptyCompensationTitle": "No Recovery Task Queue",
      "emptyCompensationDesc": "All recovery task submissions have been reviewed.",
      "reviewCompensation": "Review Task",
      "punishmentTitle": "Penalty Report",
      "punishmentSubtitle": "Audit ad-hoc disciplinary incidents reported across client workspaces.",
      "emptyPunishmentTitle": "No Penalty Report Queue",
      "emptyPunishmentDesc": "All reported disciplinary incidents have been audited.",
      "reviewPunishment": "Review Incident",
      "incidentDescription": "Incident & Infraction",
      "pendingReview": "Awaiting Review",
      "approved": "Approved",
      "rejected": "Rejected",
      "totalGoldDistributed": "Total Gold Distributed",
      "pendingVerification": "Awaiting Verification",
      "verifiedApplied": "Verified (Applied)",
      "cancelledDismissed": "Dismissed",
      "totalViolations": "Total Violations",
      "totalCompensations": "Total Recovery Tasks",
      "totalIncidents": "Total Penalty Reports",
      "cases": "Cases",
      "tasks": "Tasks"
    },
    "approval": {
      "reviewRewardClaim": "Review Quests & KPI Submission",
      "backToReward": "Back to Quests & KPI Approvals",
      "consequenceTitle": "SOP Consequence",
      "compensationTitle": "Recovery Task",
      "punishmentTitle": "Penalty Report"
    },
    "squads": {
      "title": "Division & Squad",
      "subtitle": "Organize teams, departments, and cross-functional squads for leaderboard competition.",
      "createSquad": "+ Create New Squad",
      "searchPlaceholder": "Search squad or division name...",
      "squadName": "Division & Squad Name",
      "membersCount": "Members",
      "totalGold": "Total Gold Earned",
      "performanceIndex": "Performance Progress",
      "emptyTitle": "No Squads or Divisions Configured",
      "emptyDesc": "Create functional squads or department divisions to start team gamification.",
      "confirmDelete": "Are you sure you want to delete this squad?",
      "createTitle": "Create New Division & Squad",
      "createSubtitle": "Add a new division or squad to group team quests and player KPIs",
      "editTitle": "Edit Division & Squad",
      "editSubtitle": "Update division information and squad name",
      "detailsTitle": "Division & Squad Details",
      "detailsSubtitle": "Division details and team target configuration",
      "name": "Division & Squad Name",
      "description": "Division & Squad Description",
      "members": "Squad Members",
      "noDescription": "No description provided for this squad.",
      "savedSuccess": "Squad saved successfully.",
      "updatedSuccess": "Squad updated successfully.",
      "deletedSuccess": "Squad has been deleted.",
      "progressLabel": "Progress"
    },
    "squad": {
      "title": "Division & Squad",
      "subtitle": "Organize teams, departments, and cross-functional squads for leaderboard competition.",
      "createSquad": "+ Create New Squad",
      "searchPlaceholder": "Search squad or division name...",
      "squadName": "Division & Squad Name",
      "membersCount": "Members",
      "totalGold": "Total Gold Earned",
      "performanceIndex": "Performance Progress",
      "emptyTitle": "No Squads or Divisions Configured",
      "emptyDesc": "Create functional squads or department divisions to start team gamification.",
      "confirmDelete": "Are you sure you want to delete this squad?",
      "createTitle": "Create New Division & Squad",
      "createSubtitle": "Add a new division or squad to group team quests and player KPIs",
      "editTitle": "Edit Division & Squad",
      "editSubtitle": "Update division information and squad name",
      "detailsTitle": "Division & Squad Details",
      "detailsSubtitle": "Division details and team target configuration",
      "name": "Division & Squad Name",
      "description": "Division & Squad Description",
      "members": "Squad Members",
      "noDescription": "No description provided for this squad.",
      "savedSuccess": "Squad saved successfully.",
      "updatedSuccess": "Squad updated successfully.",
      "deletedSuccess": "Squad has been deleted."
    },
    "player": {
      "title": "Company Employees & Players",
      "subtitle": "Manage participating employee accounts, squad assignments, and game roles.",
      "insertNew": "+ Register New Player",
      "addToMaker": "Promote to Maker",
      "alreadyInMaker": "Maker & Player",
      "squad": "Division & Squad",
      "noPlayersFound": "No Players Found",
      "noPlayersDesc": "No employees have been registered yet in your organization.",
      "confirmPromoteTitle": "Promote to Game Maker?",
      "confirmPromoteText": "This user will be granted managerial permissions to create quests and verify team submissions.",
      "confirmPromoteBtn": "Yes, Promote to Maker",
      "quotaUsage": "Seat Quota Capacity",
      "quotaSubtitle": "Monitor registered players vs total company seat quota pool.",
      "totalSeats": "Total Seats",
      "seatsUsed": "Seats In Use",
      "seatsAvailable": "Available Seats",
      "upgradeQuota": "+ Top-Up Quota Seats",
      "level": "Level",
      "xp": "XP",
      "gold": "Gold",
      "streak": "Streak",
      "position": "Job Title",
      "status": "Status",
      "editPlayer": "Edit Player",
      "resetPassword": "Reset Password",
      "deletePlayer": "Offboard Member",
      "confirmDemoteMakerTitle": "Revoke Maker Access?",
      "confirmDemoteMakerText": "This employee will retain player status only.",
      "confirmDemoteMakerBtn": "Yes, Revoke Maker Access",
      "confirmDeleteTitle": "Offboard Employee?",
      "confirmDeleteText": "Deleting this player will revoke access and release 1 seat back to your company quota pool.",
      "confirmDeleteBtn": "Yes, Offboard & Release Seat",
      "resetPasswordTitle": "Reset Employee Password",
      "resetPasswordSub": "Set a new login password for employee:",
      "newPassword": "New Password",
      "passwordUpdated": "Password updated successfully.",
      "resetPasswordSuccess": "Password has been reset successfully.",
      "editModalTitle": "Edit Employee Profile"
    },
    "maker": {
      "title": "Game Maker (Manager)",
      "subtitle": "Manage team managers and squad supervisors authorized to design quests and approve submissions.",
      "insertNew": "+ Register New Maker",
      "addToPlayer": "Assign as Player",
      "alreadyInPlayer": "Maker & Player",
      "noMakersFound": "No Game Makers Found",
      "noMakersDesc": "No operational managers have been assigned yet in your organization.",
      "confirmAssignTitle": "Assign as Game Player?",
      "confirmAssignText": "This manager will also receive player capabilities to participate in quests and earn rewards.",
      "confirmAssignBtn": "Yes, Assign as Player",
      "demoteToPlayer": "Demote to Player Only",
      "confirmDemoteTitle": "Remove Maker Role?",
      "confirmDemoteText": "This user will no longer be able to create quests or approve submissions.",
      "confirmDemoteBtn": "Yes, Remove Maker Role",
      "confirmDeleteTitle": "Delete Game Maker?",
      "confirmDeleteText": "Are you sure you want to delete this game maker account?",
      "confirmDeleteBtn": "Yes, Delete Maker",
      "editMaker": "Edit Maker"
    },
    "approvalDetail": {
      "rewardApprovalTitle": "Review Quests & KPI Submission",
      "consequenceApprovalTitle": "Review SOP Consequence",
      "punishmentApprovalTitle": "Review Penalty Report",
      "compensationApprovalTitle": "Review Recovery Task",
      "submissionSubtitle": "Inspect evidence attachment and confirm reward distribution or rejection.",
      "consequenceSubtitle": "Review violation report details and confirm disciplinary sanction or dismissal.",
      "punishmentSubtitle": "Review incident details and confirm disciplinary record or dismissal.",
      "compensationSubtitle": "Inspect submitted recovery task evidence and confirm task completion.",
      "submittedAt": "Submitted At",
      "questRule": "Quests & KPI",
      "employee": "Employee",
      "rewardGold": "Reward Gold",
      "description": "Description",
      "comment": "Employee Comment",
      "evidenceAttachment": "Evidence Attachment",
      "viewAttachment": "Inspect Full Evidence",
      "noAttachment": "No Attachment Provided",
      "rejectionNotes": "Rejection Notes",
      "decisionAction": "Review Decision",
      "approve": "Approve & Credit Reward",
      "reject": "Reject Submission",
      "approveConsequence": "Approve & Apply Sanction",
      "rejectConsequence": "Reject Report",
      "approvePunishment": "Approve & Record Incident",
      "rejectPunishment": "Reject Report",
      "approveCompensation": "Approve & Clear Penalty",
      "rejectCompensation": "Reject & Require Revision",
      "consequenceApprovedMsg": "Violation report has been verified and disciplinary sanction applied.",
      "consequenceRejectedMsg": "Violation report has been rejected or dismissed.",
      "punishmentApprovedMsg": "Penalty report has been verified and recorded.",
      "punishmentRejectedMsg": "Penalty report has been rejected or dismissed.",
      "compensationApprovedMsg": "Recovery task has been verified and penalty cleared.",
      "compensationRejectedMsg": "Recovery task has been rejected.",
      "rewardApprovedMsg": "Quest submission has been approved and rewards distributed.",
      "rewardRejectedMsg": "Quest submission has been rejected.",
      "compensationTask": "Recovery Task",
      "offsettingViolation": "Offsetting Violation",
      "reasonPlaceholder": "Provide constructive feedback explaining why this submission was rejected...",
      "submitDecision": "Confirm Review",
      "reportedBy": "Reported By",
      "violationRule": "SOP Consequence",
      "penaltyDeduction": "Penalty Deduction"
    },
    "gameSettings": {
      "title": "Game Settings & Architecture Hub",
      "subtitle": "Gamification configuration, terminology standards, XP & Gold engine parameters, and company branding.",
      "engineActive": "Gamiteam Engine 2.0 Active",
      "tabTerminology": "1. Guide & Terminology",
      "tabEngine": "2. Engine Mechanics & Parameters",
      "tabBranding": "3. Company Profile & Branding",
      "tabWizard": "4. Setup Checklist Wizard",
      "mechanismTitle": "Gamiteam Productivity Cycle",
      "mechanismDesc": "The platform works via an integrated productivity loop: Quests generate Gold & XP, SOP Consequences discipline standards, Recovery Tasks offset mistakes, and Reward Shop provides real motivation.",
      "targetPositive": "POSITIVE TARGETS",
      "questsTitle": "Quests & KPI",
      "questsFlow": "Flow: Maker Creates Rule → Player Takes & Submits Proof → Maker Approves → Player Claims Reward",
      "manageQuests": "Manage Quest Rules →",
      "sopDiscipline": "SOP DISCIPLINE",
      "penaltiesTitle": "SOP Consequence",
      "penaltiesFlow": "Flow: Violation Occurs → Report Submitted → Maker/Owner Verifies → Gold Deducted",
      "managePenalties": "Manage SOP Consequences →",
      "remediation": "REMEDIATION",
      "compensationsTitle": "Recovery Task",
      "compensationsFlow": "Flow: Player Receives Penalty → Takes Recovery Task → Submits → Penalty Resolved",
      "manageCompensations": "Manage Recovery Tasks →",
      "rewardShopTitle": "Reward Shop & Redemption",
      "rewardShopFlow": "Flow: Player Accumulates Gold → Purchases Item in Shop → Admin Distributes Perk",
      "manageShop": "Open Reward Shop →",
      "tabAi": "5. AI Game Architect & Copilot",
      "aiBannerTitle": "AI Gamification Architect & Copilot",
      "aiBannerDesc": "Let AI analyze your company profile, design balanced quest economies, prevent employee burnout, and generate tailored SOP rules in seconds.",
      "aiSelectIndustry": "Select Team & Industry Archetype",
      "aiCustomPrompt": "Or Describe Custom Team Goals & Challenges",
      "aiPromptPlaceholder": "e.g. We are a fast-paced software agency with 15 developers. We need quests for code reviews, sprint delivery, and fair penalties for missing daily standups without hurting morale...",
      "aiGenerateBtn": "Generate AI Gamification Blueprint",
      "aiGenerating": "AI is balancing economy & generating blueprint...",
      "aiApplyEngineBtn": "Apply Settings to Game Engine",
      "aiDeployRulesBtn": "1-Click Deploy Rules to Workspace",
      "aiDeploying": "Deploying rules to database...",
      "aiDeployedSuccess": "All recommended Quests, SOP Consequences, Recovery Tasks, and Reward Shop items have been deployed!",
      "aiHealthScore": "Economy Balance Score",
      "aiBurnoutRisk": "Burnout Risk",
      "aiSlaAdherence": "Projected SLA Adherence",
      "saveEngineConfig": "Save Engine Configuration",
      "engineSaved": "Gamification engine parameters saved successfully!",
      "aiBlueprintDoneTitle": "AI Blueprint Successfully Created!",
      "aiBlueprintDoneDesc": "Gamification engine successfully aligned for profile {archetype} with balance score {score}/100.",
      "aiParamsApplied": "AI recommendation parameters have been applied to the Gamification Engine tab!",
      "aiConfirmDeployTitle": "Deploy AI Rules to Database?",
      "aiConfirmDeployDesc": "AI system will automatically register {quests} Quests & KPIs, {consequences} SOP Consequences, {compensations} Recovery Tasks, and {rewards} Reward Items into your organization database.",
      "aiConfirmDeployBtn": "Yes, Deploy Now!",
      "aiDeploySuccessTitle": "Successfully Deployed to Workspace!",
      "aiDeployErrorDesc": "Failed to deploy some rules to the database.",
      "blueprintCopiedTitle": "Copied!",
      "blueprintCopiedDesc": "Gamification blueprint specification (JSON) copied to clipboard.",
      "activeRealmBadge": "ACTIVE WORKSPACE",
      "aiAppliedToEngineDesc": "Engine parameters and progression curves have been loaded into your workspace settings.",
      "aiBlueprintReady": "AI Gamification Blueprint Generated",
      "aiDeployPartialError": "Some items could not be deployed. Please check your workspace rules list.",
      "aiGeneratedDesc": "Tailored blueprint for {archetype} (Configuration Readiness: {score}%).",
      "aiGeneratedTitle": "Blueprint Synthesized",
      "antiCheatBalanced": "Balanced (OCR + Maker Review on High-Value Quests)",
      "antiCheatLenient": "Streamlined (Auto-Approve Low-Tier Daily Quests)",
      "antiCheatShort": "Verification Mode",
      "antiCheatShortBalanced": "Balanced",
      "antiCheatShortLenient": "Streamlined",
      "antiCheatShortStrict": "Strict",
      "antiCheatStrict": "Strict (100% Manual Manager Verification + Proof Hash)",
      "antiCheatToleranceLabel": "Evidence Verification & Anti-Cheat Policy",
      "archCreative": "Marketing, Brand & Creative Studio",
      "archOperations": "Retail, Supply Chain & Field Operations",
      "archSales": "B2B Sales & Revenue Growth",
      "archSupport": "Customer Support & Service Desk",
      "archTech": "Software Engineering, Product & DevOps",
      "baseXp100": "100 XP (Standard Corporate Pace)",
      "baseXp150": "150 XP (Measured Quarterly Pace)",
      "baseXp200": "200 XP (Long-Term Mastery Pace)",
      "baseXp50": "50 XP (Fast Onboarding Progression)",
      "baseXpPerLevel": "Base XP Threshold per Level",
      "baseXpShort": "Base XP",
      "brandingSubtitle": "Customize your workspace identity, theme accent, and commander welcome message shown in the mobile app.",
      "brandingTitle": "Workspace Identity & Mobile Branding",
      "calculatedRankLabel": "Calculated Player Rank",
      "colCumulativeXp": "Cumulative XP Threshold",
      "colLevelUpReward": "Level-Up Title & Milestone",
      "colRequiredXp": "XP Required for Tier",
      "colTierLevel": "Level Tier",
      "commanderBriefingLabel": "Workspace Briefing",
      "companyLogoLabel": "Workspace Logo",
      "companyNameLabel": "Organization Display Name",
      "companyNamePlaceholder": "e.g. PT Nusantara Digital",
      "compensationsCardDesc": "Redemption tasks to clear penalty records",
      "copiedBlueprintDesc": "Full blueprint JSON copied to clipboard.",
      "copiedTitle": "JSON Copied",
      "copyJsonBtn": "Copy JSON Spec",
      "currentTierXpLabel": "Progress in Current Level",
      "dailyGoldCapLabel": "Maximum Daily Gold Cap per Employee",
      "dailyGoldCapShort": "Daily Gold Cap",
      "dailyStreakLabel": "Enable Consecutive Workday Streak Bonus",
      "dailyStreakSubtitle": "Reward sustained daily SOP consistency without inflating one-off payouts.",
      "dailyStreakTitle": "Consistency Streak & Peer Recognition Rules",
      "databaseLabel": "Workspace Ruleset",
      "days1To2": "Days 1 - 2",
      "days1To2Desc": "Standard base reward rate (1.0x)",
      "days3To6": "Days 3 - 6",
      "days3To6Desc": "Momentum bonus (+10% XP)",
      "days7Plus": "7+ Consecutive Days",
      "days7PlusDesc": "Full streak multiplier applied",
      "days7Short": "7+ Days",
      "daysUnit": "days",
      "defaultCompanyName": "Enterprise Workspace",
      "defaultEvidenceHint": "Verified task completion proof",
      "defaultWelcomePreview": "Complete daily operational quests with verified quality and earn real team rewards.",
      "deployConfirmBtn": "Deploy All to Workspace",
      "deployConfirmDesc": "This will publish {quests} quests, {consequences} consequences, {compensations} recovery tasks, and {rewards} shop rewards to your live workspace.",
      "deployConfirmTitle": "Deploy Blueprint to Live Workspace?",
      "engineTuningSubtitle": "Calibrate XP leveling curves, daily Gold budget caps, and verification policies.",
      "engineTuningTitle": "Gamification Engine & Economy Parameters",
      "enterTotalXpLabel": "Simulate Total Employee XP",
      "evidenceGuideSuffix": "Required proof: {evidence}",
      "evidenceLabel": "Required Proof:",
      "freqDaily": "Daily",
      "goldMultiplierHigh": "High Consistency Boost",
      "goldMultiplierStandard": "Standard Sustainable Boost",
      "goldMultiplierSuffix": "Gold Multiplier",
      "goldPerDayUnit": "Gold per day",
      "kudosAllowanceLabel": "Weekly Peer Kudos Quota per Member",
      "kudosOption10": "10 Kudos per week (High Collaboration)",
      "kudosOption3": "3 Kudos per week (Selective Recognition)",
      "kudosOption5": "5 Kudos per week (Recommended Standard)",
      "kudosSystemDesc": "Each team member can send up to {allowance} peer recognitions per week (+{gold} Gold each).",
      "kudosSystemTitle": "Peer-to-Peer Recognition (Kudos)",
      "levelLabel": "LEVEL",
      "levelValue": "Level {level}",
      "livePreviewTitle": "Mobile Player Hub Preview",
      "logoFormatHint": "PNG, JPG, or SVG (max 2 MB, square ratio recommended)",
      "lowOptimal": "Balanced Economy",
      "normalRate": "1.0x Base",
      "penaltiesCardDesc": "Clear accountability rules for SOP violations",
      "productivityIncentive": "Core KPI Incentive",
      "questsCardDesc": "Actionable daily & weekly KPI missions",
      "questsSuiteTitle": "Recommended KPI Quests ({count})",
      "recommendedEngineParams": "Recommended Engine Parameters",
      "recommendedShopItems": "Recommended Reward Catalog",
      "recoverInfraction": "Infraction Recovery",
      "recoveryTasksTitle": "Recovery & Compensation Tasks",
      "rewardShopBadge": "Catalog Item",
      "rewardShopCardDesc": "Tangible perks employees redeem with Gold",
      "sopPenaltiesTitle": "SOP Accountability & Consequences",
      "streakMultiplierLabel": "7-Day Streak Gold Multiplier",
      "streakMultiplierShort": "Streak Bonus",
      "themeColorLabel": "Primary Brand Accent Color",
      "toNextLevelLabel": "to Level {level}",
      "welcomeMessageLabel": "Team Welcome Briefing",
      "welcomeMessagePlaceholder": "Write a clear motivational briefing for your team...",
      "xpCurveExponential": "Exponential (Steep Senior Mastery Curve)",
      "xpCurveLabel": "Level Progression Curve Formula",
      "xpCurveLinear": "Linear (Steady Equal Steps per Level)",
      "xpCurveModerate": "Balanced Progressive (+25% per Level Tier)",
      "xpMatrixSubtitle": "Live threshold projection across employee levels based on your active curve.",
      "xpMatrixTitle": "Leveling Threshold Matrix",
      "xpPerLvlUnit": "XP per level",
      "xpSimulatorSubtitle": "Test how employee XP translates into rank titles and progression bars.",
      "xpSimulatorTitle": "Interactive Level Progression Simulator"
    },
    "redeem": {
      "title": "Reward Shop",
      "subtitle": "Configure merchandise, vouchers, and perks that employees can redeem using earned Gold.",
      "addItem": "+ Add Reward Item",
      "searchPlaceholder": "Search reward item...",
      "itemName": "Reward Item Name",
      "costGold": "Cost (Gold)",
      "emptyTitle": "No Reward Items Available",
      "emptyDesc": "Create gift vouchers, perks, or merchandise items for employees to redeem.",
      "createTitle": "Create New Reward Item",
      "createSub": "Add an item to the employee redemption marketplace with defined gold price.",
      "editTitle": "Edit Reward Item",
      "editSub": "Update item specifications or adjust gold redemption cost.",
      "detailsTitle": "Reward Item Details",
      "confirmDelete": "Are you sure you want to remove this reward item?",
      "deletedSuccess": "Reward item has been successfully removed.",
      "savedSuccess": "Reward item saved successfully."
    },
    "playerForm": {
      "createTitle": "Register New Game Player",
      "createSub": "Onboard an employee into the organization gamification workspace.",
      "editTitle": "Edit Game Player",
      "editSub": "Update employee account profile, squad assignment, and contact details.",
      "detailsTitle": "Game Player Profile Details",
      "playerName": "Player Name",
      "dateOfBirth": "Date of Birth",
      "emailAddress": "Email Address",
      "phoneNumber": "Phone Number",
      "password": "Password",
      "updatePassword": "Change Password (Optional)",
      "leaveBlankPassword": "Leave blank to keep current password",
      "squad": "Division & Squad",
      "selectSquad": "Select Squad",
      "position": "Job Position",
      "userPhoto": "Profile Avatar",
      "changePhoto": "Upload New Photo",
      "joinDate": "Joined Date",
      "savedSuccess": "Player data saved successfully.",
      "updatedSuccess": "Player data updated successfully.",
      "deletedSuccess": "Player has been deleted.",
      "confirmDelete": "Are you sure you want to delete this player?"
    },
    "makerForm": {
      "createTitle": "Register New Game Maker (Manager)",
      "createSub": "Add a supervisor or team manager with quest creation and approval privileges.",
      "editTitle": "Edit Game Maker (Manager)",
      "editSub": "Update supervisor account details, squad authority, and contact information.",
      "detailsTitle": "Game Maker (Manager) Profile Details",
      "makerName": "Maker Name",
      "dateOfBirth": "Date of Birth",
      "emailAddress": "Email Address",
      "phoneNumber": "Phone Number",
      "password": "Password",
      "updatePassword": "Change Password (Optional)",
      "leaveBlankPassword": "Leave blank to keep current password",
      "squad": "Division & Squad",
      "selectSquad": "Select Squad",
      "position": "Job Position",
      "userPhoto": "Profile Avatar",
      "changePhoto": "Upload New Photo",
      "joinDate": "Joined Date",
      "savedSuccess": "Game Maker data saved successfully.",
      "updatedSuccess": "Game Maker data updated successfully.",
      "deletedSuccess": "Game Maker has been deleted.",
      "confirmDelete": "Are you sure you want to delete this Game Maker?"
    },
    "rulesForm": {
      "editRewardTitle": "Edit Quests & KPI",
      "editRewardSub": "Modify quest objective requirements, gold rewards, recurrence cycle, and target assignees.",
      "detailRewardTitle": "Quests & KPI Specification",
      "editConsequenceTitle": "Edit SOP Consequence",
      "editConsequenceSub": "Update penalty Gold or non-gold disciplinary consequence for policy breach.",
      "detailConsequenceTitle": "SOP Consequence Specification",
      "editCompensationTitle": "Edit Recovery Task",
      "editCompensationSub": "Update recovery task allowing employees to offset violation Gold.",
      "detailCompensationTitle": "Recovery Task Specification",
      "questName": "Quest Title",
      "questType": "Quest Type",
      "alwaysActive": "Always Active (Available Anytime)",
      "oneTime": "One-Time Objective",
      "rewardType": "Reward Incentive",
      "goldCoins": "Gold",
      "nonGoldPerk": "Non-Gold & Custom Perk",
      "rewardValue": "Reward Value",
      "frequency": "Cycle Frequency",
      "noRepeat": "One-Time (No Repeat)",
      "daily": "Daily Cycle",
      "weekly": "Weekly Cycle",
      "monthly": "Monthly Cycle",
      "endsOn": "Validity Expiration (Ends On)",
      "targetAssignees": "Target Assignees",
      "allPlayers": "All Company Players",
      "specificPlayers": "Specific Players",
      "specificSquads": "Specific Division & Squad",
      "description": "Objective & Standard of Proof",
      "descPlaceholder": "Provide clear success metrics and required evidence attachments...",
      "consequenceName": "SOP Consequence Title",
      "punishmentType": "SOP Consequence Type",
      "penaltyType": "SOP Consequence Type",
      "penaltyGold": "Deduct Gold",
      "penaltyNonGold": "Non-Gold Consequence",
      "compensationName": "Recovery Task Title",
      "compensationDesc": "Recovery Task Activity & Standard",
      "savedSuccess": "Rule saved successfully.",
      "updatedSuccess": "Rule updated successfully.",
      "deletedSuccess": "Rule has been deleted."
    },
    "executive": {
      "suiteBadge": "GAME OWNER SUITE",
      "macroRadar": "Macro Telemetry & ROI Radar",
      "geminiAi": "Gemini Strategic AI",
      "title": "Executive Command & Macro Analytics",
      "description": "Strategic command center for Founders & C-Level executives. Monitor circulating Gold liquidity, corporate gamification ROI, division velocity heatmaps, early fatigue/turnover detection, and company boss raid quarterly progress.",
      "exportPdf": "Export Audit PDF",
      "syncTelemetry": "Sync Telemetry",
      "totalGoldLiquidity": "TOTAL GOLD LIQUIDITY",
      "goldRate": "1 Gold = Rp 1,000",
      "goldCirculating": "Gold Circulating",
      "liabilityValuation": "Liability Valuation",
      "burnRate": "Burn Rate",
      "pool": "Pool",
      "netCorporateRoi": "NET CORPORATE ROI",
      "returnOnIncentive": "Return on Incentive",
      "roiDesc": "Output KPI efficiency vs distributed incentive rewards.",
      "roiBenchmark": "Above SaaS industry benchmark (3.2x)",
      "velocityIndex": "COMPANY VELOCITY INDEX",
      "highSpeed": "High Speed",
      "velocitySub": "Consistency streak ratio & 7-day quest execution pace.",
      "activeDailyEmployees": "Active daily employees",
      "activeRealms": "ACTIVE 3D REALMS",
      "manageMarketplace": "Manage Marketplace",
      "realmsDeployed": "Realms Deployed",
      "rulesVerified": "Anti-cheat & SOP verified",
      "bossRaidTitle": "COMPANY BOSS RAID",
      "target": "Target",
      "quarterTarget": "Q4 Target",
      "bossRaidDesc": "Every quest cleared by all company employees chips away at the raid target. Once defeated, the pool bonus is automatically disbursed to payroll based on individual impact.",
      "hpRemaining": "Remaining Boss HP",
      "damageDealt": "Damage Dealt",
      "contributors": "Contributors",
      "deadline": "Deadline",
      "lootPool": "Loot Pool",
      "staff": "staff",
      "members": "Members",
      "projectedDefeat": "Projected Defeat: 12 Days Ahead of Schedule",
      "triggerBoost": "Trigger Raid Motivation Boost",
      "adjustTarget": "Adjust Target",
      "divisionHeatmap": "Division Squad Heatmap",
      "divisionHeatmapSub": "Velocity and operational health comparison across corporate squads",
      "last7Days": "Last 7 Days",
      "last30Days": "Last 30 Days",
      "divisionSquad": "Division & Squad",
      "questsCleared": "Quests Cleared",
      "completionRate": "Completion Rate",
      "velocityScore": "Velocity Score",
      "status": "Status",
      "turnoverRadar": "Turnover & Fatigue Radar",
      "turnoverRadarSub": "Early detection of broken streaks or disengaged personnel",
      "detectedCount": "Detected",
      "allConsistent": "All team members are active, engaged, and motivated!",
      "streakLost": "Streak broken",
      "inactiveDays": "Inactive",
      "days": "days",
      "callMaker": "Alert Manager (Maker)",
      "proactiveAlgo": "Proactive Risk Engine:",
      "proactiveDesc": "Reduces enterprise turnover by up to 38% by spotting performance declines weeks before formal resignations.",
      "financialLedger": "Financial Ledger & Tax Audit (PPN 11%)",
      "financialLedgerSub": "Transparent allocation of incentive funds, 11% VAT deduction, and gateway fees",
      "autoDisburseActive": "Auto-Disbursement Active",
      "autoTaxInvoice": "Automatic Tax Invoice",
      "grossRewardQ4": "Gross Q4 Rewards",
      "ppnCollected": "PPN 11% Collected",
      "platformFee": "Platform Fee (2.5%)",
      "netDisbursed": "Net Disbursed to Staff",
      "geminiAdvisory": "Gemini Strategic Executive Advisory",
      "geminiAdvisorySub": "Automated C-Level AI recommendations for corporate performance scaling",
      "guidanceSentTitle": "Guidance Signal Sent!",
      "guidanceSentDesc": "Guidance signal sent to Game Maker! Maker will promptly evaluate SOP & rescue reward for {name}.",
      "motivationBoostTitle": "Raid Motivation Boost Active!",
      "motivationBoostDesc": "All employees receive +15% XP & Gold boost for quests completed within the next 24 hours.",
      "adjustRaidTarget": "Adjust Boss Raid Target",
      "enterRaidTargetNominal": "Enter new Boss Raid target amount (IDR):",
      "raidTargetUpdated": "Boss Raid target updated successfully.",
      "auditReportGenerated": "Audit Report Generated Successfully!",
      "auditReportDesc": "Executive Gamification & Financial Audit report downloaded successfully.",
      "adjustBossModalLabel": "Update Boss Raid Target HP (Quest Points)",
      "adjustBossModalTitle": "Configure Boss Raid Target",
      "adjustBossSuccessMsg": "Boss Raid target parameters updated.",
      "auditReportGeneratedMsg": "Executive summary report has been prepared for printing or PDF export.",
      "auditReportGeneratedTitle": "Executive Report Ready",
      "defaultBossName": "Quarterly Operations Milestone",
      "noActiveBossRaid": "No Active Boss Raid Configured",
      "raidBoostMsg": "Team motivation notification has been broadcast to active workspace members.",
      "raidBoostTitle": "Raid Motivation Broadcast Sent",
      "raidBoostedStatus": "Motivation Broadcast Active",
      "rescueDispatched": "Check-in Scheduled",
      "rescueSignalMsg": "1-on-1 coaching check-in reminder sent to {name}'s manager.",
      "rescueSignalTitle": "Coaching Check-in Dispatched",
      "totalGoldEarnedLabel": "Total Gold Earned by Team",
      "totalGoldRedeemedLabel": "Total Gold Redeemed in Shop"
    },
    "quota": {
      "title": "Seat Allocation & Player Quota Management",
      "subtitle": "Monitor active player seat utilization, license quotas, and enterprise client seat top-ups in real-time.",
      "topUpQuotaBtn": "+ Add Seat Quota",
      "capacity": "Capacity",
      "totalSeats": "Total Seat Capacity",
      "registeredPlayers": "Registered Active Players",
      "availableSeats": "Available Free Seats",
      "avgUtilization": "Average Seat Utilization",
      "seatsAllocated": "Seats Allocated",
      "seatsAvailableForOnboarding": "Available slots for employee onboarding",
      "searchPlaceholder": "Search company or owner name...",
      "allCapacityStatus": "All Capacity Levels",
      "capacityAvailable": "Healthy Capacity (< 70%)",
      "capacityWarning": "Near Capacity (70% - 90%)",
      "capacityCritical": "Critical Capacity (> 90%)",
      "loadingQuota": "Synchronizing tenant seat allocation data...",
      "tableNo": "No",
      "tableCompany": "Client Enterprise",
      "tablePackage": "Active Plan",
      "tableQuota": "Quota",
      "tablePlayers": "Players",
      "tableUtilization": "Utilization",
      "tableStatus": "Status",
      "tableAction": "Actions",
      "topUpBtn": "Top-up Seats",
      "noCompaniesFound": "No client companies match your search or filter.",
      "expansionTitle": "Expand Player Seat Quota",
      "expansionSubtitle": "Add extra player licenses to scale onboarding capacity for client enterprises.",
      "backToQuota": "Back to Quota Allocation",
      "selectClient": "Select Client Enterprise",
      "clientCompany": "Client Enterprise",
      "chooseClientPlaceholder": "Choose client company...",
      "activeQuota": "Active Quota",
      "newQuotaEstimate": "Estimated New Quota",
      "additionalSeatsCount": "Additional Seat Quantity",
      "seats": "Seats",
      "customSeatsLabel": "Custom Seat Quantity",
      "customSeatsPlaceholder": "e.g. 50",
      "playerSeats": "Player Seats",
      "licenseDuration": "Quota License Duration",
      "standard": "Standard",
      "voucherCode": "Discount Voucher (Optional)",
      "voucherPlaceholder": "e.g. GAMITEAM2026",
      "applyVoucher": "Apply Code",
      "voucherApplied": "Voucher Applied!",
      "quotaSummary": "Quota Expansion Order Summary",
      "seatsSubtotal": "Seat Subtotal",
      "taxPpn": "PPN (11%)",
      "prorationCredit": "Proration Credit",
      "totalPayable": "Total Payable",
      "proceedToPayment": "Proceed to Payment",
      "calculating": "Calculating order...",
      "successOrder": "Quota order created successfully",
      "seatsCount": "{count} Seats",
      "currentSeats": "Current: {count} Seats"
    },
    "billing": {
      "title": "Company Subscription & Billing",
      "periodTitle": "Billing Period & Plan",
      "packageName": "Plan Name",
      "totalUsers": "Allocated Seats",
      "expiryDate": "Expiration Date",
      "upgradeNow": "Upgrade Plan",
      "upgradeModalTitle": "Upgrade Enterprise Plan",
      "upgradeModalBody": "Would you like to scale or upgrade your company’s Gamiteam subscription tier?",
      "upgradeModalDesc": "Consult with our enterprise specialists for custom employee seat capacity, SLA guarantees, and dedicated realms.",
      "closeModal": "Close",
      "contactSales": "Contact Enterprise Sales",
      "billingInfo": "Billing Information",
      "billingCycle": "Billing Cycle",
      "nextBillingDate": "Next Billing Date",
      "quotaCapacity": "Seat Capacity & Quota",
      "quotaUsage": "Seats in Use",
      "quickAddQuota": "+ Add Quota",
      "historyTitle": "Billing & Payment History",
      "payDate": "Payment Date",
      "billingPeriod": "Coverage Period",
      "totalAmount": "Total Amount",
      "paymentType": "Method",
      "paymentStatus": "Status",
      "action": "Actions",
      "payNow": "Pay Online",
      "payManual": "Manual Transfer",
      "viewDetail": "Invoice Details",
      "downloadInvoice": "Download Invoice",
      "noHistory": "No Billing History Found",
      "noHistoryDesc": "No subscription renewals or seat top-ups recorded yet.",
      "reasonForReject": "Reason for Rejection",
      "month": "Month",
      "digital": "Payment Gateway",
      "manual": "Manual Transfer",
      "pending": "Pending",
      "paid": "Paid",
      "expired": "Expired",
      "failed": "Failed",
      "approved": "Approved",
      "information": "Invoice Information",
      "status": "Status",
      "paymentDestination": "Destination Account",
      "accountNumber": "Account Number",
      "senderBank": "Sending Bank",
      "senderName": "Sender Account Name",
      "uploadProof": "Upload Payment Proof",
      "confirmTransfer": "Confirm Manual Transfer",
      "transferNotice": "Transfer to official Gamiteam bank account and upload your payment receipt below.",
      "proofRequired": "Proof Required",
      "proofRequiredNotice": "Please attach your bank transfer receipt proof.",
      "paymentSubmitted": "Payment Submitted!",
      "paymentSubmittedDesc": "Your manual payment proof has been submitted for verification. Superadmin will activate your quota shortly.",
      "submissionError": "Submission Error",
      "receiptNotice": "Upload official transfer receipt from Mobile Banking, ATM, or Internet Banking.",
      "bankPlaceholder": "e.g. BCA, Bank Mandiri, BRI, BNI",
      "senderPlaceholder": "e.g. PT Maju Bersama & Budi Rahardjo",
      "activeSubscriptionBadge": "Active Subscription",
      "addonOptionBadge": "Seat Add-on (Flexible)",
      "addonOptionDesc": "Add 5, 10, 25, 50, or custom seats to your active subscription without changing your base tier.",
      "addonOptionTitle": "Add Extra Player Seats",
      "bankTransferMethod": "Bank Transfer",
      "buyAddonSeatsBtn": "Buy Add-on Seats",
      "chooseExpansionTitle": "Choose Quota & Plan Expansion",
      "manualPaymentError": "Failed to process manual payment request.",
      "monthShort": "Mo",
      "onlineMethod": "Online Payment",
      "quotaHealthyBadge": "Healthy",
      "tierListLabel": "Starter • Growth • Enterprise",
      "tierOptionBadge": "Bundled Plan Tier",
      "tierOptionDesc": "Upgrade workspace capacity to higher bundled tiers with automatic active-day proration credit.",
      "tierOptionTitle": "Upgrade Base Package Tier",
      "upgradeTierPlanBtn": "Upgrade Plan Tier"
    },
    "checkout": {
      "title": "Subscription & Quota Checkout",
      "activatePackage": "Current Active Subscription",
      "newPackage": "Select Subscription Plan",
      "package": "Plan",
      "pricePerUnit": "Unit Price",
      "qty": "Qty",
      "duration": "Duration",
      "totalPrice": "Total Price",
      "selectPackagePlaceholder": "Choose a plan...",
      "additionalUser": "Additional Player Seats",
      "summary": "Order Summary",
      "packageSummary": "Subscription Breakdown",
      "newBill": "Plan Subtotal",
      "credit": "Proration Credit",
      "total": "Grand Total",
      "discountCode": "Promo Voucher Code",
      "apply": "Apply",
      "back": "Back",
      "payNowBtn": "Proceed to Payment",
      "invoiceNumber": "Invoice Number",
      "transferModalTitle": "Manual Bank Transfer",
      "transferInstructions": "Please transfer the exact total amount to the official Gamiteam corporate account. After transfer, confirm payment proof for instant activation.",
      "bankName": "Bank Central Asia (BCA)",
      "accountHolder": "PT Gamiteam Digital Nusantara",
      "accountNumber": "Account Number: 5892 000 000",
      "postpone": "Pay Later",
      "confirmTransfer": "Confirm Payment Now",
      "onlineModalTitle": "Payment Gateway",
      "onlineModalBody": "Redirecting to secure payment checkout...",
      "freeTier": "Standard Features",
      "additionalTier": "Extra Additions",
      "usersQuota": "{count} of {total} seats",
      "additionalSeatsRow": "Additional Player Seats",
      "addonSubtotalLabel": "Add-on Seat Subtotal",
      "checkoutErrorTitle": "Checkout Failed",
      "colDescription": "Description",
      "coreAdminSeatsFeature": "5 Core Administrator Seats Included",
      "createInvoiceFailed": "Unable to create billing invoice.",
      "customSeatsCountLabel": "Custom Seat Quantity",
      "enterpriseActiveBadge": "Enterprise Workspace",
      "flexibleTopupFeature": "Flexible On-Demand Player Seat Top-ups",
      "manualTransferBtn": "Manual Bank Transfer",
      "modeAddonBtn": "Add Extra Seats Only",
      "modeAddonDesc": "Keep your current plan tier and top up extra seats prorated to your active cycle.",
      "modeAddonTitle": "Seat Quota Add-on",
      "modePackageBtn": "Switch or Upgrade Plan Tier",
      "modePackageDesc": "Select a bundled subscription plan and duration with automatic proration calculation.",
      "modePackageTitle": "Subscription Tier Plan",
      "officialDestinationAccount": "Official Corporate Bank Account",
      "onlineGatewayErrorTitle": "Payment Gateway Notice",
      "onlineGatewayUnavailableText": "Online payment gateway could not be reached. Please try again or use manual bank transfer.",
      "onlinePaymentBtn": "Pay Online Instantly",
      "partnerNetworkFeature": "Multi-Division Workspace Governance",
      "paymentGatewayRedirectText": "Redirecting to the secure payment checkout page...",
      "paymentGatewayTitle": "Payment Checkout Ready",
      "perSeatPerMonth": "per seat per month",
      "proformaTitle": "Proforma Order Summary",
      "promoAppliedAmountText": "Voucher {code} applied! Discount: Rp {amount}",
      "promoAppliedTitle": "Promo Voucher Applied",
      "promoEnterValidText": "Please enter a valid promo code first.",
      "promoInvalidFallback": "Promo code is invalid, inactive, or does not meet minimum transaction requirements.",
      "promoInvalidTitle": "Promo Code Unavailable",
      "promoModalTitle": "Apply Promo Voucher",
      "promoPlaceholder": "Enter promo code (e.g. GAMITEAM20)",
      "promoVoucherDiscount": "Promo Voucher Discount",
      "prorationCreditLabel": "Active Plan Proration Credit",
      "prorationUpgradeFeature": "Automatic Proration Credit on Tier Upgrades",
      "quickPresetsLabel": "Quick Seat Presets",
      "seatCountRequiredText": "Please specify at least 1 additional player seat.",
      "seatCountRequiredTitle": "Seat Quantity Required",
      "securePaymentChannelsDesc": "Choose instant digital settlement or verified corporate bank transfer.",
      "securePaymentChannelsTitle": "Corporate Payment Channels",
      "selectPackageText": "Please choose a subscription package before proceeding.",
      "selectPackageTitle": "Select Subscription Plan",
      "subscriptionPlanQuotaRow": "Base Subscription Plan Quota",
      "totalInvoiceAmountLabel": "Total Invoice Amount:",
      "totalPayableLabel": "Total Amount Payable"
    },
    "register": {
      "title": "Enterprise Client Registration",
      "subtitle": "Transform team performance with KPI quests, streak rewards, and real-time division collaboration.",
      "companyName": "Company Name",
      "companyNamePlaceholder": "e.g. PT Maju Bersama",
      "ownerName": "Executive & Owner Full Name",
      "ownerNamePlaceholder": "e.g. Budi Rahardjo",
      "phoneNumber": "Official Phone or WhatsApp",
      "phoneNumberPlaceholder": "e.g. 081234567890",
      "numberOfPlayers": "Initial Employee Seats",
      "numberOfPlayersPlaceholder": "e.g. 25",
      "subscription": "Subscription Duration",
      "companyLogo": "Company Logo",
      "email": "Corporate Email Address",
      "emailPlaceholder": "e.g. founder@company.com",
      "password": "Create Password",
      "passwordPlaceholder": "Minimum 6 characters",
      "confirmPassword": "Confirm Password",
      "confirmPasswordPlaceholder": "Re-enter password",
      "registerBtn": "Register Enterprise Workspace",
      "alreadyRegistered": "Already have an enterprise account?",
      "signIn": "Sign in to Gamiteam",
      "success": "Registration Successful!",
      "successSub": "Your enterprise workspace has been provisioned. Please sign in to access your platform.",
      "passwordMismatch": "Passwords do not match.",
      "plansBenefit": "Included Enterprise Features",
      "benefit1": "Full Quest & SOP Engine with XP/Gold economy",
      "benefit2": "Cross-Division Leaderboards & Boss Raid Quests",
      "benefit3": "Gemini AI Strategic Insights & Turnover Radar",
      "monthUnit": "Month",
      "monthsUnit": "Months"
    },
    "common": {
      "search": "Search...",
      "filter": "Filter",
      "all": "All",
      "save": "Save Changes",
      "saving": "Saving...",
      "cancel": "Cancel",
      "refresh": "Refresh",
      "create": "Create",
      "delete": "Delete",
      "deleted": "Deleted!",
      "edit": "Edit",
      "view": "View",
      "back": "Back",
      "close": "Close",
      "approve": "Approve",
      "reject": "Reject",
      "status": "Status",
      "actions": "Actions",
      "date": "Date",
      "name": "Name",
      "photo": "Profile Picture",
      "role": "Access Role",
      "joinedSince": "Registered Since",
      "description": "Description",
      "success": "Success",
      "error": "Error",
      "loading": "Loading data...",
      "noData": "No records found.",
      "active": "Active",
      "inactive": "Inactive",
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "language": "Language",
      "selectLanguage": "Select Language",
      "submit": "Submit Data",
      "update": "Update Data",
      "confirm": "Are you sure?",
      "confirmDelete": "This action cannot be undone!",
      "warning": "Warning",
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "entries": "entries",
      "previous": "Previous",
      "prev": "Previous",
      "next": "Next",
      "category": "Category",
      "gold": "Gold",
      "no": "No",
      "processing": "Processing...",
      "reset": "Reset"
    },
    "aiModal": {
      "title": "Gemini AI Quest Architect",
      "subtitle": "Auto-generate structured KPI quests, SOP rules, and balanced rewards with Gemini AI",
      "departmentLabel": "Target Department & Squad Focus",
      "deptGeneral": "General & All Company",
      "deptSales": "Sales & Business Development",
      "deptTech": "Engineering, IT & DevOps",
      "deptMarketing": "Marketing & Creative",
      "deptOps": "Customer Support & Operations",
      "deptHr": "HR, Finance & Administration",
      "promptLabel": "Describe Your Team Goal or Challenge",
      "promptPlaceholder": "Example: Increase B2B sales pipeline velocity, ensure CRM updates before 5 PM, and boost weekly code review turnaround...",
      "quickPromptsLabel": "Quick Prompts:",
      "generateBtn": "Generate Quest Recommendations with Gemini AI",
      "generatingBtn": "Gemini AI is Designing Quests...",
      "selectHelp": "Select the quests you want to deploy to your workspace:",
      "selectAll": "Select All",
      "deselectAll": "Deselect All",
      "regenerate": "Regenerate",
      "selectedCount": "{count} quest(s) selected",
      "cancelBtn": "Cancel",
      "deployBtn": "Deploy {count} Quest(s) Now",
      "deployingBtn": "Deploying to Database...",
      "dailyBadge": "Daily Quest",
      "oneTimeBadge": "One-Time Quest",
      "evidenceRequired": "Evidence Required",
      "recommendedPenaltyLabel": "Recommended Consequence:",
      "reasoningLabel": "KPI Design Rationale:"
    },
    "profile": {
      "title": "Account Profile",
      "subtitle": "Manage your personal profile, security credentials, and workspace identity.",
      "editTitle": "Edit Account Profile",
      "editSubtitle": "Update your personal information, avatar, and contact details.",
      "passwordTitle": "Change Account Password",
      "passwordSubtitle": "Secure your account by updating your login password.",
      "resetPasswordTitle": "Change Account Password",
      "resetPasswordSubtitle": "Secure your account by updating your login password.",
      "fullName": "Full Name",
      "userName": "Full Name",
      "fullNamePlaceholder": "Enter full name",
      "email": "Email Address",
      "emailAddress": "Email Address",
      "emailPlaceholder": "Enter email address",
      "phone": "Phone or WhatsApp Number",
      "phoneNumber": "Phone or WhatsApp Number",
      "phonePlaceholder": "Enter phone number",
      "birthDate": "Date of Birth",
      "position": "Job Title",
      "positionPlaceholder": "Enter job position",
      "photo": "Profile Photo",
      "changePhoto": "Upload New Photo",
      "currentPhoto": "Current Photo",
      "changePasswordBtn": "Change Password",
      "editProfileBtn": "Edit Profile",
      "updateData": "Update Profile",
      "updatedSuccess": "Profile updated successfully.",
      "currentPassword": "Current Password",
      "currentPasswordPlaceholder": "Enter current password",
      "newPassword": "New Password",
      "newPasswordPlaceholder": "Enter new password (min. 6 characters)",
      "confirmPassword": "Confirm New Password",
      "confirmPasswordPlaceholder": "Re-enter new password",
      "confirmNewPassword": "Confirm New Password",
      "confirmNewPasswordPlaceholder": "Re-enter new password",
      "hidePassword": "Hide password",
      "showPassword": "Show password",
      "passwordMismatch": "New password and confirmation do not match.",
      "savePasswordBtn": "Update Password",
      "updatePassword": "Update Password",
      "passwordUpdatedSuccess": "Password updated successfully."
    },
    "studio": {
      "title": "Performance Quest & SOP Studio",
      "subtitle": "Transform business goals and operating procedures into engaging, verified daily quests, squad milestones, and fair incentives.",
      "badgeMaker": "PERFORMANCE STUDIO",
      "badgeAi": "Gemini AI Anti-Cheat Engine",
      "badgeSop": "Fast SOP to Quest Pipeline",
      "newQuestBtn": "+ Create New Quest",
      "gameSettingsBtn": "Game Settings & AI",
      "marketplaceBtn": "Realm Blueprints Market",
      "tabArchitect": "AI Quest & SOP Architect",
      "tabSimulator": "Live Mobile HUD Simulator",
      "tabEconomy": "Incentive Economy & Budget Guard",
      "tabAntiCheat": "AI Verification Queue",
      "architectTitle": "Smart SOP to Gamified Quest Generator",
      "architectDesc": "Define your business objective or paste an SOP. Gemini AI will structure the quest, cadence, self-checking QA checklist, and reward points automatically.",
      "targetGoalLabel": "Business Goal & SOP Objective",
      "targetGoalPlaceholder": "e.g. Sales B2B Follow-up & Closing: Minimum 5 client follow-ups daily and 2 demos weekly",
      "divisionLabel": "Target Division & Squad",
      "cadenceLabel": "Cadence & Frequency",
      "cadenceDaily": "Daily Habit (Routine SOP)",
      "cadenceWeekly": "Weekly Sprint (Milestone)",
      "cadenceQuarterly": "Quarterly Raid (Boss Target)",
      "rewardGoldLabel": "Reward Gold",
      "rewardXpLabel": "Reward XP",
      "cashEquivalent": "Equivalent to",
      "generateAiBtn": "Generate Formula with Gemini AI",
      "deployQuestBtn": "Deploy Quest to Player Realm",
      "checklistTitle": "Self-Checking QA Checklist (Player Verification)",
      "checklistDesc": "Employees must tick these points before submitting proof to ensure standard compliance.",
      "evidenceStandardLabel": "Verification Standard & Evidence Guide",
      "evidenceStandardPlaceholder": "e.g. Upload signed contract & DocuSign link & merged Git PR screenshot",
      "consequenceLabel": "Consequence & Missed Deadline Penalty",
      "consequenceDesc": "Deduct -50 XP if missed without approved medical/leave permit.",
      "presetsTitle": "Tested Industry SOP Presets",
      "presetsSub": "1-Click deploy proven performance formulas",
      "usePreset": "Use Formula",
      "simulatorTitle": "Live Player Mobile HUD Preview",
      "simulatorDesc": "Preview exactly how this quest, its rewards, and its self-checking checklist will look on an employee's smartphone.",
      "deviceHeader": "Player Quest Board",
      "activeMissionBadge": "ACTIVE QUEST",
      "tapToSubmit": "Tap to Complete Quest",
      "viewGuidelines": "View SOP Guidelines",
      "economyTitle": "Incentive Economy & Liability Calculator",
      "economyDesc": "Simulate monthly Gold liability, Rupiah redemption costs, and verify company reward budget limits.",
      "estMonthlyGold": "Est. Monthly Gold Distributed",
      "estLiability": "Rupiah Reward Liability",
      "budgetSafety": "Budget Guard Status",
      "budgetSafe": "Healthy & Within Budget Limit",
      "budgetWarning": "Warning: Reward liability approaches quota threshold",
      "dailyCap": "Daily Gold Earn Cap Per Player",
      "antiCheatTitle": "Gemini AI Vision Anti-Cheat Queue",
      "antiCheatDesc": "AI analyzes uploaded proof images (OCR text extraction, metadata timestamps, and duplicate perceptual hashing).",
      "batchApprove": "Batch Approve Verified",
      "allCleanTitle": "All Submissions Verified!",
      "allCleanSub": "No pending items. Management hours saved today.",
      "ocrConfidence": "Confidence",
      "antiCheatChecks": "Integrity Checks",
      "hashUnique": "Unique Hash (No Duplicate)",
      "hashDupe": "Potential Duplicate Image",
      "approveBtn": "Approve",
      "rejectBtn": "Reject",
      "addChecklistBtn": "+ Add Item",
      "aiFallbackCheck1": "Confirm deliverable meets documented SOP quality standards",
      "aiFallbackCheck2": "Verify output with the designated team lead",
      "aiFallbackCheck3": "Attach timestamped screenshot or official document link",
      "aiFallbackEvidence": "Submit verified completion evidence for: {goal}. Include a clear screenshot or system record link.",
      "aiFallbackName": "KPI Execution: {goal}",
      "aiHelperText": "Gemini AI analyzes your KPI objective and recommends balanced quest rewards and QA criteria.",
      "approveProofError": "Failed to approve quest submission.",
      "awaitingManualReview": "Awaiting manual verification by Game Maker.",
      "batchApproveSuccess": "Batch Verification Completed",
      "batchApproveSuccessDesc": "{count} high-confidence submissions (>= 85% AI match) have been approved.",
      "checklistItemPlaceholder": "e.g. Attach signed client document or merged PR link",
      "closePreview": "Close Preview",
      "colEmployee": "Employee",
      "colOcrVision": "OCR & AI Inspection",
      "colQuestSop": "Quest & SOP",
      "colUploadedProof": "Submitted Proof",
      "consequenceAutoDesc": "Accountability deduction for missed deadline or incomplete SOP execution on: {name}",
      "consequenceAutoName": "SOP Non-Compliance: {name}",
      "dailyCapNotice": "Each employee is capped at {cap} Gold per day under your workspace economy guard settings.",
      "defaultDivisionName": "General Division",
      "defaultPlayerName": "Team Member",
      "defaultQuestDescription": "Complete the assigned task in accordance with team SOP standards.",
      "defaultQuestSubmission": "Quest Submission",
      "formulaGeneratedDesc": "Quest title, incentive weights, and QA checklist items have been updated.",
      "formulaGeneratedTitle": "Quest Formula Synthesized",
      "goalEmptyDesc": "Please enter a business KPI target or SOP objective first.",
      "goalEmptyTitle": "Objective Required",
      "goldConversionLabel": "1 Gold Reference Value (Rupiah):",
      "keywordsLabel": "Detected Keywords",
      "manualReviewBadge": "Manual Review",
      "matchSuffix": "Match",
      "membersUnit": "Members",
      "monthlyProjectionTitle": "Projected Monthly Incentive Allocation",
      "presetApplied": "Preset Formula Applied",
      "proofApprovedToast": "Approved \"{name}\" (+{gold} Gold)",
      "proofRejectedDesc": "Reason recorded: \"{reason}\". The employee may submit revised evidence.",
      "proofRejectedTitle": "Submission Rejected",
      "questDeployErrorDesc": "An error occurred while publishing this quest to your workspace.",
      "questDeployFailed": "Failed to Publish Quest",
      "questDeployedDesc": "Quest \"{name}\" is now live in the employee mobile app.",
      "questDeployedTitle": "Quest Published to Workspace",
      "questNameRequired": "Quest Title is Required",
      "questTitleLabel": "Quest Title & Target Deliverable",
      "questTitlePlaceholder": "e.g. Enterprise B2B Daily Outreach & Deal Closure",
      "rejectProofBtn": "Reject Submission",
      "rejectProofError": "Failed to reject quest submission.",
      "rejectProofTitle": "Reject Quest Submission",
      "rejectReasonDefault": "Uploaded image is unclear or does not match required SOP verification criteria.",
      "rejectReasonLabel": "Provide clear feedback so the employee can resubmit valid proof:",
      "sampleEvidenceGuide": "Upload clear completion evidence following your team operational standard.",
      "sampleQuestTitle": "Sample Operational KPI Quest",
      "simCompletionRateLabel": "Expected Team Quest Completion Rate:",
      "simTeamSizeLabel": "Active Participating Employees:",
      "simulatorChecklistLabel": "Self-Verification QA Checklist:",
      "simulatorOnline": "LIVE PREVIEW",
      "sopEvidenceModalTitle": "Submitted SOP Evidence",
      "timestampPrefix": "Submitted: {time}",
      "timestampValid": "Timestamp verified",
      "xpHelperText": "Determines employee level progression and leaderboard rank",
      "zoomBtn": "Inspect"
    },
    "marketplace": {
      "badgeVirtual": "3D VIRTUAL WORKSPACE",
      "badgeInstantPay": "Instant Checkout (QRIS & VA)",
      "badgeHris": "HRIS Enterprise Integrated",
      "title": "Blueprint Catalog & Team Collaboration Realms",
      "subtitle": "Modern enterprise solution to supercharge employee engagement and team productivity. Deploy ready-to-use Game Realm configurations—complete with daily SOP targets, collaborative team challenges, reward systems, and performance leaderboards.",
      "creatorStudioBtn": "Creator Studio & Blueprint Forge",
      "tabCatalog": "Realm Galaxy Catalog",
      "tabInstalled": "Installed in Workspace",
      "activeRealmTitle": "Active Team Universe:",
      "activeRealmDeployed": "Deployed on {date} • All employees currently work on quests from this realm",
      "manageQuestsBtn": "Manage Team Quests",
      "searchPlaceholder": "Search realm, industry, or KPI metrics...",
      "noRealmsFound": "No matching blueprints found",
      "noRealmsDesc": "Try adjusting your search query or selecting a different category.",
      "deployBtn": "Deploy Setting",
      "freeLicense": "FREE BLUEPRINT",
      "orderNumber": "ORDER NO.",
      "purchasedRealm": "PURCHASED REALM",
      "totalPrice": "TOTAL PRICE",
      "paymentStatus": "PAYMENT STATUS",
      "paidDate": "PAID DATE",
      "action": "ACTION",
      "noTransactions": "No Realm Transactions Yet",
      "noTransactionsDesc": "No history of blueprint template purchases yet.",
      "statusPaid": "PAID & VERIFIED",
      "statusPending": "PENDING PAYMENT",
      "payNow": "Pay Now",
      "completed": "Done",
      "previewTitle": "Realm Blueprint Details",
      "licensePrice": "License Price:",
      "loreTitle": "Lore & Narrative Framework",
      "worldZonesTitle": "Open-World Progression Zones",
      "presetQuestsTitle": "Included SOP Quests & Boss DMG",
      "bossRaidTitle": "World Boss Raid Challenge",
      "bossRaidSubtitle": "Quarterly team target personified into a raid monster",
      "closeBtn": "Close",
      "deployNowBtn": "Deploy This Blueprint Now",
      "buyAndDeployBtn": "Proceed to Checkout & Deploy",
      "checkoutTitle": "Digital Payment Checkout",
      "checkoutSubtitle": "Premium Game Setting License",
      "paymentDesc": "Automatic real-time verification via QRIS, Virtual Account (BCA, Mandiri, BRI, BNI), and e-Wallets.",
      "openPaymentUrl": "Open Secure Payment Page",
      "simulatePayment": "Simulate & Verify Payment Clearance",
      "licensedGateway": "Bank Indonesia Licensed Gateway",
      "cancelBtn": "Cancel",
      "studioTitle": "Enterprise Blueprint Forge: Design Performance Blueprint",
      "studioSubtitle": "Architect balanced performance formulas, SOP questlines, and team boss raids tailored to your industry.",
      "presetSelectTitle": "Quick 1-Click Industry Presets:",
      "presetSales": "SaaS B2B Sales Hunter",
      "presetDevOps": "Zero-Defect DevOps & SRE",
      "presetSupport": "CSAT 98% Customer Champion",
      "presetRetail": "Retail & Store Operations",
      "presetOnboarding": "New Hire Onboarding Flight",
      "aiPromptLabel": "AI Formula Architect (Prompt to Questline):",
      "aiPromptPlaceholder": "e.g., Accelerate sales closing by 30% and verify CRM deal contracts...",
      "aiGenerateBtn": "Generate AI Formula",
      "blueprintTitleLabel": "Blueprint Title & SOP Framework",
      "blueprintTitlePlaceholder": "e.g. SaaS B2B Revenue Hunter Framework & Zero-Defect DevOps Blueprint",
      "categoryLabel": "Department & Guild Category",
      "themeLabel": "Execution & Aesthetic Theme",
      "descLabel": "Business Impact & Description",
      "descPlaceholder": "Describe this performance formula: what metrics are boosted and how it guides the team...",
      "questsTableTitle": "Interactive Questline Builder",
      "questNameCol": "Quest Name & Target SOP",
      "questTypeCol": "Cadence",
      "questGoldCol": "Gold",
      "questXpCol": "XP",
      "questBossDmgCol": "Boss DMG",
      "addQuestBtn": "+ Add Quest",
      "bossRaidSectionTitle": "Collective Division Objective (Boss Raid)",
      "bossNameLabel": "Boss Titan Objective Name",
      "bossNamePlaceholder": "e.g. The Q4 Revenue Titan (Rp 1.5 Billion Target)",
      "bossHpLabel": "Target Pool HP",
      "bossRewardPoolLabel": "Pooled Gold Reward",
      "priceLabel": "Blueprint License Price (Rp)",
      "priceHelp": "0 for free & open source blueprint",
      "deployDirectBtn": "Deploy Directly to Workspace (1-Click)",
      "publishMarketplaceBtn": "Publish to Marketplace Catalog",
      "deployDirectSuccess": "Blueprint Deployed to Workspace!",
      "deployDirectSuccessMsg": "All quests and the team boss raid have been activated in your team workspace.",
      "publishSuccess": "Game Setting Published!",
      "publishSuccessMsg": "Your blueprint is now live in the marketplace catalog for other Game Makers to discover.",
      "activeInWorkspaceBadge": "Active in Workspace",
      "aiHelperText": "Gemini AI structures KPI quests, Gold weights, and Boss Raid milestones from your prompt.",
      "archivedStatus": "Archived",
      "catAll": "All Categories",
      "catCulture": "Culture & Onboarding",
      "catCultureTeam": "People & Culture",
      "catEngineering": "Engineering & DevOps",
      "catEngineeringSquad": "Engineering & DevOps",
      "catOperations": "Retail & Operations",
      "catOperationsTeam": "Operations & Logistics",
      "catSales": "Sales & Revenue",
      "catSalesGuild": "Sales & Revenue",
      "catSupport": "Customer Support",
      "catSupportTeam": "Customer Experience",
      "categoryAndThemeMeta": "Category: {category} • Theme: {theme}",
      "colCategoryTheme": "Category & Theme",
      "colInstalledDate": "Installed Date",
      "colRealmSetting": "Blueprint Name",
      "defaultBossName": "Quarterly Team Target",
      "generalCat": "General Operations",
      "loadingCatalog": "Loading blueprint catalog...",
      "newQuestDefaultTitle": "Complete Verified Daily KPI Deliverable",
      "noInstalledDesc": "Deploy a blueprint from the Marketplace Catalog or synthesize one with AI to populate your workspace.",
      "noInstalledTitle": "No Installed Blueprints Yet",
      "orderIdLabel": "Order Reference",
      "purchaseHistoryTitle": "Blueprint Acquisition & License History",
      "purchasedBadge": "Licensed",
      "questRowPlaceholder": "Enter measurable KPI quest title...",
      "questsCountUnit": "Quests",
      "reactivateBtn": "Re-Deploy",
      "realmPrefix": "Blueprint:",
      "removeQuestTitle": "Remove quest row",
      "rewardPoolBadge": "Reward Pool",
      "standardTheme": "Corporate Standard",
      "teamsUnit": "workspaces",
      "themeAgile": "Agile Sprint Execution",
      "themeCorporate": "Executive KPI Governance",
      "themeDiscipline": "Operational Excellence & QA",
      "themeRaid": "Collaborative Team Milestone",
      "typeDaily": "Daily",
      "typeSprint": "Sprint",
      "typeWeekly": "Weekly",
      "unrated": "New"
    },
    "footer": {
      "tagline": "Enterprise Workforce Gamification Platform",
      "editionBadge": "Enterprise Suite v2.5"
    }
  },
  "id": {
    "nav": {
      "platformOverview": "Ikhtisar Platform",
      "tenantManagement": "Manajemen Mitra",
      "billingAndFinance": "Langganan & Pembayaran",
      "systemAndSecurity": "Direktori Pengguna",
      "companyWorkspace": "Ruang Kerja Perusahaan",
      "dashboard": "Dashboard Platform",
      "clientCompanies": "Perusahaan Mitra (Klien)",
      "createCompany": "Daftarkan Mitra Baru",
      "subscriptionPackages": "Paket Langganan",
      "billingApprovals": "Verifikasi Invoice Transfer",
      "playerQuota": "Alokasi Kuota Pemain",
      "paymentChannels": "Kanal Pembayaran",
      "discountVouchers": "Kupon Diskon",
      "globalUsers": "Master Pengguna Platform",
      "systemAuditLogs": "Audit Log Sistem",
      "gameRealms": "Marketplace Virtual Realms",
      "ownerAnalytics": "Analitik Eksekutif",
      "makerStudio": "Studio Operasional",
      "gameSettings": "Pusat Pengaturan Game",
      "squads": "Skuad & Divisi",
      "rules": "Misi & Target KPI",
      "quests": "Misi & Target KPI",
      "consequences": "Sanksi SOP",
      "compensations": "Misi Pemulihan",
      "approvals": "Pusat Verifikasi (Approval)",
      "questApprovals": "Pengajuan Misi & Target KPI",
      "consequenceApprovals": "Sanksi SOP",
      "punishmentApprovals": "Laporan Pelanggaran",
      "compensationApprovals": "Misi Pemulihan",
      "rewardShop": "Katalog Hadiah (Reward Shop)",
      "gamePlayer": "Karyawan (Player)",
      "gameMaker": "Game Maker (Manajer)",
      "inboundLeads": "Registrasi & Leads Masuk",
      "gameBenchmarks": "Benchmark Game Setting",
      "creatorEcosystem": "Ekosistem Kreator",
      "superadminSection": "Manajemen Platform",
      "ownerSection": "Manajemen Perusahaan Mitra",
      "makerSection": "Studio Operasional Game",
      "companyPersonnel": "Personel Perusahaan",
      "glossary": "Glosarium & Panduan Sistem",
      "profileSettings": "Pengaturan Profil",
      "companyBilling": "Langganan Perusahaan",
      "logOut": "Keluar",
      "platformOperator": "Operator Platform",
      "enterpriseMember": "Anggota Perusahaan",
      "defaultUserName": "Pengguna Ruang Kerja",
      "openMenu": "Buka menu navigasi",
      "realmGuildMaster": "Studio Operasional",
      "realmRoyalCommand": "Komando Eksekutif",
      "realmSovereign": "Administrasi Platform",
      "roleMaker": "Game Maker",
      "roleOwner": "Pemilik Ruang Kerja",
      "toggleSidebar": "Alihkan bilah navigasi samping"
    },
    "leads": {
      "title": "Inbound Leads & Registrasi Mitra",
      "subtitle": "Kelola pengajuan demo dan uji coba dari landing page publik, kualifikasi prospek, dan konversi menjadi workspace perusahaan aktif.",
      "totalInbound": "Total Leads Masuk",
      "fromPublicLanding": "Diajukan melalui formulir landing page",
      "newLeads": "Belum Dihubungi",
      "qualified": "Prospek Terkualifikasi",
      "converted": "Perusahaan Aktif",
      "statusNew": "Baru Masuk",
      "statusContacted": "Sudah Dihubungi",
      "statusQualified": "Terkualifikasi",
      "statusConverted": "Terkonversi",
      "statusRejected": "Ditolak",
      "searchPlaceholder": "Cari perusahaan, nama kontak, email...",
      "company": "Perusahaan (Mitra)",
      "contactPerson": "Penanggung Jawab",
      "channels": "Saluran Langsung",
      "convertBtn": "Konversi ke Mitra",
      "deleteConfirm": "Apakah Anda yakin ingin menghapus data lead ini?",
      "modalTitle": "Detail Lead & Konversi Klien",
      "notesPlaceholder": "Tambahkan catatan follow-up sales atau konsultasi...",
      "emptyTitle": "Belum Ada Leads Masuk",
      "emptyDesc": "Pengajuan demo dan registrasi uji coba klien baru dari landing page akan muncul di sini.",
      "detailTitle": "Detail Registrasi Masuk",
      "workEmail": "Email Perusahaan",
      "whatsappPhone": "No. WhatsApp",
      "teamSize": "Ukuran Tim",
      "inquiryMessage": "Pesan & Tujuan Kebutuhan",
      "noMessage": "Tidak ada catatan khusus.",
      "openWhatsApp": "Buka WhatsApp Konsultasi",
      "closeModal": "Tutup",
      "confirmConvertTitle": "Konversi Menjadi Mitra Resmi?",
      "confirmConvertText": "Apakah Anda yakin ingin mengonversi \"{company}\" menjadi Mitra Resmi Gamiteam? Sistem akan membuat ruang kerja dan akun Owner baru.",
      "convertSuccessTitle": "Mitra Berhasil Dikonversi!",
      "convertSuccessText": "Perusahaan \"{company}\" telah dibuat dengan akun Game Owner: {email}.",
      "viewCompanyBtn": "Lihat Detail Perusahaan",
      "markNew": "Tandai Baru",
      "markContacted": "Tandai Dihubungi",
      "markQualified": "Tandai Terkualifikasi",
      "markRejected": "Tandai Ditolak",
      "awaitingContact": "Menunggu Dihubungi",
      "slaHours": "SLA < 24 Jam",
      "readyConversion": "Siap dikonversi ke mitra",
      "activeEnterprises": "Mitra Perusahaan Aktif"
    },
    "benchmarks": {
      "title": "Benchmark Game Setting & Telemetri Platform",
      "subtitle": "Telemetri menyeluruh platform: tingkat penyelesaian quest, kedisiplinan SOP per divisi, dan perpustakaan blueprint master resmi.",
      "createTemplateBtn": "+ Buat Blueprint Master",
      "topFramework": "Framework Terbaik",
      "topFrameworkSub": "tingkat keterlibatan rata-rata",
      "optimalCycle": "Siklus Quest Optimal",
      "optimalCycleSub": "Rentang waktu dengan penyelesaian tertinggi",
      "avgCompletion": "Rata-rata Penyelesaian Global",
      "aboveIndustryAverage": "Di atas rata-rata industri (87%)",
      "goldPool": "Sirkulasi Gold di Sistem",
      "goldPoolSub": "Total ekonomi poin gamifikasi aktif",
      "divisionTitle": "Heatmap Efektivitas Gamifikasi Lintas Divisi",
      "divisionSubtitle": "Perbandingan performa dan kepatuhan SOP di setiap departemen perusahaan klien.",
      "completionRate": "SLA Penyelesaian Quest",
      "sopAdherence": "Kepatuhan SOP & Tata Tertib",
      "topRulesTitle": "Peringkat Aturan Gamifikasi Terbaik",
      "topRulesSub": "Aturan dengan adopsi tertinggi dan dampak paling positif pada produktivitas.",
      "ruleName": "Nama Aturan Gamifikasi",
      "rewards": "Imbalan XP & Gold",
      "impact": "SLA Selesai",
      "blueprintsTitle": "Perpustakaan Blueprint Master Resmi",
      "blueprintsSub": "Templat gamifikasi kurasi Gamiteam HQ yang dapat langsung diadopsi oleh perusahaan mitra.",
      "previewJson": "Lihat JSON",
      "noTemplatesFound": "Belum ada templat blueprint untuk industri ini.",
      "createTemplateModalTitle": "Buat Blueprint Master Resmi",
      "editTemplateModalTitle": "Ubah Blueprint Master",
      "templateTitle": "Judul Blueprint",
      "industry": "Industri",
      "blueprintJson": "Spesifikasi Blueprint (JSON)",
      "activeQuestsLabel": "Misi Aktif",
      "adoptionsLabel": "Adopsi",
      "allIndustries": "Semua Industri",
      "approvedSubmissionsSub": "Pengajuan misi yang disetujui",
      "avgEngagementLabel": "Rata-rata Tingkat Partisipasi",
      "badgeFeatured": "Unggulan",
      "badgeOfficial": "Resmi",
      "benchmarkSlaLabel": "Target Tolok Ukur",
      "crossTenantNormalized": "Dinormalisasi lintas ruang kerja aktif",
      "deleteBlueprintTitle": "Hapus Cetak Biru",
      "deleteTemplateConfirmMsg": "Cetak biru utama ini akan dihapus permanen dari katalog tolok ukur.",
      "deleteTemplateErrorMsg": "Gagal menghapus templat cetak biru.",
      "deleteTemplateSuccessMsg": "Cetak biru utama berhasil dihapus.",
      "editBlueprintTitle": "Ubah Cetak Biru Utama",
      "engagementScoreLabel": "Tingkat Partisipasi",
      "featuredMarketplaceCheck": "Tampilkan sebagai unggulan di Katalog Marketplace",
      "indFintech": "Fintech & Perbankan",
      "indHealthcare": "Kesehatan & Perhotelan",
      "indOps": "Ritel & Operasional Lapangan",
      "indSales": "Penjualan B2B & Pendapatan",
      "indTech": "Rekayasa Perangkat Lunak & DevOps",
      "invalidJsonMsg": "Konfigurasi JSON aturan tidak valid. Harap masukkan format objek atau larik JSON yang benar.",
      "masterBlueprintSpec": "Spesifikasi Cetak Biru Utama",
      "noDataYet": "Belum Ada Data",
      "officialTemplateCheck": "Tandai sebagai Cetak Biru Resmi Gamiteam",
      "rulesCountLabel": "Jumlah Misi",
      "rulesCountSuffix": "misi",
      "saveTemplateErrorMsg": "Gagal menyimpan templat cetak biru.",
      "saveTemplateSuccessMsg": "Templat cetak biru berhasil disimpan.",
      "searchBlueprint": "Cari judul cetak biru, kategori, atau industri...",
      "templateDescPlaceholder": "Jelaskan sasaran KPI, tim sasaran, serta ritme operasional...",
      "templateTitlePlaceholder": "Contoh: Akselerasi Pendapatan B2B Korporat"
    },
    "creators": {
      "title": "Ekosistem Kreator & Bagi Hasil Komisi",
      "subtitle": "Kelola kreator game, seleksi pengajuan mitra, pembagian komisi pendapatan (70/30), dan verifikasi pencairan saldo.",
      "tabLeaderboard": "Hall of Fame Kreator",
      "tabApplications": "Pengajuan Partner Baru",
      "tabRevenueShare": "Pengaturan Bagi Hasil",
      "tabPayouts": "Antrean Pencairan Dana",
      "totalVerifiedCreators": "Kreator Terverifikasi",
      "totalBlueprintsInstalled": "Blueprint Terinstal",
      "totalCreatorEarnings": "Total Komisi Dibayarkan",
      "platformCommissionCut": "Bagi Hasil Gamiteam HQ",
      "hallOfFameTitle": "Peringkat Kreator Terbaik (Hall of Fame)",
      "hallOfFameSub": "Diurutkan berdasarkan jumlah adopsi templat, ulasan kepuasan, dan sertifikasi resmi.",
      "creatorName": "Kreator Mitra",
      "specialization": "Spesialisasi",
      "rating": "Rating & Ulasan",
      "adoptions": "Adopsi Mitra",
      "earnings": "Total Penghasilan",
      "applicationsTitle": "Pengajuan Calon Partner Kreator",
      "applicationsSub": "Desainer gamifikasi dan konsultan HR yang mendaftar dari landing page publik.",
      "applicant": "Calon Mitra",
      "portfolio": "Tautan Portofolio",
      "proposalConcept": "Konsep Desain Gamifikasi",
      "noApplicationsFound": "Tidak ada pengajuan partner baru.",
      "commissionSetupTitle": "Konfigurasi Global Pembagian Komisi",
      "commissionSetupSub": "Tentukan rasio bagi hasil standar antara kreator komunitas dan Gamiteam Platform HQ.",
      "creatorPercentLabel": "Bagi Hasil Kreator (%)",
      "platformPercentLabel": "Bagi Hasil Gamiteam Platform HQ (%)",
      "minPayoutLabel": "Batas Minimum Pencairan Dana",
      "payoutScheduleLabel": "Jadwal Pemrosesan Pencairan",
      "saveConfigBtn": "Simpan Konfigurasi Komisi",
      "simCalculatorTitle": "Kalkulator Simulasi Bagi Hasil Interaktif",
      "simCalculatorSub": "Hitung estimasi pembagian pendapatan antara Kreator dan Gamiteam HQ secara real-time.",
      "payoutQueueTitle": "Antrean Pengajuan Pencairan Dana Kreator",
      "payoutQueueSub": "Verifikasi dan proses pembayaran komisi ke rekening bank kreator yang terdaftar.",
      "grossAmount": "Jumlah Bruto",
      "netPayout": "Transfer Bersih (Net)",
      "bankDetails": "Rekening Bank Penerima",
      "simPriceLabel": "Simulasi Harga Template",
      "simVolumeLabel": "Volume Penjualan & Adopsi",
      "simTotalRevenue": "Simulasi Omset Kotor",
      "simCreatorTakes": "Bagi Hasil Kreator",
      "simPlatformTakes": "Margin Bersih Platform",
      "approveApplication": "Setujui Kreator",
      "rejectApplication": "Tolak Permohonan",
      "reviewNotes": "Catatan Peninjauan",
      "reviewModalTitle": "Tinjau Permohonan Mitra Kreator",
      "confirmApproveCreator": "Konfirmasi verifikasi dan sertifikasi mitra kreator?",
      "adoptedByEnterprises": "Diadopsi lintas ruang kerja aktif",
      "approveAndPay": "Verifikasi & Cairkan Komisi",
      "approveSuccessMsg": "Pengajuan kreator telah disetujui dan tersertifikasi.",
      "autoCalculatedHint": "Dihitung otomatis agar total pembagian tepat 100%",
      "bankTransferRefLabel": "Nomor Referensi Transfer Bank",
      "certifiedCreators": "Kreator Tersertifikasi",
      "commissionPaidLabel": "Total Royalti Kreator Tersalurkan",
      "confirmPayoutText": "Konfirmasi pencairan sebesar {amount} kepada {name} ({bank} - {account}).",
      "defaultApproveNotes": "Portofolio dan cetak biru KPI telah diverifikasi sesuai standar kualitas platform.",
      "defaultRejectNotes": "Pengajuan cetak biru memerlukan kriteria verifikasi KPI terukur yang lebih jelas.",
      "distributedToPartners": "Pencairan royalti mitra kreator selesai",
      "hqMargin": "Porsi Platform",
      "minPayoutHint": "Batas minimal pencairan royalti dalam Rupiah",
      "noNotes": "Belum ada catatan peninjau",
      "noPayoutsFound": "Tidak ada pengajuan pencairan royalti yang sesuai filter.",
      "payoutErrorMsg": "Gagal memproses pencairan royalti kreator.",
      "payoutFeeNotice": "Pastikan transfer bank telah diselesaikan sebelum menyimpan nomor referensi.",
      "payoutSuccessMsg": "Pencairan royalti berhasil dicatat lunas dan terekam pada log audit.",
      "rank": "Peringkat",
      "refPrefix": "Ref:",
      "rejectSuccessMsg": "Pengajuan kreator ditolak beserta catatan evaluasi.",
      "revenueSaveErrorMsg": "Gagal menyimpan kebijakan bagi hasil.",
      "revenueSaveSuccessMsg": "Kebijakan bagi hasil kreator berhasil diperbarui.",
      "reviewErrorMsg": "Gagal menyimpan keputusan peninjauan.",
      "reviewNotesPlaceholder": "Tuliskan catatan evaluasi objektif untuk pemohon...",
      "reviewedPrefix": "Ditinjau:",
      "reviewsLabel": "ulasan",
      "scheduleBiweekly": "Dua Mingguan (Tanggal 1 & 15)",
      "scheduleMonthly": "Bulanan (Batas Tanggal 25)",
      "scheduleWeekly": "Mingguan (Setiap Jumat)",
      "searchApplicant": "Cari nama pemohon, email, atau spesialisasi...",
      "searchPayout": "Cari nama kreator, bank, atau nomor referensi...",
      "statusProcessed": "Dicairkan",
      "tierCreator": "Kreator {tier}",
      "transferNet": "Royalti Bersih",
      "unrated": "Belum Dinilai",
      "verifiedPartnerTitle": "Mitra Cetak Biru Terverifikasi",
      "workspacesLabel": "ruang kerja"
    },
    "audit": {
      "title": "Audit Log Keamanan & Sistem",
      "subtitle": "Catatan telemetri seluruh aktivitas registrasi mitra, verifikasi invoice, perubahan kuota, dan peristiwa admin.",
      "exportCsv": "Ekspor CSV",
      "totalEvents": "Total Log Peristiwa",
      "billingEvents": "Verifikasi Invoice",
      "tenantEvents": "Peristiwa Mitra",
      "securityLogins": "Audit Akses & Keamanan",
      "searchPlaceholder": "Cari event, aktor, mitra, atau IP...",
      "allCategories": "Semua Kategori",
      "catTenant": "Mitra Perusahaan",
      "catBilling": "Keuangan & Billing",
      "catSecurity": "Keamanan & Akses",
      "catSystem": "Konfigurasi Sistem",
      "allSeverities": "Semua Tingkat Keparahan",
      "colTimestamp": "Waktu",
      "colEvent": "Peristiwa & Tindakan",
      "colTarget": "Target Objek",
      "colActor": "Aktor Pelaksana",
      "colIp": "Alamat IP",
      "colSeverity": "Tingkat",
      "emptyTitle": "Tidak Ada Audit Log Ditemukan",
      "emptyDesc": "Tidak ada catatan aktivitas platform yang cocok dengan kriteria filter.",
      "sevDanger": "Kritis",
      "sevInfo": "Informasi",
      "sevSuccess": "Terverifikasi",
      "sevWarning": "Peringatan"
    },
    "superadmin": {
      "title": "Pusat Operasional Platform Gamiteam",
      "subtitle": "Kontrol Utama SaaS: Manajemen perusahaan mitra, pendapatan berulang, paket langganan, dan telemetri sistem.",
      "mrr": "Pendapatan Berulang Bulanan (MRR)",
      "totalRevenue": "Total Pendapatan Platform",
      "activeTenants": "Mitra Perusahaan Aktif",
      "totalGlobalUsers": "Total Pengguna Platform",
      "totalGlobalPlayers": "Total Karyawan (Players)",
      "totalGlobalMakers": "Total Manajer (Makers)",
      "pendingInvoices": "Invoice Menunggu Verifikasi",
      "platformHealth": "Kesehatan Layanan Platform",
      "allCompanies": "Daftar Perusahaan Mitra",
      "searchCompanies": "Cari nama perusahaan, pemilik, atau email...",
      "companyName": "Perusahaan (Mitra)",
      "ownerContact": "Game Owner (Kontak)",
      "currentPlan": "Paket Aktif",
      "playerQuota": "Kuota Karyawan",
      "subscriptionStatus": "Status Langganan",
      "healthStatus": "Kondisi Keaktifan",
      "actions": "Aksi",
      "pendingBillingTitle": "Invoice Transfer Menunggu Konfirmasi",
      "pendingBillingDesc": "Pembayaran langganan transfer bank manual yang membutuhkan verifikasi Superadmin.",
      "approvePayment": "Verifikasi & Aktifkan",
      "rejectPayment": "Tolak Pembayaran",
      "invoiceNumber": "No. Invoice",
      "package": "Paket",
      "amount": "Nominal",
      "date": "Tanggal",
      "paymentMethod": "Metode Pembayaran",
      "noPendingInvoices": "Tidak ada pembayaran yang menunggu verifikasi.",
      "revenueTrendTitle": "Performa Pendapatan 12 Bulan",
      "quickStats": "Indikator Kinerja Utama Platform",
      "globalCompletionRate": "Tingkat Penyelesaian Quest Global",
      "totalGoldInCirculation": "Total Gold Beredar di Sistem",
      "onboardClientBtn": "+ Daftarkan Perusahaan Mitra",
      "planStarter": "Starter",
      "planGrowth": "Growth",
      "planEnterprise": "Enterprise",
      "statusActive": "Aktif",
      "statusExpiring": "Segera Berakhir",
      "statusExpired": "Kedaluwarsa",
      "statusTrial": "Uji Coba Gratis",
      "companyDetails": "Detail Perusahaan Mitra",
      "companyTelemetry": "Telemetri & Kesehatan Perusahaan",
      "companyInfo": "Profil Perusahaan",
      "joinDate": "Tanggal Bergabung",
      "registeredEmail": "Email Admin Perusahaan",
      "ownerName": "Nama Game Owner",
      "phoneNumber": "Nomor Telepon atau WhatsApp",
      "playerQuotaUsage": "Alokasi Kuota Karyawan",
      "activeUsers7d": "Pengguna Aktif (7 Hari Terakhir)",
      "activityRatio": "Tingkat Keaktifan (Engagement)",
      "totalRulesConfigured": "Jumlah Aturan Gamifikasi",
      "questSubmissionsCount": "Total Pengajuan Quest",
      "completionSuccessRate": "Rasio Keberhasilan Misi",
      "daysUntilExpiry": "Hari Menuju Jatuh Tempo",
      "editCompany": "Ubah Data Mitra",
      "deleteCompany": "Hentikan Layanan Mitra (Offboard)",
      "confirmDeleteCompany": "Apakah Anda yakin ingin menghapus perusahaan mitra ini? Seluruh data workspace terkait akan diarsipkan.",
      "onboardNewCompany": "Daftarkan Perusahaan Mitra Baru",
      "onboardSubtitle": "Registrasi klien baru, alokasikan kuota pemain awal, dan siapkan workspace khusus.",
      "companyLogo": "Logo Brand Perusahaan",
      "selectSubscriptionPlan": "Pilih Paket Langganan",
      "initialPaymentStatus": "Status Pembayaran Awal",
      "initialPaymentPaid": "Lunas & Langsung Aktif",
      "initialPaymentUnpaid": "Menunggu Pembayaran (Transfer Manual)",
      "packagesTitle": "Paket Langganan SaaS",
      "packagesSubtitle": "Atur batas kuota, harga per kursi/pengguna, dan fitur paket untuk perusahaan mitra.",
      "createPackage": "Buat Paket Langganan",
      "editPackage": "Ubah Paket Langganan",
      "packageName": "Nama Paket",
      "pricePerSeatMonth": "Harga per Kursi per Bulan",
      "maxUserSeats": "Batas Maksimal Pengguna (Kuota)",
      "packageDescription": "Deskripsi Paket & Fitur Termasuk",
      "confirmDeletePackage": "Apakah Anda yakin ingin menghapus paket langganan ini?",
      "discountsTitle": "Voucher & Kupon Promo Diskon",
      "discountsSubtitle": "Kelola kode promosi pemasaran, diskon persentase, dan potongan harga tetap untuk tagihan klien.",
      "createDiscount": "Buat Kode Promo",
      "editDiscount": "Ubah Kode Promo",
      "discountCode": "Kode Promo",
      "discountType": "Tipe Diskon",
      "discountValue": "Nilai Diskon",
      "percentage": "Persentase (%)",
      "flatAmount": "Nominal Tetap (Rp)",
      "usageLimit": "Batas Maksimal Penukaran",
      "expiryDate": "Tanggal Kedaluwarsa",
      "confirmDeleteDiscount": "Apakah Anda yakin ingin menghapus kupon diskon ini?",
      "platformPlayersTitle": "Direktori Karyawan Platform (Players)",
      "platformPlayersSubtitle": "Direktori global seluruh karyawan lintas perusahaan mitra yang berpartisipasi dalam quest gamifikasi.",
      "platformMakersTitle": "Direktori Manajer Platform (Makers)",
      "platformMakersSubtitle": "Direktori global seluruh manajer dan pembuat aturan quest lintas perusahaan mitra.",
      "assignedCompany": "Perusahaan Mitra (Tenant)",
      "squadDivision": "Skuad & Divisi",
      "userLevel": "Level",
      "userXp": "Poin XP",
      "goldBalance": "Gold",
      "gamiteamHq": "GAMITEAM HQ • OPERATOR PLATFORM",
      "allSystemsNominal": "Seluruh Sistem Normal",
      "allTimeBillingVolume": "Total volume tagihan platform sepanjang masa",
      "viewAllEnterprises": "Lihat semua mitra perusahaan →",
      "tenants": "Mitra",
      "activeEconomy": "Ekonomi Aktif",
      "acrossAllTenants": "Lintas Seluruh Mitra",
      "liveRules": "Aturan Aktif",
      "platformRules": "Aturan Gamifikasi Platform",
      "monthlyBilledVolume": "Volume tagihan langganan bulanan di seluruh organisasi klien",
      "allTime": "Total",
      "viewAllInvoices": "Lihat Seluruh Invoice & Tagihan →",
      "onlineGateway": "Gerbang Pembayaran Daring",
      "manualTransfer": "Transfer Bank (Manual)",
      "confirmActivationTitle": "Verifikasi & Aktifkan Langganan?",
      "confirmActivationText": "Apakah Anda yakin ingin memverifikasi invoice #{invoice} untuk {company}? Ini akan langsung mengaktifkan langganan klien.",
      "confirmActivationBtn": "Ya, Verifikasi & Aktifkan!",
      "rejectionReasonLabel": "Alasan Penolakan *",
      "rejectionReasonPlaceholder": "Contoh: Bukti transfer buram, nominal tidak sesuai, atau mutasi belum masuk rekening bank.",
      "confirmRejection": "Konfirmasi Penolakan",
      "healthy": "Optimal",
      "roleScope": "Cakupan Peran",
      "operationalMaker": "Game Maker (Manajer)",
      "noPlayersFound": "Tidak Ada Data Player Ditemukan",
      "noPlayersDesc": "Tidak ada catatan player karyawan yang cocok dengan kriteria filter.",
      "noMakersFound": "Tidak Ada Data Game Maker Ditemukan",
      "noMakersDesc": "Tidak ada Game Maker (Manajer) operasional yang cocok dengan kriteria filter.",
      "noDiscountsFound": "Tidak Ada Voucher Promo Ditemukan",
      "noDiscountsDesc": "Belum ada kode diskon yang dikonfigurasi. Buat kode promo untuk penagihan klien.",
      "createPromoCode": "+ Buat Kode Promo",
      "paymentChannelsTitle": "Metode Pembayaran & Gateway",
      "paymentChannelsSubtitle": "Konfigurasi saluran pembayaran gateway transfer bank, e-wallet, dan paket langganan perusahaan.",
      "createPaymentMethod": "Tambah Metode Pembayaran",
      "editPaymentMethod": "Edit Metode Pembayaran",
      "detailPaymentMethod": "Detail Saluran Pembayaran",
      "paymentMethodName": "Nama Metode & Saluran",
      "channelCode": "Kode Saluran",
      "baseFee": "Biaya Dasar",
      "channelInfo": "Informasi Saluran Pembayaran",
      "noPaymentsFound": "Belum Ada Metode Pembayaran",
      "noPaymentsDesc": "Tambahkan konfigurasi gateway pembayaran atau rekening transfer untuk klien.",
      "discountDetailTitle": "Detail Kupon Diskon",
      "discountDetailSubtitle": "Informasi spesifikasi voucher promo, batasan pemakaian, dan status masa berlaku.",
      "editDiscountBtn": "Edit Kupon",
      "deleteDiscountBtn": "Hapus Kupon",
      "confirmDeleteDiscountTitle": "Hapus Kupon Diskon?",
      "confirmDeleteDiscountText": "Kupon \"{code}\" akan dihapus permanen.",
      "discountDeletedSuccess": "Kupon diskon telah dihapus.",
      "invoiceVerificationDetail": "Detail Verifikasi Invoice",
      "destinationBank": "Bank Tujuan Transfer",
      "baseAmount": "Nominal Tagihan",
      "discountVoucher": "Voucher Diskon",
      "totalTransferAmount": "Total Jumlah Transfer",
      "paymentTransferSlip": "Bukti Transfer Pembayaran",
      "noProofUploaded": "Belum ada bukti transfer diunggah",
      "billingPeriod": "Periode Tagihan",
      "duration": "Durasi",
      "confirmApproveInvoiceTitle": "Setujui & Aktifkan Langganan?",
      "confirmApproveInvoiceText": "Konfirmasi verifikasi invoice #{invoice}? Langganan mitra akan langsung aktif.",
      "approveSuccessText": "Invoice #{invoice} berhasil disetujui dan langganan aktif.",
      "securityAndAllocation": "Keamanan & Alokasi Ruang Kerja",
      "initialPassword": "Kata Sandi Awal",
      "subscriptionTerms": "Ketentuan Langganan & Tagihan",
      "chooseLogoFile": "Pilih logo perusahaan (PNG, JPG, SVG)...",
      "logoRecommendation": "Disarankan: PNG transparan atau SVG, maks 2MB.",
      "quickTopupSuccess": "Alokasi kuota mitra berhasil diperbarui!",
      "activeMrrLabel": "Pendapatan Berulang Bulanan Aktif",
      "activeUntilPrefix": "Aktif hingga",
      "allCompaniesSub": "Ruang kerja perusahaan terdaftar",
      "approveErrorMsg": "Gagal menyetujui transaksi pembayaran.",
      "approveInvoiceError": "Gagal menyetujui faktur penagihan.",
      "approveSuccessMsg": "Langganan berhasil diaktifkan untuk {company}.",
      "approvedLower": "disetujui",
      "chartRevenueAxis": "Pendapatan (IDR)",
      "chartRevenueSeries": "Pendapatan Langganan Lunas",
      "clientFallback": "Klien Perusahaan",
      "createdPrefix": "Dibuat",
      "defaultClientName": "Klien Perusahaan",
      "healthInactive": "Tidak Aktif",
      "healthWarningActivity": "Aktivitas Rendah",
      "healthWarningSub": "Masa Langganan Segera Berakhir",
      "invoiceRejectedMsg": "Faktur ditolak dan pemberitahuan telah dikirim ke perusahaan.",
      "invoiceRejectedTitle": "Faktur Ditolak",
      "invoicesCountLabel": "Faktur",
      "managersLabel": "Manajer",
      "monthsLabel": "bulan",
      "noActivePlan": "Belum Berlangganan",
      "noExpirySet": "Tanpa batas tanggal",
      "ownersLabel": "Pemilik",
      "playersLabel": "Pemain",
      "quotaPrefix": "Kuota Kursi:",
      "rejectErrorMsg": "Gagal menolak faktur.",
      "rejectInvoiceError": "Gagal menolak faktur penagihan.",
      "rejectSuccessText": "Transaksi penagihan telah ditolak dan tercatat.",
      "searchInvoicesPlaceholder": "Cari nomor faktur, perusahaan, atau paket...",
      "standardPlan": "Paket Standar",
      "trialPlan": "Ruang Kerja Uji Coba",
      "usersLabel": "pengguna"
    },
    "auth": {
      "loginTitle": "Masuk ke Platform Gamiteam",
      "loginSubtitle": "Platform Gamifikasi & Motivasi Karyawan Enterprise",
      "emailLabel": "Email Perusahaan",
      "emailPlaceholder": "nama@perusahaan.com",
      "passwordLabel": "Kata Sandi",
      "passwordPlaceholder": "Masukkan kata sandi",
      "rememberMe": "Ingat sesi ini",
      "forgotPassword": "Lupa Kata Sandi?",
      "signInBtn": "Masuk",
      "signingIn": "Memverifikasi...",
      "registerLink": "Belum punya akun perusahaan? Daftar di sini",
      "quickRoleSwitch": "Pilih Cepat Akun Demo",
      "superadmin": "Superadmin (Operator Platform)",
      "gameOwner": "Pemilik Ruang Kerja (Mitra Perusahaan)",
      "gameMaker": "Manajer Misi (Manajer)",
      "gamePlayer": "Pemain (Karyawan)",
      "resetPasswordTitle": "Atur Ulang Kata Sandi",
      "resetPasswordDesc": "Masukkan alamat email yang terdaftar untuk menerima petunjuk atur ulang kata sandi.",
      "resetPasswordModalTitle": "Atur Ulang Kata Sandi",
      "resetPasswordModalDesc": "Masukkan alamat email yang terdaftar untuk menerima petunjuk atur ulang kata sandi.",
      "registeredEmail": "Alamat Email Terdaftar",
      "sending": "Mengirim...",
      "sendResetLink": "Kirim Tautan Reset",
      "backToLogin": "Kembali ke Halaman Masuk",
      "chooseCommandClass": "PILIH KELAS KOMANDO",
      "demoAccess": "AKSES DEMO",
      "sovereignRole": "Penguasa Citadela",
      "sovereignSub": "Markas Superadmin",
      "ownerRole": "Pemilik Perusahaan",
      "ownerSub": "CEO & Analitik",
      "makerRole": "Master Divisi",
      "makerSub": "Studio Misi",
      "playerLink": "Aplikasi Ksatria",
      "citadelGuard": "PENJAGA CITADELA KSATRIA • CITADELA MULTI-MITRA",
      "citadelEdition": "GAMITEAM • EDISI CITADELA KERAJAAN KSATRIA",
      "enterCitadel": "MASUK CITADELA KOMANDO",
      "openingCitadelGates": "MEMBUKA GERBANG CITADELA...",
      "signInFailed": "Gagal Masuk",
      "checkInbox": "Periksa Kotak Masuk Anda",
      "requestFailed": "Permintaan Gagal",
      "accessDenied": "Akses Ditolak",
      "accessDeniedMsg": "Anda tidak memiliki izin untuk mengakses Portal Admin.",
      "playerBlockedMsg": "Pemain harus menggunakan Aplikasi Pemain. Akses ke Portal Admin dibatasi.",
      "loggedOut": "Berhasil Keluar",
      "loggedOutDesc": "Anda telah berhasil keluar dari akun.",
      "copyright": "Hak Cipta © 2026 Gamiteam. Seluruh hak cipta dilindungi."
    },
    "workspace": {
      "title": "Pusat Komando Gamifikasi Perusahaan",
      "subtitle": "Telemetri keaktifan tim, peringkat performa skuad, dan peredaran hadiah Gold real-time.",
      "engagementIndex": "Skor Keaktifan Tim",
      "activeStreaks": "Pemain Konsisten (Streaks)",
      "goldPool": "Total Gold Beredar",
      "kudosSent": "Apresiasi Rekan (Kudos)",
      "squadClash": "Peringkat Skuad & Divisi",
      "squadClashDesc": "Peringkat performa berdasarkan penyelesaian misi dan Gold",
      "hallOfFame": "Pemain Terbaik (Top MVP)",
      "hallOfFameDesc": "Pemain terdepan berdasarkan level, konsistensi, dan Gold",
      "liveActivity": "Aktivitas Misi & Aliran Apresiasi",
      "recentQuests": "Penyelesaian Misi Terbaru",
      "recentKudos": "Apresiasi & Ucapan Rekan",
      "noRecentQuests": "Belum ada misi yang diselesaikan hari ini.",
      "noQuestActivity": "Belum ada aktivitas penyelesaian misi.",
      "noRecentKudos": "Belum ada apresiasi dikirim hari ini.",
      "companyInvoices": "Riwayat Tagihan & Langganan",
      "createQuestBtn": "+ Buat Misi",
      "reviewSubmissionsBtn": "Verifikasi Pengajuan",
      "rewardShopBtn": "Toko Hadiah",
      "quotaUsed": "Kursi Terpakai",
      "companyActiveStatus": "Workspace Aktif",
      "quickOwnerAnalytics": "Analisis Makro Game Owner",
      "quickOwnerDesc": "Radar ROI, likuiditas Gold, heatmap divisi, dan Company Boss Raid.",
      "quickMakerStudio": "Maker Studio & Verifikasi",
      "quickMakerDesc": "Audit pengajuan misi, pembuat misi cepat, dan intervensi tim.",
      "quickRealmsMarket": "Ruang Kerja & Template SOP",
      "quickRealmsDesc": "Simulasi kerja interaktif dan template kolaborasi tim.",
      "openSuite": "Buka Suite →",
      "openStudio": "Buka Studio →",
      "openMarket": "Buka Market →",
      "monthlySubscriptionStatistic": "Statistik Langganan Bulanan",
      "latest12Months": "12 Bulan Terakhir",
      "payDate": "Tanggal Pembayaran",
      "billingPeriod": "Periode Tagihan",
      "totalAmount": "Total Nominal",
      "downloadInvoice": "Unduh Invoice",
      "numberOfPlayers": "Jumlah Pemain",
      "newRegistration": "Pendaftaran Baru",
      "renewal": "Perpanjangan",
      "viewAll": "Lihat Semua",
      "members": "Anggota",
      "pts": "Gold",
      "days": "Hari",
      "seasonActive": "Musim Aktif",
      "refreshData": "Segarkan Telemetri",
      "filterThisMonth": "Bulan Ini",
      "filterAllTime": "Sepanjang Masa",
      "streakSubtext": "Konsisten absensi & tuntas misi",
      "goldPoolSubtext": "Beredar dalam tim bulan ini",
      "kudosSubtext": "Saling apresiasi sesama rekan",
      "level": "Level",
      "rank": "Peringkat",
      "squadDivision": "Skuad & Divisi",
      "totalGoldPts": "Total Perolehan Gold",
      "questProgress": "Progres Misi",
      "ratingVeryActive": "Sangat Aktif",
      "ratingActive": "Aktif",
      "ratingGettingStarted": "Baru Mulai",
      "activeQuestsCardSub": "Misi KPI harian & sprint terpublikasi",
      "activeQuestsCardTitle": "Misi Ruang Kerja Aktif",
      "approvedQuestsSeries": "Misi Disetujui",
      "badgeWorkspaces": "Ringkasan Ruang Kerja Perusahaan",
      "chartActivityAxis": "Aktivitas Selesai",
      "makersCardSub": "Pemimpin tim & peninjau misi",
      "monthlyActivityStatistic": "Tren Aktivitas Operasional Bulanan",
      "newMembersSeries": "Anggota Baru",
      "playersCardSub": "Karyawan aktif berpartisipasi",
      "staffSuffix": "anggota"
    },
    "quests": {
      "title": "Misi & Target KPI",
      "subtitle": "Definisikan sasaran kerja karyawan, standar SOP, dan sistem reward gamifikasi.",
      "createNewQuest": "+ Buat Misi Baru",
      "searchPlaceholder": "Cari nama misi, target, atau kategori...",
      "questName": "Nama Misi",
      "reward": "Hadiah (Gold & Item)",
      "description": "Deskripsi Sasaran",
      "frequency": "Siklus",
      "division": "Skuad & Divisi",
      "actions": "Aksi",
      "viewDetails": "Lihat Detail",
      "editQuest": "Ubah Misi",
      "deleteQuest": "Hapus Misi",
      "confirmDelete": "Apakah Anda yakin ingin menghapus aturan misi ini?",
      "emptyTitle": "Belum Ada Aturan Misi",
      "emptyDesc": "Buat misi target dan sasaran SOP untuk memotivasi performa karyawan.",
      "consequencesTitle": "Sanksi SOP",
      "consequencesSubtitle": "Konsekuensi transparan atas keterlambatan atau pelanggaran SOP.",
      "createConsequence": "+ Buat Sanksi SOP",
      "compensationsTitle": "Misi Pemulihan",
      "compensationsSubtitle": "Misi pemulihan agar karyawan dapat memulihkan poin pelanggaran.",
      "createCompensation": "+ Buat Misi Pemulihan",
      "pointsDeduction": "Pengurangan Gold",
      "offsetAmount": "Nilai Pemulihan",
      "violationRule": "Sanksi SOP",
      "compensationTask": "Misi Pemulihan",
      "emptyCompTitle": "Belum Ada Misi Pemulihan",
      "emptyCompDesc": "Belum ada misi pemulihan yang diatur di ruang kerja ini.",
      "emptyConsequenceTitle": "Belum Ada Sanksi SOP",
      "emptyConsequenceDesc": "Belum ada aturan sanksi SOP yang dibuat.",
      "statusActive": "Aktif",
      "statusDraftPaused": "Draf atau Dijeda",
      "cloneSuccess": "Misi Berhasil Disalin!",
      "cloneSuccessDesc": "Salinan \"{name}\" telah dibuat dan aktif.",
      "cloneFailed": "Gagal Duplikasi",
      "statusUpdated": "Status Diperbarui",
      "statusUpdatedDesc": "Misi \"{name}\" kini {status}.",
      "statusUpdateFailed": "Gagal Mengubah Status",
      "deleteConfirmText": "Misi ini akan dihapus dari daftar.",
      "deleted": "Dihapus",
      "deletedDesc": "Misi telah berhasil dihapus.",
      "deleteFailed": "Gagal menghapus misi",
      "deleteBtn": "Hapus Misi",
      "weekDayRequired": "Silakan pilih hari untuk pengulangan mingguan",
      "deleteQuestConfirmTitle": "Hapus Misi?",
      "deleteQuestConfirmText": "Apakah Anda yakin ingin menghapus misi ini?"
    },
    "approvals": {
      "title": "Verifikasi & Approval Misi & Target KPI",
      "subtitle": "Audit bukti kerja, setujui pencairan reward, atau tolak pengajuan yang tidak valid.",
      "searchPlaceholder": "Cari nama pemain atau judul misi...",
      "employee": "Karyawan (Pemain)",
      "questRule": "Misi & Target KPI",
      "submittedAt": "Waktu Pengajuan",
      "verificationStatus": "Status Verifikasi",
      "reviewSubmission": "Tinjau Pengajuan",
      "reviewRewardClaim": "Tinjau Pengajuan Misi & Target KPI",
      "backToReward": "Kembali ke Approval Misi & Target KPI",
      "emptyTitle": "Tidak Ada Antrean Approval",
      "emptyDesc": "Semua pengajuan misi karyawan telah diproses atau belum ada pengajuan baru.",
      "filterStatus": "Filter Status",
      "consequenceTitle": "Sanksi SOP",
      "consequenceSubtitle": "Verifikasi laporan pelanggaran tata tertib dan audit pengurangan penalti karyawan.",
      "emptyConsequenceTitle": "Tidak Ada Antrean Sanksi SOP",
      "emptyConsequenceDesc": "Semua laporan pelanggaran tata tertib telah diproses atau belum ada laporan baru.",
      "reviewConsequence": "Tinjau Laporan",
      "compensationTitle": "Misi Pemulihan",
      "compensationSubtitle": "Tinjau bukti misi pemulihan agar karyawan dapat memulihkan penalti.",
      "emptyCompensationTitle": "Tidak Ada Antrean Misi Pemulihan",
      "emptyCompensationDesc": "Semua pengajuan misi pemulihan telah ditinjau.",
      "reviewCompensation": "Tinjau Misi",
      "punishmentTitle": "Laporan Pelanggaran",
      "punishmentSubtitle": "Audit laporan pelanggaran dan penetapan tindakan disipliner.",
      "emptyPunishmentTitle": "Tidak Ada Antrean Laporan Pelanggaran",
      "emptyPunishmentDesc": "Semua laporan pelanggaran disipliner telah diaudit.",
      "reviewPunishment": "Tinjau Laporan",
      "incidentDescription": "Tindakan & Deskripsi Pelanggaran",
      "pendingReview": "Menunggu Review",
      "approved": "Disetujui",
      "rejected": "Ditolak",
      "totalGoldDistributed": "Total Gold Dibagikan",
      "pendingVerification": "Menunggu Verifikasi",
      "verifiedApplied": "Diverifikasi (Dikenakan)",
      "cancelledDismissed": "Dibatalkan",
      "totalViolations": "Total Pelanggaran",
      "totalCompensations": "Total Misi Pemulihan",
      "totalIncidents": "Total Laporan Pelanggaran",
      "cases": "Kasus",
      "tasks": "Misi"
    },
    "approval": {
      "reviewRewardClaim": "Tinjau Pengajuan Misi & Target KPI",
      "backToReward": "Kembali ke Approval Misi & Target KPI",
      "consequenceTitle": "Sanksi SOP",
      "compensationTitle": "Misi Pemulihan",
      "punishmentTitle": "Laporan Pelanggaran"
    },
    "squads": {
      "title": "Skuad & Divisi",
      "subtitle": "Organisir tim, departemen, dan skuad lintas divisi untuk kompetisi leaderboard.",
      "createSquad": "+ Buat Skuad Baru",
      "searchPlaceholder": "Cari nama skuad atau divisi...",
      "squadName": "Nama Skuad & Divisi",
      "membersCount": "Jumlah Anggota",
      "totalGold": "Total Gold Terkumpul",
      "performanceIndex": "Progres Performa",
      "emptyTitle": "Belum Ada Skuad atau Divisi",
      "emptyDesc": "Buat skuad fungsional atau divisi departemen untuk memulai gamifikasi tim.",
      "confirmDelete": "Apakah Anda yakin ingin menghapus skuad ini?",
      "createTitle": "Buat Skuad & Divisi Baru",
      "createSubtitle": "Tambahkan divisi atau skuad baru untuk pengelompokan misi dan KPI player",
      "editTitle": "Ubah Skuad & Divisi",
      "editSubtitle": "Perbarui informasi divisi dan nama skuad",
      "detailsTitle": "Detail Skuad & Divisi",
      "detailsSubtitle": "Detail divisi dan konfigurasi target tim",
      "name": "Nama Skuad & Divisi",
      "description": "Deskripsi Skuad & Divisi",
      "members": "Anggota Skuad",
      "noDescription": "Belum ada deskripsi untuk skuad ini.",
      "savedSuccess": "Skuad berhasil disimpan.",
      "updatedSuccess": "Skuad berhasil diperbarui.",
      "deletedSuccess": "Skuad berhasil dihapus.",
      "progressLabel": "Progres"
    },
    "squad": {
      "title": "Skuad & Divisi",
      "subtitle": "Organisir tim, departemen, dan skuad lintas divisi untuk kompetisi leaderboard.",
      "createSquad": "+ Buat Skuad Baru",
      "searchPlaceholder": "Cari nama skuad atau divisi...",
      "squadName": "Nama Skuad & Divisi",
      "membersCount": "Jumlah Anggota",
      "totalGold": "Total Gold Terkumpul",
      "performanceIndex": "Progres Performa",
      "emptyTitle": "Belum Ada Skuad atau Divisi",
      "emptyDesc": "Buat skuad fungsional atau divisi departemen untuk memulai gamifikasi tim.",
      "confirmDelete": "Apakah Anda yakin ingin menghapus skuad ini?",
      "createTitle": "Buat Skuad & Divisi Baru",
      "createSubtitle": "Tambahkan divisi atau skuad baru untuk pengelompokan misi dan KPI player",
      "editTitle": "Ubah Skuad & Divisi",
      "editSubtitle": "Perbarui informasi divisi dan nama skuad",
      "detailsTitle": "Detail Skuad & Divisi",
      "detailsSubtitle": "Detail divisi dan konfigurasi target tim",
      "name": "Nama Skuad & Divisi",
      "description": "Deskripsi Skuad & Divisi",
      "members": "Anggota Skuad",
      "noDescription": "Belum ada deskripsi untuk skuad ini.",
      "savedSuccess": "Skuad berhasil disimpan.",
      "updatedSuccess": "Skuad berhasil diperbarui.",
      "deletedSuccess": "Skuad berhasil dihapus."
    },
    "player": {
      "title": "Karyawan & Pemain Perusahaan (Player)",
      "subtitle": "Kelola akun karyawan yang berpartisipasi, penugasan skuad dan divisi, dan role gamifikasi.",
      "insertNew": "+ Daftarkan Player Baru",
      "addToMaker": "Promosikan ke Maker",
      "alreadyInMaker": "Manajer & Pemain",
      "squad": "Skuad & Divisi",
      "noPlayersFound": "Belum Ada Data Player",
      "noPlayersDesc": "Belum ada anggota player atau karyawan yang terdaftar di organisasi Anda.",
      "confirmPromoteTitle": "Promosikan Menjadi Game Maker?",
      "confirmPromoteText": "Pengguna ini akan diberikan wewenang manajerial untuk membuat misi dan memverifikasi pengajuan tim.",
      "confirmPromoteBtn": "Ya, Promosikan ke Maker",
      "quotaUsage": "Kapasitas Kuota Kursi Pemain",
      "quotaSubtitle": "Pantau jumlah pemain aktif terdaftar vs kapasitas alokasi kuota perusahaan.",
      "totalSeats": "Total Kursi",
      "seatsUsed": "Kursi Terpakai",
      "seatsAvailable": "Sisa Kuota Kursi",
      "upgradeQuota": "+ Tambah Kuota (Top-Up)",
      "level": "Level",
      "xp": "XP",
      "gold": "Gold",
      "streak": "Konsistensi Harian",
      "position": "Jabatan",
      "status": "Status",
      "editPlayer": "Ubah Data Karyawan",
      "resetPassword": "Atur Ulang Kata Sandi",
      "deletePlayer": "Nonaktifkan Akun",
      "confirmDemoteMakerTitle": "Cabut Hak Akses Maker?",
      "confirmDemoteMakerText": "Karyawan ini akan dikembalikan menjadi player murni.",
      "confirmDemoteMakerBtn": "Ya, Cabut Akses Maker",
      "confirmDeleteTitle": "Offboard & Hapus Karyawan?",
      "confirmDeleteText": "Menghapus player ini akan mencabut akses aplikasi dan mengembalikan 1 kuota kursi ke kuota perusahaan Anda.",
      "confirmDeleteBtn": "Ya, Offboard & Bebaskan Kuota",
      "resetPasswordTitle": "Atur Ulang Kata Sandi Karyawan",
      "resetPasswordSub": "Tentukan kata sandi masuk baru untuk karyawan:",
      "newPassword": "Kata Sandi Baru",
      "passwordUpdated": "Kata sandi berhasil diperbarui.",
      "resetPasswordSuccess": "Kata sandi berhasil diatur ulang.",
      "editModalTitle": "Ubah Profil Karyawan"
    },
    "maker": {
      "title": "Game Maker (Manajer)",
      "subtitle": "Kelola Game Maker (Manajer) dan pengawas skuad yang berwenang merancang misi dan menyetujui pengajuan.",
      "insertNew": "+ Daftarkan Maker Baru",
      "addToPlayer": "Tugaskan sebagai Pemain",
      "alreadyInPlayer": "Manajer & Pemain",
      "noMakersFound": "Belum Ada Data Maker",
      "noMakersDesc": "Belum ada Game Maker yang ditugaskan di organisasi Anda.",
      "confirmAssignTitle": "Tugaskan sebagai Game Player?",
      "confirmAssignText": "Manajer ini juga akan mendapatkan kapabilitas pemain untuk berpartisipasi dalam misi dan menukarkan hadiah.",
      "confirmAssignBtn": "Ya, Tugaskan sebagai Pemain",
      "demoteToPlayer": "Kembalikan ke Pemain Murni",
      "confirmDemoteTitle": "Cabut Peran Game Maker?",
      "confirmDemoteText": "Pengguna ini tidak lagi dapat membuat misi atau memverifikasi pengajuan.",
      "confirmDemoteBtn": "Ya, Cabut Peran Maker",
      "confirmDeleteTitle": "Hapus Game Maker?",
      "confirmDeleteText": "Apakah Anda yakin ingin menghapus akun Game Maker ini?",
      "confirmDeleteBtn": "Ya, Hapus Maker",
      "editMaker": "Ubah Data Maker"
    },
    "approvalDetail": {
      "rewardApprovalTitle": "Verifikasi Pengajuan Misi & Target KPI",
      "consequenceApprovalTitle": "Verifikasi Sanksi SOP",
      "punishmentApprovalTitle": "Verifikasi Laporan Pelanggaran",
      "compensationApprovalTitle": "Verifikasi Misi Pemulihan",
      "submissionSubtitle": "Periksa lampiran bukti dan konfirmasi distribusi hadiah atau penolakan.",
      "consequenceSubtitle": "Periksa rincian laporan pelanggaran dan tentukan konfirmasi sanksi atau pembatalan.",
      "punishmentSubtitle": "Periksa rincian laporan pelanggaran dan tentukan konfirmasi penalti atau pembatalan.",
      "compensationSubtitle": "Periksa bukti pengerjaan misi pemulihan dan konfirmasi penyelesaian penalti.",
      "submittedAt": "Diajukan Pada",
      "questRule": "Misi & Target KPI",
      "employee": "Karyawan",
      "rewardGold": "Hadiah Gold",
      "description": "Deskripsi",
      "comment": "Komentar Karyawan",
      "evidenceAttachment": "Lampiran Bukti",
      "viewAttachment": "Lihat Bukti Penuh",
      "noAttachment": "Tidak Ada Bukti Lampiran",
      "rejectionNotes": "Catatan Penolakan",
      "decisionAction": "Keputusan Verifikasi",
      "approve": "Setujui & Distribusikan Hadiah",
      "reject": "Tolak Pengajuan",
      "approveConsequence": "Setujui & Terapkan Sanksi",
      "rejectConsequence": "Tolak Laporan",
      "approvePunishment": "Setujui & Catat Pelanggaran",
      "rejectPunishment": "Tolak Laporan",
      "approveCompensation": "Setujui & Selesaikan Misi Pemulihan",
      "rejectCompensation": "Tolak & Minta Perbaikan",
      "consequenceApprovedMsg": "Laporan pelanggaran telah diverifikasi dan sanksi SOP telah diterapkan.",
      "consequenceRejectedMsg": "Laporan pelanggaran telah ditolak atau dibatalkan.",
      "punishmentApprovedMsg": "Laporan pelanggaran telah diverifikasi dan dicatat ke histori.",
      "punishmentRejectedMsg": "Laporan pelanggaran telah ditolak atau dibatalkan.",
      "compensationApprovedMsg": "Misi pemulihan telah diverifikasi dan penalti telah diselesaikan.",
      "compensationRejectedMsg": "Misi pemulihan telah ditolak.",
      "rewardApprovedMsg": "Pengajuan misi telah disetujui dan hadiah telah didistribusikan.",
      "rewardRejectedMsg": "Pengajuan misi telah ditolak.",
      "compensationTask": "Misi Pemulihan",
      "offsettingViolation": "Pelanggaran Terkait",
      "reasonPlaceholder": "Tuliskan alasan konstruktif mengapa pengajuan ini ditolak...",
      "submitDecision": "Konfirmasi Keputusan",
      "reportedBy": "Dilaporkan Oleh",
      "violationRule": "Sanksi SOP",
      "penaltyDeduction": "Pengurangan Penalti"
    },
    "gameSettings": {
      "title": "Pusat Pengaturan Game & Arsitektur",
      "subtitle": "Konfigurasi gamifikasi, standarisasi terminologi, parameter mesin XP & Gold, serta identitas perusahaan.",
      "engineActive": "Mesin Gamiteam 2.0 Aktif",
      "tabTerminology": "1. Panduan & Terminologi",
      "tabEngine": "2. Mekanika & Parameter Mesin",
      "tabBranding": "3. Profil & Identitas Perusahaan",
      "tabWizard": "4. Panduan Daftar Periksa Awal",
      "mechanismTitle": "Siklus Produktivitas Gamiteam",
      "mechanismDesc": "Sistem Gamiteam bekerja melalui siklus produktivitas terpadu: Misi & Target KPI menghasilkan Gold & XP, Sanksi SOP mendisiplinkan standar kerja, Misi Pemulihan memulihkan dampak, dan Toko Hadiah menjadi tempat apresiasi tukar hadiah.",
      "targetPositive": "TARGET POSITIF",
      "questsTitle": "Misi & Target KPI",
      "questsFlow": "Alur: Maker Buat Misi → Pemain Ambil & Kirim Bukti → Persetujuan Maker → Pemain Klaim Hadiah",
      "manageQuests": "Kelola Misi & Target KPI →",
      "sopDiscipline": "DISIPLIN SOP",
      "penaltiesTitle": "Sanksi SOP",
      "penaltiesFlow": "Alur: Pelanggaran Terjadi → Laporan Masuk → Verifikasi Maker/Owner → Saldo Gold Dipotong",
      "managePenalties": "Kelola Sanksi SOP →",
      "remediation": "PEMULIHAN",
      "compensationsTitle": "Misi Pemulihan",
      "compensationsFlow": "Alur: Pemain Kena Penalti → Ambil Misi Pemulihan → Kirim Bukti → Penalti Tuntas",
      "manageCompensations": "Kelola Misi Pemulihan →",
      "rewardShopTitle": "Toko Hadiah & Penukaran",
      "rewardShopFlow": "Alur: Pemain Kumpulkan Gold → Tukar Item di Toko → Admin Bagikan Hadiah",
      "manageShop": "Buka Toko Hadiah →",
      "tabAi": "5. Bantuan AI & Game Architect",
      "aiBannerTitle": "Arsitek & Asisten Gamifikasi AI",
      "aiBannerDesc": "Biarkan AI menganalisis profil tim Anda, merancang ekonomi XP & Gold yang seimbang, mencegah burnout, dan menghasilkan aturan SOP dalam hitungan detik.",
      "aiSelectIndustry": "Pilih Profil Industri & Departemen",
      "aiCustomPrompt": "Atau Deskripsikan Kebutuhan & Tantangan Tim Anda",
      "aiPromptPlaceholder": "Contoh: Kami adalah agensi software dengan 15 engineer. Kami butuh misi untuk review pull request, penyelesaian sprint tepat waktu, dan sanksi SOP terlambat standup yang adil...",
      "aiGenerateBtn": "Buat Blueprint Gamifikasi dengan AI",
      "aiGenerating": "AI sedang menyeimbangkan ekonomi & merancang blueprint...",
      "aiApplyEngineBtn": "Terapkan ke Mesin Gamifikasi",
      "aiDeployRulesBtn": "1-Klik Rilis Semua Aturan ke Workspace",
      "aiDeploying": "Sedang merilis aturan ke database...",
      "aiDeployedSuccess": "Seluruh Misi, Sanksi SOP, Misi Pemulihan, dan Item Hadiah berhasil dirilis ke workspace!",
      "aiHealthScore": "Skor Keseimbangan Ekonomi",
      "aiBurnoutRisk": "Risiko Burnout",
      "aiSlaAdherence": "Proyeksi Kepatuhan SOP",
      "saveEngineConfig": "Simpan Konfigurasi Mesin",
      "engineSaved": "Parameter mesin gamifikasi berhasil disimpan!",
      "aiBlueprintDoneTitle": "AI Blueprint Selesai Dibuat!",
      "aiBlueprintDoneDesc": "Gamification engine berhasil diselaraskan untuk profil {archetype} dengan skor keseimbangan {score}/100.",
      "aiParamsApplied": "Parameter rekomendasi AI telah diterapkan ke tab Mesin Gamifikasi!",
      "aiConfirmDeployTitle": "Rilis Aturan AI ke Database?",
      "aiConfirmDeployDesc": "Sistem AI akan otomatis mendaftarkan {quests} Misi & Target KPI, {consequences} Sanksi SOP, {compensations} Misi Pemulihan, dan {rewards} Item Hadiah ke database organisasi Anda.",
      "aiConfirmDeployBtn": "Ya, Rilis Sekarang!",
      "aiDeploySuccessTitle": "Berhasil Diterapkan ke Workspace!",
      "aiDeployErrorDesc": "Gagal merilis sebagian aturan ke database.",
      "blueprintCopiedTitle": "Tersalin!",
      "blueprintCopiedDesc": "Blueprint spesifikasi gamifikasi (JSON) berhasil disalin ke clipboard.",
      "activeRealmBadge": "RUANG KERJA AKTIF",
      "aiAppliedToEngineDesc": "Parameter mesin gamifikasi dan kurva progresi telah dimuat ke pengaturan ruang kerja Anda.",
      "aiBlueprintReady": "Cetak Biru Gamifikasi AI Siap",
      "aiDeployPartialError": "Sebagian elemen gagal diterapkan. Silakan periksa daftar misi ruang kerja Anda.",
      "aiGeneratedDesc": "Cetak biru terstruktur untuk {archetype} (Kesiapan Konfigurasi: {score}%).",
      "aiGeneratedTitle": "Cetak Biru Berhasil Dirancang",
      "antiCheatBalanced": "Seimbang (OCR + Tinjauan Manajer pada Misi Bernilai Tinggi)",
      "antiCheatLenient": "Ringkas (Persetujuan Otomatis Misi Harian Tingkat Dasar)",
      "antiCheatShort": "Mode Verifikasi",
      "antiCheatShortBalanced": "Seimbang",
      "antiCheatShortLenient": "Ringkas",
      "antiCheatShortStrict": "Ketat",
      "antiCheatStrict": "Ketat (100% Verifikasi Manual Manajer + Sidik Bukti Unik)",
      "antiCheatToleranceLabel": "Kebijakan Verifikasi Bukti & Anti-Kecurangan",
      "archCreative": "Pemasaran, Merek & Studio Kreatif",
      "archOperations": "Ritel, Rantai Pasok & Operasional Lapangan",
      "archSales": "Penjualan B2B & Pertumbuhan Pendapatan",
      "archSupport": "Layanan Pelanggan & Meja Bantuan",
      "archTech": "Rekayasa Perangkat Lunak, Produk & DevOps",
      "baseXp100": "100 XP (Ritme Standar Perusahaan)",
      "baseXp150": "150 XP (Ritme Terukur Kuartalan)",
      "baseXp200": "200 XP (Ritme Penguasaan Jangka Panjang)",
      "baseXp50": "50 XP (Progresi Cepat Orientasi Tim)",
      "baseXpPerLevel": "Ambang XP Dasar per Level",
      "baseXpShort": "XP Dasar",
      "brandingSubtitle": "Sesuaikan identitas ruang kerja, warna aksen tema, serta pesan sambutan yang tampil di aplikasi karyawan.",
      "brandingTitle": "Identitas Ruang Kerja & Tampilan Aplikasi",
      "calculatedRankLabel": "Peringkat Karyawan Terhitung",
      "colCumulativeXp": "Total Kumulatif XP",
      "colLevelUpReward": "Gelar & Tonggak Kenaikan Level",
      "colRequiredXp": "Kebutuhan XP Tingkat Ini",
      "colTierLevel": "Tingkat Level",
      "commanderBriefingLabel": "Pesan Sambutan Tim",
      "companyLogoLabel": "Logo Ruang Kerja",
      "companyNameLabel": "Nama Tampilan Organisasi",
      "companyNamePlaceholder": "Contoh: PT Nusantara Digital",
      "compensationsCardDesc": "Tugas pemulihan untuk menebus catatan pelanggaran",
      "copiedBlueprintDesc": "Konfigurasi JSON cetak biru berhasil disalin ke papan klip.",
      "copiedTitle": "JSON Disalin",
      "copyJsonBtn": "Salin Spesifikasi JSON",
      "currentTierXpLabel": "Progres pada Level Saat Ini",
      "dailyGoldCapLabel": "Batas Maksimal Perolehan Gold Harian per Karyawan",
      "dailyGoldCapShort": "Batas Gold Harian",
      "dailyStreakLabel": "Aktifkan Bonus Konsistensi Hari Kerja Beruntun",
      "dailyStreakSubtitle": "Apresiasi konsistensi pelaksanaan SOP harian secara terukur dan terkendali.",
      "dailyStreakTitle": "Aturan Konsistensi Harian & Apresiasi Rekan Kerja",
      "databaseLabel": "Basis Aturan Ruang Kerja",
      "days1To2": "Hari ke-1 s.d. ke-2",
      "days1To2Desc": "Tarif hadiah dasar standar (1,0x)",
      "days3To6": "Hari ke-3 s.d. ke-6",
      "days3To6Desc": "Bonus momentum kerja (+10% XP)",
      "days7Plus": "7+ Hari Beruntun",
      "days7PlusDesc": "Pengali konsistensi penuh aktif",
      "days7Short": "7+ Hari",
      "daysUnit": "hari",
      "defaultCompanyName": "Ruang Kerja Perusahaan",
      "defaultEvidenceHint": "Bukti penyelesaian tugas terverifikasi",
      "defaultWelcomePreview": "Selesaikan misi operasional harian dengan kualitas terverifikasi dan raih apresiasi nyata.",
      "deployConfirmBtn": "Terapkan Semua ke Ruang Kerja",
      "deployConfirmDesc": "Tindakan ini akan menerbitkan {quests} misi, {consequences} konsekuensi, {compensations} tugas pemulihan, dan {rewards} hadiah toko ke ruang kerja aktif Anda.",
      "deployConfirmTitle": "Terapkan Cetak Biru ke Ruang Kerja Aktif?",
      "engineTuningSubtitle": "Kalibrasi kurva kenaikan level XP, batas anggaran Gold harian, serta kebijakan verifikasi.",
      "engineTuningTitle": "Parameter Mesin Gamifikasi & Ekonomi",
      "enterTotalXpLabel": "Simulasikan Total XP Karyawan",
      "evidenceGuideSuffix": "Bukti wajib: {evidence}",
      "evidenceLabel": "Bukti Wajib:",
      "freqDaily": "Harian",
      "goldMultiplierHigh": "Pengali Konsistensi Tinggi",
      "goldMultiplierStandard": "Pengali Standar Berkelanjutan",
      "goldMultiplierSuffix": "Pengali Gold",
      "goldPerDayUnit": "Gold per hari",
      "kudosAllowanceLabel": "Kuota Apresiasi Rekan Mingguan per Anggota",
      "kudosOption10": "10 Apresiasi per minggu (Kolaborasi Intensif)",
      "kudosOption3": "3 Apresiasi per minggu (Apresiasi Selektif)",
      "kudosOption5": "5 Apresiasi per minggu (Standar Direkomendasikan)",
      "kudosSystemDesc": "Setiap anggota tim dapat mengirim hingga {allowance} apresiasi rekan per minggu (masing-masing +{gold} Gold).",
      "kudosSystemTitle": "Apresiasi Antar-Rekan Kerja",
      "levelLabel": "LEVEL",
      "levelValue": "Level {level}",
      "livePreviewTitle": "Pratinjau Layar Aplikasi Karyawan",
      "logoFormatHint": "PNG, JPG, atau SVG (maks. 2 MB, rasio persegi disarankan)",
      "lowOptimal": "Ekonomi Terkendali",
      "normalRate": "1,0x Dasar",
      "penaltiesCardDesc": "Aturan akuntabilitas jelas atas pelanggaran SOP",
      "productivityIncentive": "Insentif KPI Utama",
      "questsCardDesc": "Misi KPI harian & mingguan terukur",
      "questsSuiteTitle": "Rekomendasi Misi KPI ({count})",
      "recommendedEngineParams": "Rekomendasi Parameter Mesin",
      "recommendedShopItems": "Rekomendasi Katalog Hadiah",
      "recoverInfraction": "Pemulihan Pelanggaran",
      "recoveryTasksTitle": "Tugas Pemulihan & Kompensasi",
      "rewardShopBadge": "Item Katalog",
      "rewardShopCardDesc": "Hadiah nyata yang dapat ditukar dengan Gold",
      "sopPenaltiesTitle": "Akuntabilitas & Konsekuensi SOP",
      "streakMultiplierLabel": "Pengali Gold Konsistensi 7 Hari",
      "streakMultiplierShort": "Bonus Konsistensi",
      "themeColorLabel": "Warna Aksen Utama Merek",
      "toNextLevelLabel": "menuju Level {level}",
      "welcomeMessageLabel": "Pesan Sambutan Ruang Kerja",
      "welcomeMessagePlaceholder": "Tuliskan pesan sambutan dan arahan singkat bagi tim Anda...",
      "xpCurveExponential": "Eksponensial (Tantangan Tingkat Senior Lebih Tinggi)",
      "xpCurveLabel": "Rumus Kurva Kenaikan Level",
      "xpCurveLinear": "Linear (Kebutuhan XP Setara Setiap Level)",
      "xpCurveModerate": "Progresif Seimbang (+25% setiap Kenaikan Level)",
      "xpMatrixSubtitle": "Proyeksi ambang XP lintas level karyawan berdasarkan kurva yang Anda pilih.",
      "xpMatrixTitle": "Matriks Ambang Kenaikan Level",
      "xpPerLvlUnit": "XP per level",
      "xpSimulatorSubtitle": "Uji bagaimana perolehan XP karyawan diterjemahkan menjadi peringkat dan bilah progres.",
      "xpSimulatorTitle": "Simulator Progresi Level Interaktif"
    },
    "redeem": {
      "title": "Katalog Hadiah (Reward Shop)",
      "subtitle": "Kelola merchandise, voucher, dan benefit yang dapat ditukarkan oleh karyawan dengan Gold.",
      "addItem": "+ Tambah Item Hadiah",
      "searchPlaceholder": "Cari item hadiah...",
      "itemName": "Nama Item Hadiah",
      "costGold": "Harga Tukar (Gold)",
      "emptyTitle": "Belum Ada Item Hadiah",
      "emptyDesc": "Buat voucher belanja, merchandise, atau cuti tambahan yang dapat ditukarkan karyawan.",
      "createTitle": "Tambah Item Hadiah Baru",
      "createSub": "Daftarkan item ke katalog penukaran hadiah dengan harga Gold yang ditentukan.",
      "editTitle": "Ubah Item Hadiah",
      "editSub": "Perbarui spesifikasi item atau sesuaikan harga Gold penukaran.",
      "detailsTitle": "Detail Item Hadiah",
      "confirmDelete": "Apakah Anda yakin ingin menghapus item hadiah ini?",
      "deletedSuccess": "Item hadiah berhasil dihapus.",
      "savedSuccess": "Item hadiah berhasil disimpan."
    },
    "playerForm": {
      "createTitle": "Daftarkan Game Player Baru",
      "createSub": "Tambahkan karyawan ke dalam ruang kerja gamifikasi perusahaan.",
      "editTitle": "Ubah Data Game Player",
      "editSub": "Perbarui profil akun karyawan, penugasan skuad dan divisi, dan kontak.",
      "detailsTitle": "Detail Profil Game Player",
      "playerName": "Nama Lengkap Player",
      "dateOfBirth": "Tanggal Lahir",
      "emailAddress": "Alamat Email",
      "phoneNumber": "Nomor Telepon atau WhatsApp",
      "password": "Kata Sandi",
      "updatePassword": "Ubah Kata Sandi (Opsional)",
      "leaveBlankPassword": "Kosongkan jika tidak ingin mengubah kata sandi",
      "squad": "Skuad & Divisi",
      "selectSquad": "Pilih Skuad",
      "position": "Jabatan",
      "userPhoto": "Foto Profil",
      "changePhoto": "Unggah Foto Baru",
      "joinDate": "Tanggal Bergabung",
      "savedSuccess": "Data player berhasil disimpan.",
      "updatedSuccess": "Data player berhasil diperbarui.",
      "deletedSuccess": "Player berhasil dihapus.",
      "confirmDelete": "Apakah Anda yakin ingin menghapus player ini?"
    },
    "makerForm": {
      "createTitle": "Daftarkan Game Maker (Manajer) Baru",
      "createSub": "Tambahkan manajer tim dengan hak akses merancang misi dan memverifikasi approval.",
      "editTitle": "Ubah Data Game Maker (Manajer)",
      "editSub": "Perbarui profil Game Maker (Manajer), wewenang skuad dan divisi, dan kontak.",
      "detailsTitle": "Detail Profil Game Maker (Manajer)",
      "makerName": "Nama Lengkap Maker",
      "dateOfBirth": "Tanggal Lahir",
      "emailAddress": "Alamat Email",
      "phoneNumber": "Nomor Telepon atau WhatsApp",
      "password": "Kata Sandi",
      "updatePassword": "Ubah Kata Sandi (Opsional)",
      "leaveBlankPassword": "Kosongkan jika tidak ingin mengubah kata sandi",
      "squad": "Skuad & Divisi",
      "selectSquad": "Pilih Skuad",
      "position": "Jabatan",
      "userPhoto": "Foto Profil",
      "changePhoto": "Unggah Foto Baru",
      "joinDate": "Tanggal Bergabung",
      "savedSuccess": "Data Game Maker berhasil disimpan.",
      "updatedSuccess": "Data Game Maker berhasil diperbarui.",
      "deletedSuccess": "Game Maker berhasil dihapus.",
      "confirmDelete": "Apakah Anda yakin ingin menghapus Game Maker ini?"
    },
    "rulesForm": {
      "editRewardTitle": "Ubah Misi & Target KPI",
      "editRewardSub": "Sesuaikan kriteria sasaran misi, reward Gold, siklus berulang, dan target penugasan.",
      "detailRewardTitle": "Spesifikasi Misi & Target KPI",
      "editConsequenceTitle": "Ubah Sanksi SOP",
      "editConsequenceSub": "Perbarui penalti Gold atau sanksi non-gold atas pelanggaran SOP.",
      "detailConsequenceTitle": "Spesifikasi Sanksi SOP",
      "editCompensationTitle": "Ubah Misi Pemulihan",
      "editCompensationSub": "Perbarui misi pemulihan agar karyawan dapat memulihkan penalti pelanggaran.",
      "detailCompensationTitle": "Spesifikasi Misi Pemulihan",
      "questName": "Nama Misi",
      "questType": "Tipe Misi",
      "alwaysActive": "Selalu Aktif (Bisa Diambil Kapan Saja)",
      "oneTime": "Satu Kali (Sekali Selesai)",
      "rewardType": "Tipe Hadiah",
      "goldCoins": "Gold",
      "nonGoldPerk": "Non-Gold & Benefit Kustom",
      "rewardValue": "Nilai Hadiah",
      "frequency": "Siklus Pengulangan",
      "noRepeat": "Sekali Berlaku (Tanpa Pengulangan)",
      "daily": "Siklus Harian",
      "weekly": "Siklus Mingguan",
      "monthly": "Siklus Bulanan",
      "endsOn": "Berlaku Sampai",
      "targetAssignees": "Penugasan Sasaran",
      "allPlayers": "Semua Pemain Organisasi",
      "specificPlayers": "Pemain Tertentu",
      "specificSquads": "Skuad & Divisi Tertentu",
      "description": "Sasaran & Standar Bukti",
      "descPlaceholder": "Jelaskan standar keberhasilan dan bukti yang perlu diunggah oleh pemain...",
      "consequenceName": "Nama Sanksi SOP",
      "punishmentType": "Tipe Sanksi SOP",
      "penaltyType": "Tipe Sanksi SOP",
      "penaltyGold": "Potong Gold",
      "penaltyNonGold": "Konsekuensi Non-Gold",
      "compensationName": "Nama Misi Pemulihan",
      "compensationDesc": "Aktivitas Misi Pemulihan & Standar Bukti",
      "savedSuccess": "Aturan berhasil disimpan.",
      "updatedSuccess": "Aturan berhasil diperbarui.",
      "deletedSuccess": "Aturan berhasil dihapus."
    },
    "executive": {
      "suiteBadge": "KOMANDO PEMILIK RUANG KERJA",
      "macroRadar": "Telemetri Makro & Radar Efektivitas",
      "geminiAi": "Analisis Strategis Gemini AI",
      "title": "Komando Eksekutif & Analitik Makro",
      "description": "Pusat kendali strategis untuk Founder & C-Level. Pantau perputaran likuiditas Gold, efektivitas investasi (ROI) gamifikasi, peta kinerja kecepatan divisi, deteksi dini risiko kelelahan tim, hingga progres target kuartal korporat.",
      "exportPdf": "Ekspor Laporan Audit PDF",
      "syncTelemetry": "Sinkronisasi Telemetri",
      "totalGoldLiquidity": "TOTAL GOLD LIKUIDITAS",
      "goldRate": "1 Gold = Rp 1.000",
      "goldCirculating": "Gold Beredar",
      "liabilityValuation": "Valuasi Liabilitas",
      "burnRate": "Laju Penyerapan",
      "pool": "Alokasi",
      "netCorporateRoi": "RASIO EFEKTIVITAS INSENTIF",
      "returnOnIncentive": "Efektivitas terhadap Insentif",
      "roiDesc": "Efisiensi capaian KPI dibandingkan anggaran hadiah yang didistribusikan.",
      "roiBenchmark": "Di atas standar industri SaaS (patokan 3,2x)",
      "velocityIndex": "INDEKS KECEPATAN EKSEKUSI TIM",
      "highSpeed": "Kecepatan Tinggi",
      "velocitySub": "Rasio konsistensi beruntun & kecepatan eksekusi tiket misi 7 hari.",
      "activeDailyEmployees": "Karyawan aktif harian",
      "activeRealms": "REALM 3D AKTIF",
      "manageMarketplace": "Kelola Marketplace",
      "realmsDeployed": "Realm Aktif",
      "rulesVerified": "Aturan anti-kecurangan & SOP terverifikasi",
      "bossRaidTitle": "TARGET KOLABORASI PERUSAHAAN",
      "target": "Sasaran",
      "quarterTarget": "Target Kuartal 4",
      "bossRaidDesc": "Setiap misi yang diselesaikan oleh seluruh karyawan berkontribusi langsung mengurangi target tantangan. Ketika target tercapai, bonus kolektif akan otomatis dicairkan sesuai kontribusi pencapaian.",
      "hpRemaining": "HP Boss Tersisa",
      "damageDealt": "Terkikis",
      "contributors": "Kontributor",
      "deadline": "Tenggat Waktu",
      "lootPool": "Total Hadiah Tim",
      "staff": "karyawan",
      "members": "Anggota",
      "projectedDefeat": "Proyeksi Gugur: 12 Hari Lebih Awal",
      "triggerBoost": "Kirim Dorongan Motivasi Tim",
      "adjustTarget": "Atur Target",
      "divisionHeatmap": "Peta Kinerja Skuad & Divisi",
      "divisionHeatmapSub": "Komparasi kecepatan dan performa antar divisi korporat",
      "last7Days": "7 Hari Terakhir",
      "last30Days": "30 Hari Terakhir",
      "divisionSquad": "Skuad & Divisi",
      "questsCleared": "Misi Selesai",
      "completionRate": "Tingkat Penyelesaian",
      "velocityScore": "Skor Kecepatan",
      "status": "Status",
      "turnoverRadar": "Radar Kelelahan & Retensi Tim",
      "turnoverRadarSub": "Deteksi dini capaian beruntun terputus atau karyawan pasif",
      "detectedCount": "Terdeteksi",
      "allConsistent": "Semua anggota tim konsisten dan aktif berenergi!",
      "streakLost": "Rentetan putus",
      "inactiveDays": "Inaktif",
      "days": "hari",
      "callMaker": "Panggil Manajer (Maker)",
      "proactiveAlgo": "Algoritma Proaktif:",
      "proactiveDesc": "Mengurangi risiko pergantian personel hingga 38% dengan mendeteksi penurunan performa sejak dini.",
      "financialLedger": "Buku Besar Finansial & Audit Pajak (PPN 11%)",
      "financialLedgerSub": "Transparansi alokasi dana insentif, potongan PPN 11%, dan biaya layanan",
      "autoDisburseActive": "Pencairan Otomatis Aktif",
      "autoTaxInvoice": "Faktur Pajak Otomatis",
      "grossRewardQ4": "Bruto Hadiah Q4",
      "ppnCollected": "PPN 11% Terkumpul",
      "platformFee": "Biaya Layanan Platform (2,5%)",
      "netDisbursed": "Total Bersih Diterima Tim",
      "geminiAdvisory": "Rekomendasi Eksekutif Strategis Gemini AI",
      "geminiAdvisorySub": "Rekomendasi otomatis berbasis AI C-Level untuk optimasi pertumbuhan korporat",
      "guidanceSentTitle": "Sinyal Bimbingan Terkirim!",
      "guidanceSentDesc": "Sinyal bimbingan terkirim ke Game Maker! Maker akan segera memberikan evaluasi SOP & pendampingan untuk {name}.",
      "motivationBoostTitle": "Dorongan Motivasi Raid Aktif!",
      "motivationBoostDesc": "Seluruh karyawan menerima tambahan +15% XP & Gold untuk misi yang diselesaikan dalam 24 jam ke depan.",
      "adjustRaidTarget": "Sesuaikan Target Boss Raid",
      "enterRaidTargetNominal": "Masukkan target nominal Boss Raid baru (IDR):",
      "raidTargetUpdated": "Target Boss Raid berhasil diperbarui.",
      "auditReportGenerated": "Laporan Audit Berhasil Dibuat!",
      "auditReportDesc": "Laporan Audit Finansial & Gamifikasi Eksekutif berhasil diunduh.",
      "adjustBossModalLabel": "Perbarui Target HP Boss Raid (Poin Misi)",
      "adjustBossModalTitle": "Konfigurasi Target Boss Raid",
      "adjustBossSuccessMsg": "Parameter target Boss Raid berhasil diperbarui.",
      "auditReportGeneratedMsg": "Laporan ringkasan eksekutif telah disiapkan untuk dicetak atau disimpan sebagai PDF.",
      "auditReportGeneratedTitle": "Laporan Eksekutif Siap",
      "defaultBossName": "Target Tonggak Operasional Kuartal",
      "noActiveBossRaid": "Belum Ada Boss Raid Aktif",
      "raidBoostMsg": "Pemberitahuan dorongan motivasi tim telah dikirimkan kepada anggota ruang kerja aktif.",
      "raidBoostTitle": "Dorongan Motivasi Tim Terkirim",
      "raidBoostedStatus": "Dorongan Motivasi Aktif",
      "rescueDispatched": "Pendampingan Dijadwalkan",
      "rescueSignalMsg": "Pengingat sesi pendampingan kerja telah dikirim ke manajer {name}.",
      "rescueSignalTitle": "Pendampingan Kerja Dikirim",
      "totalGoldEarnedLabel": "Total Gold Diperoleh Tim",
      "totalGoldRedeemedLabel": "Total Gold Ditukarkan di Toko"
    },
    "quota": {
      "title": "Alokasi & Manajemen Kuota Pemain",
      "subtitle": "Monitoring utilisasi kursi pemain, alokasi kapasitas lisensi, dan top-up kuota mitra perusahaan secara real-time.",
      "topUpQuotaBtn": "+ Tambah Kuota Kursi",
      "capacity": "Kapasitas",
      "totalSeats": "Total Kuota Kursi",
      "registeredPlayers": "Pemain Aktif Terdaftar",
      "availableSeats": "Kapasitas Kursi Kosong",
      "avgUtilization": "Rata-rata Utilisasi",
      "seatsAllocated": "Kursi Terpakai",
      "seatsAvailableForOnboarding": "Slot tersedia untuk onboarding baru",
      "searchPlaceholder": "Cari perusahaan atau nama owner...",
      "allCapacityStatus": "Semua Status Kapasitas",
      "capacityAvailable": "Kapasitas Luang (< 70%)",
      "capacityWarning": "Hampir Penuh (70% - 90%)",
      "capacityCritical": "Kapasitas Kritis (> 90%)",
      "loadingQuota": "Sinkronisasi data kuota tenant gamiteam...",
      "tableNo": "No",
      "tableCompany": "Perusahaan Mitra",
      "tablePackage": "Paket Aktif",
      "tableQuota": "Kuota",
      "tablePlayers": "Pemain",
      "tableUtilization": "Utilisasi",
      "tableStatus": "Status",
      "tableAction": "Aksi",
      "topUpBtn": "Top-up Kuota",
      "noCompaniesFound": "Tidak ada perusahaan mitra yang sesuai dengan pencarian atau filter.",
      "expansionTitle": "Ekspansi Kuota Pemain",
      "expansionSubtitle": "Tambahkan lisensi kursi pemain tambahan untuk memperbesar kapasitas onboarding mitra perusahaan.",
      "backToQuota": "Kembali ke Alokasi Kuota",
      "selectClient": "Pilih Perusahaan Mitra",
      "clientCompany": "Perusahaan & Klien",
      "chooseClientPlaceholder": "Pilih Mitra Perusahaan...",
      "activeQuota": "Kuota Aktif",
      "newQuotaEstimate": "Estimasi Kuota Baru",
      "additionalSeatsCount": "Jumlah Kursi Tambahan",
      "seats": "Kursi",
      "customSeatsLabel": "Jumlah Kursi Kustom",
      "customSeatsPlaceholder": "Misal: 35",
      "playerSeats": "Kursi Pemain",
      "licenseDuration": "Durasi Lisensi Kuota",
      "standard": "Standar",
      "voucherCode": "Kupon Diskon (Opsional)",
      "voucherPlaceholder": "Contoh: GAMITEAM2026",
      "applyVoucher": "Gunakan Kupon",
      "voucherApplied": "Kupon Berhasil Digunakan!",
      "quotaSummary": "Ringkasan Order Ekspansi Kuota",
      "seatsSubtotal": "Subtotal Kursi",
      "taxPpn": "PPN (11%)",
      "prorationCredit": "Kredit Prorasi",
      "totalPayable": "Total Tagihan",
      "proceedToPayment": "Lanjutkan ke Pembayaran",
      "calculating": "Menghitung rincian...",
      "successOrder": "Order penambahan kuota berhasil dibuat",
      "seatsCount": "{count} Kursi",
      "currentSeats": "Saat ini: {count} Kursi"
    },
    "billing": {
      "title": "Langganan & Pembayaran Perusahaan",
      "periodTitle": "Periode Tagihan & Paket",
      "packageName": "Nama Paket",
      "totalUsers": "Total Kursi Dialokasikan",
      "expiryDate": "Tanggal Kadaluarsa",
      "upgradeNow": "Upgrade Paket",
      "upgradeModalTitle": "Konfirmasi Upgrade Paket",
      "upgradeModalBody": "Apakah Anda ingin memperbarui atau upgrade paket Gamiteam perusahaan Anda?",
      "upgradeModalDesc": "Konsultasikan kebutuhan ekspansi tim, penambahan kuota pemain, dan fitur enterprise Gamiteam dengan tim spesialis kami.",
      "closeModal": "Tutup",
      "contactSales": "Hubungi Tim Support",
      "billingInfo": "Informasi Tagihan",
      "billingCycle": "Siklus Tagihan",
      "nextBillingDate": "Jatuh Tempo Berikutnya",
      "quotaCapacity": "Kapasitas & Utilisasi Kursi",
      "quotaUsage": "Kursi Terpakai",
      "quickAddQuota": "+ Tambah Kuota",
      "historyTitle": "Riwayat Pembayaran & Tagihan",
      "payDate": "Tanggal Bayar",
      "billingPeriod": "Periode Layanan",
      "totalAmount": "Total Tagihan",
      "paymentType": "Metode",
      "paymentStatus": "Status",
      "action": "Aksi",
      "payNow": "Bayar Online",
      "payManual": "Transfer Manual",
      "viewDetail": "Detail Tagihan",
      "downloadInvoice": "Unduh Invoice",
      "noHistory": "Belum Ada Riwayat Billing",
      "noHistoryDesc": "Belum ada transaksi paket berlangganan atau kuota tambahan yang tercatat.",
      "reasonForReject": "Alasan Penolakan",
      "month": "Bulan",
      "digital": "Gerbang Pembayaran",
      "manual": "Transfer Manual",
      "pending": "Menunggu",
      "paid": "Lunas",
      "expired": "Kedaluwarsa",
      "failed": "Gagal",
      "approved": "Disetujui",
      "information": "Informasi Invoice",
      "status": "Status",
      "paymentDestination": "Rekening Tujuan Transfer",
      "accountNumber": "Nomor Rekening",
      "senderBank": "Bank Pengirim",
      "senderName": "Nama Pemilik Rekening Pengirim",
      "uploadProof": "Unggah Bukti Transfer",
      "confirmTransfer": "Konfirmasi Transfer Manual",
      "transferNotice": "Transfer ke rekening resmi Gamiteam dan unggah foto/tangkapan layar bukti transfer.",
      "proofRequired": "Bukti Diperlukan",
      "proofRequiredNotice": "Silakan lampirkan bukti transfer pembayaran bank Anda.",
      "paymentSubmitted": "Pembayaran Berhasil Dikirim!",
      "paymentSubmittedDesc": "Bukti transfer manual Anda telah dikirim untuk diverifikasi. Superadmin akan segera mengaktifkan kuota Anda.",
      "submissionError": "Gagal Mengirimkan",
      "receiptNotice": "Unggah struk transfer resmi dari Mobile Banking, ATM, atau Internet Banking.",
      "bankPlaceholder": "contoh: BCA, Bank Mandiri, BRI, BNI",
      "senderPlaceholder": "contoh: PT Maju Bersama & Budi Rahardjo",
      "activeSubscriptionBadge": "Langganan Aktif",
      "addonOptionBadge": "Tambah Kuota Kursi",
      "addonOptionDesc": "Tambahkan 5, 10, 25, 50, atau jumlah kursi kustom ke langganan aktif tanpa mengubah paket dasar.",
      "addonOptionTitle": "Tambah Kapasitas Kursi Pemain",
      "bankTransferMethod": "Transfer Bank",
      "buyAddonSeatsBtn": "Beli Kuota Tambahan",
      "chooseExpansionTitle": "Pilih Penambahan Kuota & Paket",
      "manualPaymentError": "Gagal memproses permintaan pembayaran manual.",
      "monthShort": "Bln",
      "onlineMethod": "Pembayaran Daring",
      "quotaHealthyBadge": "Normal",
      "tierListLabel": "Pemula • Pertumbuhan • Korporat",
      "tierOptionBadge": "Paket Berlangganan Utama",
      "tierOptionDesc": "Tingkatkan kapasitas ruang kerja ke paket lebih tinggi dengan perhitungan kredit prorata hari aktif.",
      "tierOptionTitle": "Tingkatkan Paket Dasar",
      "upgradeTierPlanBtn": "Tingkatkan Paket"
    },
    "checkout": {
      "title": "Pembayaran Langganan & Kuota",
      "activatePackage": "Paket Berlangganan Aktif",
      "newPackage": "Pilih Paket Langganan Baru",
      "package": "Paket",
      "pricePerUnit": "Harga per Unit",
      "qty": "Qty",
      "duration": "Durasi",
      "totalPrice": "Total Harga",
      "selectPackagePlaceholder": "Pilih Paket...",
      "additionalUser": "Kursi Pemain Tambahan",
      "summary": "Ringkasan Pesanan",
      "packageSummary": "Rincian Langganan",
      "newBill": "Tagihan Paket",
      "credit": "Kredit Prorasi",
      "total": "Total Pembayaran",
      "discountCode": "Kode Voucher Diskon",
      "apply": "Terapkan",
      "back": "Kembali",
      "payNowBtn": "Bayar Sekarang",
      "invoiceNumber": "Nomor Invoice",
      "transferModalTitle": "Transfer Bank Manual",
      "transferInstructions": "Silakan transfer tepat sesuai nominal total ke rekening resmi Gamiteam berikut. Setelah transfer, konfirmasi bukti pembayaran untuk aktivasi instan.",
      "bankName": "Bank Central Asia (BCA)",
      "accountHolder": "PT Gamiteam Digital Nusantara",
      "accountNumber": "Nomor Rekening: 5892 000 000",
      "postpone": "Nanti Saja",
      "confirmTransfer": "Konfirmasi Transfer Sekarang",
      "onlineModalTitle": "Gateway Pembayaran",
      "onlineModalBody": "Mengarahkan ke halaman checkout pembayaran aman...",
      "freeTier": "Fasilitas Standar",
      "additionalTier": "Tambahan Ekstra",
      "usersQuota": "{count} dari {total} kursi",
      "additionalSeatsRow": "Tambahan Kursi Pemain",
      "addonSubtotalLabel": "Subtotal Tambahan Kursi",
      "checkoutErrorTitle": "Pemrosesan Gagal",
      "colDescription": "Deskripsi",
      "coreAdminSeatsFeature": "Termasuk 5 Kursi Administrator Inti",
      "createInvoiceFailed": "Gagal membuat faktur penagihan.",
      "customSeatsCountLabel": "Jumlah Kursi Kustom",
      "enterpriseActiveBadge": "Ruang Kerja Korporat",
      "flexibleTopupFeature": "Penambahan Kursi Pemain Fleksibel Sesuai Kebutuhan",
      "manualTransferBtn": "Transfer Bank Manual",
      "modeAddonBtn": "Tambah Kuota Kursi Saja",
      "modeAddonDesc": "Pertahankan paket saat ini dan tambahkan kuota kursi sesuai sisa masa aktif.",
      "modeAddonTitle": "Penambahan Kuota Kursi",
      "modePackageBtn": "Ganti atau Tingkatkan Paket",
      "modePackageDesc": "Pilih paket langganan bundel beserta durasi dengan perhitungan prorata otomatis.",
      "modePackageTitle": "Paket Berlangganan Utama",
      "officialDestinationAccount": "Rekening Resmi Perusahaan",
      "onlineGatewayErrorTitle": "Pemberitahuan Gerbang Pembayaran",
      "onlineGatewayUnavailableText": "Gerbang pembayaran daring sedang tidak dapat dihubungi. Silakan coba kembali atau gunakan transfer bank manual.",
      "onlinePaymentBtn": "Bayar Daring Seketika",
      "partnerNetworkFeature": "Tata Kelola Ruang Kerja Multi-Divisi",
      "paymentGatewayRedirectText": "Mengalihkan ke halaman pembayaran aman...",
      "paymentGatewayTitle": "Halaman Pembayaran Siap",
      "perSeatPerMonth": "per kursi per bulan",
      "proformaTitle": "Ringkasan Pesanan Proforma",
      "promoAppliedAmountText": "Kode promo {code} diterapkan! Potongan: Rp {amount}",
      "promoAppliedTitle": "Kode Promo Diterapkan",
      "promoEnterValidText": "Silakan masukkan kode promo terlebih dahulu.",
      "promoInvalidFallback": "Kode promo tidak ditemukan, sudah kedaluwarsa, atau belum memenuhi syarat transaksi.",
      "promoInvalidTitle": "Kode Promo Tidak Berlaku",
      "promoModalTitle": "Gunakan Kode Promo",
      "promoPlaceholder": "Masukkan kode promo (contoh: GAMITEAM20)",
      "promoVoucherDiscount": "Potongan Kode Promo",
      "prorationCreditLabel": "Kredit Prorata Paket Aktif",
      "prorationUpgradeFeature": "Kredit Prorata Otomatis saat Peningkatan Paket",
      "quickPresetsLabel": "Pilihan Cepat Jumlah Kursi",
      "seatCountRequiredText": "Harap masukkan minimal 1 tambahan kursi pemain.",
      "seatCountRequiredTitle": "Jumlah Kursi Wajib Diisi",
      "securePaymentChannelsDesc": "Pilih pembayaran digital instan atau transfer bank perusahaan terverifikasi.",
      "securePaymentChannelsTitle": "Saluran Pembayaran Perusahaan",
      "selectPackageText": "Silakan pilih paket langganan terlebih dahulu sebelum melanjutkan.",
      "selectPackageTitle": "Pilih Paket Langganan",
      "subscriptionPlanQuotaRow": "Kuota Dasar Paket Langganan",
      "totalInvoiceAmountLabel": "Total Tagihan Faktur:",
      "totalPayableLabel": "Total Pembayaran Bersih"
    },
    "register": {
      "title": "Registrasi Akun Perusahaan",
      "subtitle": "Tingkatkan produktivitas tim dengan quest berbasis KPI, streak disiplin, dan kolaborasi divisi secara real-time.",
      "companyName": "Nama Perusahaan",
      "companyNamePlaceholder": "Contoh: PT Maju Bersama",
      "ownerName": "Nama Lengkap Pemilik & Pimpinan",
      "ownerNamePlaceholder": "Contoh: Budi Rahardjo",
      "phoneNumber": "Nomor Telepon atau WhatsApp Resmi",
      "phoneNumberPlaceholder": "Contoh: 081234567890",
      "numberOfPlayers": "Jumlah Kursi Karyawan Awal",
      "numberOfPlayersPlaceholder": "Contoh: 25",
      "subscription": "Durasi Langganan",
      "companyLogo": "Logo Perusahaan",
      "email": "Email Resmi Perusahaan",
      "emailPlaceholder": "Contoh: founder@perusahaan.com",
      "password": "Buat Kata Sandi",
      "passwordPlaceholder": "Minimal 6 karakter",
      "confirmPassword": "Ulangi Kata Sandi",
      "confirmPasswordPlaceholder": "Masukkan ulang kata sandi",
      "registerBtn": "Daftarkan Workspace Perusahaan",
      "alreadyRegistered": "Sudah memiliki akun perusahaan?",
      "signIn": "Masuk ke Gamiteam",
      "success": "Pendaftaran Berhasil!",
      "successSub": "Workspace perusahaan Anda telah dibuat. Silakan login untuk memulai platform.",
      "passwordMismatch": "Kata sandi tidak cocok.",
      "plansBenefit": "Fasilitas Termasuk dalam Akun Enterprise",
      "benefit1": "Mesin Quest & SOP penuh dengan ekonomi XP & Gold",
      "benefit2": "Papan Peringkat Antar Divisi & Boss Raid Kuartalan",
      "benefit3": "Wawasan Strategis Gemini AI & Radar Deteksi Turnover",
      "monthUnit": "Bulan",
      "monthsUnit": "Bulan"
    },
    "common": {
      "search": "Cari...",
      "filter": "Saring",
      "all": "Semua",
      "save": "Simpan Perubahan",
      "saving": "Menyimpan...",
      "cancel": "Batal",
      "refresh": "Segarkan",
      "create": "Tambah",
      "delete": "Hapus",
      "deleted": "Terhapus!",
      "edit": "Ubah",
      "view": "Lihat",
      "back": "Kembali",
      "close": "Tutup",
      "approve": "Setujui",
      "reject": "Tolak",
      "status": "Status",
      "actions": "Aksi",
      "date": "Tanggal",
      "name": "Nama",
      "photo": "Foto Profil",
      "role": "Peran Akses",
      "joinedSince": "Terdaftar Sejak",
      "description": "Deskripsi",
      "success": "Berhasil",
      "error": "Gagal",
      "loading": "Memuat data...",
      "noData": "Tidak ada data ditemukan.",
      "active": "Aktif",
      "inactive": "Tidak Aktif",
      "pending": "Menunggu",
      "approved": "Disetujui",
      "rejected": "Ditolak",
      "language": "Bahasa",
      "selectLanguage": "Pilih Bahasa",
      "submit": "Kirim Data",
      "update": "Perbarui Data",
      "confirm": "Apakah Anda yakin?",
      "confirmDelete": "Data yang dihapus tidak dapat dikembalikan!",
      "warning": "Peringatan",
      "showing": "Menampilkan",
      "to": "sampai",
      "of": "dari",
      "entries": "entri",
      "previous": "Sebelumnya",
      "prev": "Sebelumnya",
      "next": "Selanjutnya",
      "category": "Kategori",
      "gold": "Gold",
      "no": "No",
      "processing": "Memproses...",
      "reset": "Atur Ulang"
    },
    "aiModal": {
      "title": "Arsitek Misi Gemini AI",
      "subtitle": "Otomatisasi pembuatan Misi KPI, aturan SOP, dan poin reward dengan bantuan Gemini AI",
      "departmentLabel": "Fokus Departemen & Skuad Target",
      "deptGeneral": "Umum & Seluruh Perusahaan",
      "deptSales": "Penjualan & Pengembangan Bisnis",
      "deptTech": "Rekayasa Perangkat Lunak, TI & DevOps",
      "deptMarketing": "Pemasaran & Kreatif",
      "deptOps": "Layanan Pelanggan & Operasional",
      "deptHr": "SDM, Keuangan & Administrasi",
      "promptLabel": "Deskripsikan Target atau Tantangan Tim Anda",
      "promptPlaceholder": "Contoh: Tingkatkan kecepatan closing sales B2B, pastikan update CRM sebelum jam 5 sore, dan percepat review PR kode mingguan...",
      "quickPromptsLabel": "Ide Cepat:",
      "generateBtn": "Buat Rekomendasi Quest dengan Gemini AI",
      "generatingBtn": "Gemini AI Sedang Merancang Quest...",
      "selectHelp": "Pilih quest yang ingin langsung ditambahkan ke daftar aturan:",
      "selectAll": "Pilih Semua",
      "deselectAll": "Batal Pilih Semua",
      "regenerate": "Generate Ulang",
      "selectedCount": "{count} quest dipilih",
      "cancelBtn": "Batal",
      "deployBtn": "Tambahkan {count} Quest Sekarang",
      "deployingBtn": "Menyimpan ke Database...",
      "dailyBadge": "Misi Harian",
      "oneTimeBadge": "Sekali Selesai",
      "evidenceRequired": "Wajib Bukti",
      "recommendedPenaltyLabel": "Konsekuensi Jika Gagal:",
      "reasoningLabel": "Rasional Desain KPI:"
    },
    "profile": {
      "title": "Profil Akun",
      "subtitle": "Kelola informasi profil pribadi, kredensial keamanan, dan identitas ruang kerja Anda.",
      "editTitle": "Ubah Profil Akun",
      "editSubtitle": "Perbarui informasi pribadi, foto profil, dan rincian kontak Anda.",
      "passwordTitle": "Ubah Kata Sandi Akun",
      "passwordSubtitle": "Amankan akun Anda dengan memperbarui kata sandi masuk.",
      "resetPasswordTitle": "Ubah Kata Sandi Akun",
      "resetPasswordSubtitle": "Amankan akun Anda dengan memperbarui kata sandi masuk.",
      "fullName": "Nama Lengkap",
      "userName": "Nama Lengkap",
      "fullNamePlaceholder": "Masukkan nama lengkap",
      "email": "Alamat Email",
      "emailAddress": "Alamat Email",
      "emailPlaceholder": "Masukkan alamat email",
      "phone": "Nomor Telepon atau WhatsApp",
      "phoneNumber": "Nomor Telepon atau WhatsApp",
      "phonePlaceholder": "Masukkan nomor telepon",
      "birthDate": "Tanggal Lahir",
      "position": "Jabatan",
      "positionPlaceholder": "Masukkan jabatan",
      "photo": "Foto Profil",
      "changePhoto": "Unggah Foto Baru",
      "currentPhoto": "Foto Saat Ini",
      "changePasswordBtn": "Ubah Kata Sandi",
      "editProfileBtn": "Ubah Profil",
      "updateData": "Perbarui Profil",
      "updatedSuccess": "Profil berhasil diperbarui.",
      "currentPassword": "Kata Sandi Saat Ini",
      "currentPasswordPlaceholder": "Masukkan kata sandi saat ini",
      "newPassword": "Kata Sandi Baru",
      "newPasswordPlaceholder": "Masukkan kata sandi baru (min. 6 karakter)",
      "confirmPassword": "Konfirmasi Kata Sandi Baru",
      "confirmPasswordPlaceholder": "Masukkan ulang kata sandi baru",
      "confirmNewPassword": "Konfirmasi Kata Sandi Baru",
      "confirmNewPasswordPlaceholder": "Masukkan ulang kata sandi baru",
      "hidePassword": "Sembunyikan kata sandi",
      "showPassword": "Tampilkan kata sandi",
      "passwordMismatch": "Kata sandi baru dan konfirmasi tidak cocok.",
      "savePasswordBtn": "Perbarui Kata Sandi",
      "updatePassword": "Perbarui Kata Sandi",
      "passwordUpdatedSuccess": "Kata sandi berhasil diperbarui."
    },
    "studio": {
      "title": "Studio Perancang Kinerja & SOP Misi",
      "subtitle": "Ubah sasaran bisnis dan prosedur operasional menjadi misi harian yang terukur, target sprint tim, dan insentif yang adil.",
      "badgeMaker": "STUDIO KINERJA GAME MAKER",
      "badgeAi": "Engine Anti-Kecurangan Gemini AI",
      "badgeSop": "Konversi Cepat SOP menjadi Misi",
      "newQuestBtn": "+ Buat Misi Baru",
      "gameSettingsBtn": "Pengaturan Game & AI",
      "marketplaceBtn": "Katalog Blueprint Realm",
      "tabArchitect": "Arsitek Misi & SOP AI",
      "tabSimulator": "Simulator Layar HP Player",
      "tabEconomy": "Kalkulator Budget & Insentif",
      "tabAntiCheat": "Antrean Verifikasi Bukti",
      "architectTitle": "Generator Misi Gamifikasi & SOP Cerdas",
      "architectDesc": "Tulis tujuan bisnis atau tempel SOP kerja Anda. Gemini AI akan merumuskan misi harian, frekuensi, ceklis kendali mutu mandiri (QA), dan bobot reward secara otomatis.",
      "targetGoalLabel": "Tujuan Bisnis & Sasaran SOP",
      "targetGoalPlaceholder": "Contoh: Sales B2B Follow-up & Closing: Minimal 5 follow-up klien harian dan 2 demo mingguan",
      "divisionLabel": "Target Skuad & Divisi",
      "cadenceLabel": "Frekuensi & Ritme Misi",
      "cadenceDaily": "Misi Rutin Harian (SOP Habit)",
      "cadenceWeekly": "Sprint Mingguan (Milestone)",
      "cadenceQuarterly": "Target Kuartal (Boss Raid)",
      "rewardGoldLabel": "Hadiah Gold",
      "rewardXpLabel": "Hadiah XP",
      "cashEquivalent": "Setara",
      "generateAiBtn": "Rancang Formula dengan Gemini AI",
      "deployQuestBtn": "Rilis Misi ke Realm Karyawan",
      "checklistTitle": "Ceklis Kendali Mutu Mandiri (Self-Checking QA)",
      "checklistDesc": "Karyawan wajib mencentang poin-poin ini sebelum mengunggah bukti demi menjaga standar hasil kerja.",
      "evidenceStandardLabel": "Standar Bukti & Pedoman Validasi",
      "evidenceStandardPlaceholder": "Contoh: Unggah MoU & screenshot tanda tangan digital & link pull request Git yang telah dimerge",
      "consequenceLabel": "Konsekuensi & Penalti Melebihi Batas Waktu",
      "consequenceDesc": "Potong -50 XP jika terlewat tanpa alasan izin/medis resmi.",
      "presetsTitle": "Preset SOP Industri Teruji",
      "presetsSub": "1-Klik terapkan formula kinerja siap pakai",
      "usePreset": "Gunakan Formula",
      "simulatorTitle": "Simulator Tampilan Mobile Player",
      "simulatorDesc": "Lihat simulasi visual persis bagaimana misi, reward, dan ceklis ini akan tampil di smartphone karyawan.",
      "deviceHeader": "Papan Misi Player",
      "activeMissionBadge": "MISI AKTIF",
      "tapToSubmit": "Ketuk untuk Selesaikan Misi",
      "viewGuidelines": "Lihat Panduan SOP",
      "economyTitle": "Kalkulator Ekonomi & Liabilitas Insentif",
      "economyDesc": "Simulasikan perkiraan Gold bulanan, nilai pencairan Rupiah, dan pastikan tidak melampaui alokasi budget perusahaan.",
      "estMonthlyGold": "Est. Gold Bulanan Beredar",
      "estLiability": "Liabilitas Nilai Reward (Rp)",
      "budgetSafety": "Status Keamanan Budget",
      "budgetSafe": "Sehat & Sesuai Kuota Budget Perusahaan",
      "budgetWarning": "Peringatan: Proyeksi reward mendekati ambang batas kuota",
      "dailyCap": "Batas Maksimal Gold Harian & Karyawan",
      "antiCheatTitle": "Antrean Verifikasi Bukti Gemini AI Vision",
      "antiCheatDesc": "AI menganalisis gambar bukti (ekstraksi teks OCR, stempel waktu metadata, dan pengecekan hash duplikat).",
      "batchApprove": "Batch Approve Terverifikasi",
      "allCleanTitle": "Semua Bukti Telah Diverifikasi!",
      "allCleanSub": "Tidak ada antrean tertunda. Jam kerja manajemen berhasil dihemat.",
      "ocrConfidence": "Tingkat Keyakinan",
      "antiCheatChecks": "Pemeriksaan Integritas",
      "hashUnique": "Hash Unik (Bukan Foto Duplikat)",
      "hashDupe": "Potensi Foto Duplikat",
      "approveBtn": "Setujui",
      "rejectBtn": "Tolak",
      "addChecklistBtn": "+ Tambah Poin",
      "aiFallbackCheck1": "Memastikan hasil kerja memenuhi standar kualitas SOP",
      "aiFallbackCheck2": "Memvalidasi hasil bersama penanggung jawab divisi",
      "aiFallbackCheck3": "Melampirkan tangkapan layar bertanda waktu atau tautan dokumen resmi",
      "aiFallbackEvidence": "Lampirkan bukti penyelesaian terverifikasi untuk: {goal}. Sertakan tangkapan layar jelas atau tautan catatan sistem.",
      "aiFallbackName": "Eksekusi KPI: {goal}",
      "aiHelperText": "Gemini AI menganalisis sasaran KPI Anda dan merekomendasikan bobot hadiah serta daftar periksa mutu yang seimbang.",
      "approveProofError": "Gagal menyetujui bukti penyelesaian misi.",
      "awaitingManualReview": "Menunggu verifikasi manual oleh Game Maker.",
      "batchApproveSuccess": "Persetujuan Massal Selesai",
      "batchApproveSuccessDesc": "{count} pengajuan bukti berakurasi tinggi (>= 85% kecocokan AI) berhasil disetujui sekaligus.",
      "checklistItemPlaceholder": "Contoh: Melampirkan dokumen klien resmi atau tautan PR yang disetujui",
      "closePreview": "Tutup Pratinjau",
      "colEmployee": "Karyawan",
      "colOcrVision": "Pemeriksaan OCR & AI",
      "colQuestSop": "Misi & SOP",
      "colUploadedProof": "Bukti Unggahan",
      "consequenceAutoDesc": "Pengurangan akuntabilitas atas keterlambatan atau ketidaksesuaian pelaksanaan SOP pada: {name}",
      "consequenceAutoName": "Ketidakpatuhan SOP: {name}",
      "dailyCapNotice": "Setiap karyawan dibatasi maksimal {cap} Gold per hari sesuai pengaturan pelindung ekonomi ruang kerja Anda.",
      "defaultDivisionName": "Divisi Umum",
      "defaultPlayerName": "Anggota Tim",
      "defaultQuestDescription": "Selesaikan misi kerja sesuai standar operasional prosedur tim.",
      "defaultQuestSubmission": "Pengajuan Misi",
      "formulaGeneratedDesc": "Judul misi, bobot insentif, dan daftar periksa mutu mandiri telah diperbarui.",
      "formulaGeneratedTitle": "Formula Misi Berhasil Dirumuskan",
      "goalEmptyDesc": "Silakan tuliskan sasaran KPI bisnis atau tujuan SOP terlebih dahulu.",
      "goalEmptyTitle": "Sasaran Belum Diisi",
      "goldConversionLabel": "Nilai Referensi 1 Gold (Rupiah):",
      "keywordsLabel": "Kata Kunci Terdeteksi",
      "manualReviewBadge": "Tinjauan Manual",
      "matchSuffix": "Cocok",
      "membersUnit": "Anggota",
      "monthlyProjectionTitle": "Proyeksi Alokasi Insentif Bulanan",
      "presetApplied": "Formula Prasetel Diterapkan",
      "proofApprovedToast": "Bukti \"{name}\" disetujui (+{gold} Gold)",
      "proofRejectedDesc": "Alasan tercatat: \"{reason}\". Karyawan dapat mengunggah ulang bukti yang diperbaiki.",
      "proofRejectedTitle": "Bukti Pengajuan Ditolak",
      "questDeployErrorDesc": "Terjadi kesalahan saat menerbitkan misi ini ke ruang kerja Anda.",
      "questDeployFailed": "Gagal Menerbitkan Misi",
      "questDeployedDesc": "Misi \"{name}\" kini aktif di aplikasi karyawan ruang kerja Anda.",
      "questDeployedTitle": "Misi Berhasil Diterbitkan",
      "questNameRequired": "Judul Misi Wajib Diisi",
      "questTitleLabel": "Judul Misi & Target Kerja",
      "questTitlePlaceholder": "Contoh: Penjangkauan Klien B2B Harian & Penutupan Kontrak",
      "rejectProofBtn": "Tolak Bukti",
      "rejectProofError": "Gagal menolak pengajuan bukti misi.",
      "rejectProofTitle": "Tolak Bukti Penyelesaian Misi",
      "rejectReasonDefault": "Bukti foto kurang jelas atau belum memenuhi kriteria verifikasi SOP yang ditetapkan.",
      "rejectReasonLabel": "Berikan alasan penolakan yang jelas agar karyawan dapat memperbaiki unggahan bukti:",
      "sampleEvidenceGuide": "Unggah bukti penyelesaian tugas yang jelas sesuai standar operasional tim.",
      "sampleQuestTitle": "Contoh Misi KPI Operasional",
      "simCompletionRateLabel": "Estimasi Tingkat Penyelesaian Misi Tim:",
      "simTeamSizeLabel": "Jumlah Karyawan Aktif Berpartisipasi:",
      "simulatorChecklistLabel": "Daftar Periksa Mutu Mandiri:",
      "simulatorOnline": "PRATINJAU AKTIF",
      "sopEvidenceModalTitle": "Bukti Pelaksanaan SOP",
      "timestampPrefix": "Dikirim: {time}",
      "timestampValid": "Waktu unggah terverifikasi",
      "xpHelperText": "Meningkatkan progresi level dan peringkat kontribusi karyawan",
      "zoomBtn": "Perbesar"
    },
    "marketplace": {
      "badgeVirtual": "RUANG KERJA VIRTUAL 3D",
      "badgeInstantPay": "Pembayaran Instan (QRIS & VA)",
      "badgeHris": "Terintegrasi HRIS Korporat",
      "title": "Katalog Template & Ruang Kolaborasi Tim",
      "subtitle": "Solusi modern meningkatkan keterlibatan kerja dan produktivitas tim. Pasang konfigurasi Game Realm siap pakai—lengkap dengan misi target SOP harian, tantangan target tim terpadu, sistem reward poin, dan leaderboard kinerja.",
      "creatorStudioBtn": "Studio Kreator & Blueprint Forge",
      "tabCatalog": "Katalog Galaksi Realm",
      "tabInstalled": "Realm Terpasang di Tim",
      "activeRealmTitle": "Universe Aktif Tim:",
      "activeRealmDeployed": "Dideploy pada {date} • Seluruh karyawan kini mengerjakan quest dari realm ini",
      "manageQuestsBtn": "Kelola Misi Tim",
      "searchPlaceholder": "Cari realm, industri, atau KPI...",
      "noRealmsFound": "Belum ada game setting yang cocok",
      "noRealmsDesc": "Coba ubah kata kunci pencarian atau pilih kategori lain.",
      "deployBtn": "Terapkan Cetak Biru",
      "freeLicense": "CETAK BIRU GRATIS",
      "orderNumber": "NO. PESANAN",
      "purchasedRealm": "REALM YANG DIBELI",
      "totalPrice": "TOTAL HARGA",
      "paymentStatus": "STATUS PEMBAYARAN",
      "paidDate": "TANGGAL LUNAS",
      "action": "AKSI",
      "noTransactions": "Belum Ada Transaksi Realm",
      "noTransactionsDesc": "Belum ada riwayat transaksi pembelian template realm.",
      "statusPaid": "LUNAS & TERVERIFIKASI",
      "statusPending": "MENUNGGU PEMBAYARAN",
      "payNow": "Bayar Sekarang",
      "completed": "Tuntas",
      "previewTitle": "Detail Blueprint Game Setting",
      "licensePrice": "Lisensi Setting:",
      "loreTitle": "Lore & Narasi Dunia Game",
      "worldZonesTitle": "Struktur Zona Open-World (Peta Progresi Tim)",
      "presetQuestsTitle": "Preset Misi & Mekanik Damage Boss",
      "bossRaidTitle": "Tantangan Target Kolaborasi Tim",
      "bossRaidSubtitle": "Target kuartal tim dipersonifikasikan menjadi monster raksasa",
      "closeBtn": "Tutup",
      "deployNowBtn": "Deploy Setting Ini Sekarang",
      "buyAndDeployBtn": "Lanjut Beli & Deploy",
      "checkoutTitle": "Pembayaran Digital Otomatis",
      "checkoutSubtitle": "Lisensi Template Game Setting Premium",
      "paymentDesc": "Pembayaran otomatis diverifikasi secara real-time via QRIS, Virtual Account (BCA, Mandiri, BRI, BNI), atau Dompet Digital secara aman dan terenkripsi.",
      "openPaymentUrl": "Buka Laman Pembayaran Aman",
      "simulatePayment": "Simulasi & Verifikasi Pembayaran Lunas",
      "licensedGateway": "Gerbang Pembayaran Resmi Terverifikasi",
      "cancelBtn": "Batal",
      "studioTitle": "Enterprise Blueprint Forge: Rancang Paket Blueprint Kinerja",
      "studioSubtitle": "Rancang formula kinerja terpadu lengkap dengan misi SOP harian, sprint mingguan, dan target kolaboratif Boss Raid.",
      "presetSelectTitle": "Preset Cepat 1-Klik Industri:",
      "presetSales": "Akselerasi Penjualan B2B Korporat",
      "presetDevOps": "Rekayasa Tanpa Cacat & Keandalan Sistem",
      "presetSupport": "Juara Kepuasan Layanan Pelanggan",
      "presetRetail": "Keunggulan Operasional Ritel & Cabang",
      "presetOnboarding": "Akselerasi Orientasi Karyawan Baru",
      "aiPromptLabel": "AI Formula Architect (Prompt ke Questline):",
      "aiPromptPlaceholder": "Contoh: Tingkatkan closing sales 30% dan verifikasi bukti kontrak proposal nasabah...",
      "aiGenerateBtn": "Hasilkan Formula AI",
      "blueprintTitleLabel": "Judul Blueprint Kinerja & SOP",
      "blueprintTitlePlaceholder": "Contoh: SaaS B2B Revenue Hunter Framework & Zero-Defect DevOps Blueprint",
      "categoryLabel": "Kategori Departemen & Guild",
      "themeLabel": "Model Eksekusi & Tema",
      "descLabel": "Deskripsi & Standar Dampak Bisnis",
      "descPlaceholder": "Jelaskan formula kinerja ini: target metrik apa yang diakselerasi dan bagaimana mekanismenya membimbing tim...",
      "questsTableTitle": "Penyusun Rangkaian Misi Terpadu",
      "questNameCol": "Nama Misi & Target SOP",
      "questTypeCol": "Ritme",
      "questGoldCol": "Gold",
      "questXpCol": "XP",
      "questBossDmgCol": "Dampak Target",
      "addQuestBtn": "+ Tambah Misi",
      "bossRaidSectionTitle": "Target Sasaran Kolektif Divisi (Boss Raid Target)",
      "bossNameLabel": "Nama Monster & Target Boss Titan",
      "bossNamePlaceholder": "Contoh: Pencapaian Omset Rp 1.5 Miliar Kuartal Ini",
      "bossHpLabel": "Target HP Pool",
      "bossRewardPoolLabel": "Reward Gold Pool Bersama",
      "priceLabel": "Harga Lisensi Blueprint (Rp)",
      "priceHelp": "0 untuk gratis & open source blueprint",
      "deployDirectBtn": "Pasang Langsung ke Workspace Tim (1-Click)",
      "publishMarketplaceBtn": "Terbitkan ke Marketplace Saja",
      "deployDirectSuccess": "Blueprint Berhasil Dideploy ke Workspace!",
      "deployDirectSuccessMsg": "Seluruh misi dan Boss Raid tim telah aktif di workspace Anda.",
      "publishSuccess": "Game Setting Berhasil Dipublikasikan!",
      "publishSuccessMsg": "Setting Anda kini tersedia di marketplace untuk digunakan oleh Game Maker lainnya.",
      "activeInWorkspaceBadge": "Aktif di Ruang Kerja",
      "aiHelperText": "Gemini AI menyusun misi KPI, bobot Gold, dan target Boss Raid berdasarkan sasaran Anda.",
      "archivedStatus": "Diarsipkan",
      "catAll": "Semua Kategori",
      "catCulture": "Budaya Kerja & Orientasi",
      "catCultureTeam": "SDM & Budaya Kerja",
      "catEngineering": "Rekayasa & DevOps",
      "catEngineeringSquad": "Rekayasa & DevOps",
      "catOperations": "Ritel & Operasional",
      "catOperationsTeam": "Operasional & Logistik",
      "catSales": "Penjualan & Pendapatan",
      "catSalesGuild": "Penjualan & Pendapatan",
      "catSupport": "Layanan Pelanggan",
      "catSupportTeam": "Pengalaman Pelanggan",
      "categoryAndThemeMeta": "Kategori: {category} • Tema: {theme}",
      "colCategoryTheme": "Kategori & Tema",
      "colInstalledDate": "Tanggal Dipasang",
      "colRealmSetting": "Nama Cetak Biru",
      "defaultBossName": "Target Tim Kuartalan",
      "generalCat": "Operasional Umum",
      "loadingCatalog": "Memuat katalog cetak biru...",
      "newQuestDefaultTitle": "Selesaikan Target Kerja Harian Terverifikasi",
      "noInstalledDesc": "Terapkan cetak biru dari Katalog Marketplace atau rancang menggunakan AI untuk mengisi ruang kerja Anda.",
      "noInstalledTitle": "Belum Ada Cetak Biru Terpasang",
      "orderIdLabel": "Referensi Pesanan",
      "purchaseHistoryTitle": "Riwayat Akuisisi & Lisensi Cetak Biru",
      "purchasedBadge": "Berlisensi",
      "questRowPlaceholder": "Masukkan judul misi KPI terukur...",
      "questsCountUnit": "Misi",
      "reactivateBtn": "Terapkan Ulang",
      "realmPrefix": "Cetak Biru:",
      "removeQuestTitle": "Hapus baris misi",
      "rewardPoolBadge": "Total Hadiah",
      "standardTheme": "Standar Korporat",
      "teamsUnit": "ruang kerja",
      "themeAgile": "Eksekusi Sprint Gesit",
      "themeCorporate": "Tata Kelola KPI Korporat",
      "themeDiscipline": "Keunggulan Operasional & Mutu",
      "themeRaid": "Kolaborasi Target Tim",
      "typeDaily": "Harian",
      "typeSprint": "Sprint",
      "typeWeekly": "Mingguan",
      "unrated": "Baru"
    },
    "footer": {
      "tagline": "Platform Gamifikasi Kinerja Tim Perusahaan",
      "editionBadge": "Edisi Korporat v2.5"
    }
  }
};

const state = Vue.observable({
  locale: localStorage.getItem('gamiteam_locale') || 'id',
});

export const i18n = {
  get locale() {
    return state.locale;
  },
  setLocale(newLocale) {
    if (messages[newLocale]) {
      state.locale = newLocale;
      localStorage.setItem('gamiteam_locale', newLocale);
      if (typeof document !== 'undefined' && document.documentElement) {
        document.documentElement.setAttribute('lang', newLocale);
      }
      setTimeout(() => {
        applyDomTranslation(newLocale);
      }, 20);
    }
  },
  t(path, params) {
    if (!path) return '';
    const keys = path.split('.');
    let current = messages[state.locale];
    let resolved = null;
    for (const key of keys) {
      if (current && current[key] !== undefined) {
        current = current[key];
      } else {
        current = null;
        break;
      }
    }
    if (current !== null && current !== undefined) {
      resolved = current;
    } else {
      let fallback = messages.en;
      for (const fKey of keys) {
        if (fallback && fallback[fKey] !== undefined) {
          fallback = fallback[fKey];
        } else {
          return path;
        }
      }
      resolved = fallback;
    }
    if (typeof resolved === 'string' && params && typeof params === 'object') {
      return resolved.replace(/\{(\w+)\}/g, (match, pKey) => {
        return params[pKey] !== undefined && params[pKey] !== null ? String(params[pKey]) : match;
      });
    }
    return resolved;
  },
};

export default {
  install(VueInstance) {
    if (typeof document !== 'undefined' && document.documentElement) {
      document.documentElement.setAttribute('lang', state.locale);
    }
    VueInstance.prototype.$t = i18n.t;
    VueInstance.prototype.$setLocale = i18n.setLocale;
    VueInstance.prototype.$i18n = {
      get locale() {
        return state.locale;
      },
      set locale(val) {
        i18n.setLocale(val);
      },
    };
    Object.defineProperty(VueInstance.prototype, '$currentLocale', {
      get() {
        return state.locale;
      },
    });
    initDomTranslator(() => state.locale);
  },
};
